var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _g2, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _g3, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _g4, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 493,
    height: 396,
    viewBox: "0 0 493 396",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_812_1630)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M355.321 386.904C376.559 386.904 393.776 376.445 393.776 363.543C393.776 350.641 376.559 340.182 355.321 340.182C334.083 340.182 316.866 350.641 316.866 363.543C316.866 376.445 334.083 386.904 355.321 386.904Z",
    fill: "url(#paint0_radial_812_1630)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.411 334.168H309.457V342.332L309.474 343.202C309.474 343.324 309.457 342.576 309.457 342.706C309.457 357.668 330.267 369.793 355.938 369.793C381.609 369.793 402.42 357.668 402.42 342.706C402.42 342.584 402.402 342.454 402.402 342.332H402.42V334.168H402.411Z",
    fill: "url(#paint1_linear_812_1630)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.938 361.446C381.609 361.446 402.42 349.319 402.42 334.359C402.42 319.4 381.609 307.273 355.938 307.273C330.267 307.273 309.457 319.4 309.457 334.359C309.457 349.319 330.267 361.446 355.938 361.446Z",
    fill: "url(#paint2_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M355.938 361.341C330.545 361.341 309.926 349.469 309.483 334.733C309.483 334.899 309.465 335.056 309.465 335.221C309.465 350.183 330.276 362.307 355.947 362.307C381.618 362.307 402.428 350.183 402.428 335.221C402.428 335.056 402.411 334.899 402.411 334.733C401.968 349.469 381.349 361.341 355.956 361.341H355.938Z",
    fill: "url(#paint3_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M140.523 386.904C161.761 386.904 178.978 376.445 178.978 363.543C178.978 350.641 161.761 340.182 140.523 340.182C119.285 340.182 102.068 350.641 102.068 363.543C102.068 376.445 119.285 386.904 140.523 386.904Z",
    fill: "url(#paint4_radial_812_1630)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.613 334.168H94.6589V342.332L94.6763 343.202C94.6763 343.324 94.6589 342.576 94.6589 342.706C94.6589 357.668 115.469 369.793 141.14 369.793C166.812 369.793 187.622 357.668 187.622 342.706C187.622 342.584 187.605 342.454 187.605 342.332H187.622V334.168H187.613Z",
    fill: "url(#paint5_linear_812_1630)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 361.446C166.812 361.446 187.622 349.319 187.622 334.359C187.622 319.4 166.812 307.273 141.14 307.273C115.469 307.273 94.6589 319.4 94.6589 334.359C94.6589 349.319 115.469 361.446 141.14 361.446Z",
    fill: "url(#paint6_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M141.141 361.341C115.747 361.341 95.1286 349.469 94.6851 334.733C94.6851 334.899 94.6677 335.056 94.6677 335.221C94.6677 350.183 115.478 362.307 141.149 362.307C166.821 362.307 187.631 350.183 187.631 335.221C187.631 335.056 187.613 334.899 187.613 334.733C187.17 349.469 166.551 361.341 141.158 361.341H141.141Z",
    fill: "url(#paint7_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M445.91 242.42C467.148 242.42 484.365 231.961 484.365 219.059C484.365 206.157 467.148 195.698 445.91 195.698C424.672 195.698 407.455 206.157 407.455 219.059C407.455 231.961 424.672 242.42 445.91 242.42Z",
    fill: "url(#paint8_radial_812_1630)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M493 189.683H400.046V197.848L400.063 198.718C400.063 198.84 400.046 198.091 400.046 198.222C400.046 213.184 420.856 225.308 446.527 225.308C472.199 225.308 493.009 213.184 493.009 198.222C493.009 198.1 492.991 197.97 492.991 197.848H493.009V189.683H493Z",
    fill: "url(#paint9_linear_812_1630)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M446.518 216.961C472.189 216.961 493 204.834 493 189.875C493 174.916 472.189 162.788 446.518 162.788C420.847 162.788 400.037 174.916 400.037 189.875C400.037 204.834 420.847 216.961 446.518 216.961Z",
    fill: "url(#paint10_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M446.519 216.857C421.125 216.857 400.507 204.985 400.063 190.249C400.063 190.415 400.046 190.571 400.046 190.737C400.046 205.699 420.856 217.823 446.527 217.823C472.199 217.823 493.009 205.699 493.009 190.737C493.009 190.571 492.991 190.415 492.991 190.249C492.548 204.985 471.929 216.857 446.536 216.857H446.519Z",
    fill: "url(#paint11_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M49.9339 242.42C71.1719 242.42 88.3888 231.961 88.3888 219.059C88.3888 206.157 71.1719 195.698 49.9339 195.698C28.6958 195.698 11.479 206.157 11.479 219.059C11.479 231.961 28.6958 242.42 49.9339 242.42Z",
    fill: "url(#paint12_radial_812_1630)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0329 189.683H4.06982V197.848L4.08722 198.718C4.08722 198.84 4.06982 198.091 4.06982 198.222C4.06982 213.184 24.88 225.308 50.5514 225.308C76.2227 225.308 97.0329 213.184 97.0329 198.222C97.0329 198.1 97.0155 197.97 97.0155 197.848H97.0329V189.683Z",
    fill: "url(#paint13_linear_812_1630)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5514 216.961C76.2224 216.961 97.0329 204.834 97.0329 189.875C97.0329 174.916 76.2224 162.788 50.5514 162.788C24.8803 162.788 4.06982 174.916 4.06982 189.875C4.06982 204.834 24.8803 216.961 50.5514 216.961Z",
    fill: "url(#paint14_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M50.5515 216.857C25.1584 216.857 4.53952 204.985 4.09601 190.249C4.09601 190.415 4.07861 190.571 4.07861 190.737C4.07861 205.699 24.8888 217.823 50.5602 217.823C76.2315 217.823 97.0417 205.699 97.0417 190.737C97.0417 190.571 97.0243 190.415 97.0243 190.249C96.5808 204.985 75.962 216.857 50.5689 216.857H50.5515Z",
    fill: "url(#paint15_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M140.523 119.992C161.761 119.992 178.978 109.532 178.978 96.6304C178.978 83.7283 161.761 73.2692 140.523 73.2692C119.285 73.2692 102.068 83.7283 102.068 96.6304C102.068 109.532 119.285 119.992 140.523 119.992Z",
    fill: "url(#paint16_radial_812_1630)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M187.613 67.2461H94.6589V75.4103L94.6763 76.2807C94.6763 76.4026 94.6589 75.654 94.6589 75.7846C94.6589 90.7466 115.469 102.871 141.14 102.871C166.812 102.871 187.622 90.7466 187.622 75.7846C187.622 75.6628 187.605 75.5322 187.605 75.4103H187.622V67.2461H187.613Z",
    fill: "url(#paint17_linear_812_1630)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 94.524C166.812 94.524 187.622 82.397 187.622 67.4376C187.622 52.4782 166.812 40.3512 141.14 40.3512C115.469 40.3512 94.6589 52.4782 94.6589 67.4376C94.6589 82.397 115.469 94.524 141.14 94.524Z",
    fill: "url(#paint18_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M141.141 94.4196C115.747 94.4196 95.1286 82.5475 94.6851 67.8119C94.6851 67.9772 94.6677 68.1339 94.6677 68.2993C94.6677 83.2612 115.478 95.3857 141.149 95.3857C166.821 95.3857 187.631 83.2612 187.631 68.2993C187.631 68.1339 187.613 67.9772 187.613 67.8119C187.17 82.5475 166.551 94.4196 141.158 94.4196H141.141Z",
    fill: "url(#paint19_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M355.321 119.992C376.559 119.992 393.776 109.532 393.776 96.6304C393.776 83.7283 376.559 73.2692 355.321 73.2692C334.083 73.2692 316.866 83.7283 316.866 96.6304C316.866 109.532 334.083 119.992 355.321 119.992Z",
    fill: "url(#paint20_radial_812_1630)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M402.411 67.2461H309.457V75.4103L309.474 76.2807C309.474 76.4026 309.457 75.654 309.457 75.7846C309.457 90.7466 330.267 102.871 355.938 102.871C381.609 102.871 402.42 90.7466 402.42 75.7846C402.42 75.6628 402.402 75.5322 402.402 75.4103H402.42V67.2461H402.411Z",
    fill: "url(#paint21_linear_812_1630)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M355.938 94.524C381.609 94.524 402.42 82.397 402.42 67.4376C402.42 52.4782 381.609 40.3512 355.938 40.3512C330.267 40.3512 309.457 52.4782 309.457 67.4376C309.457 82.397 330.267 94.524 355.938 94.524Z",
    fill: "url(#paint22_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M355.938 94.4196C330.545 94.4196 309.926 82.5475 309.483 67.8119C309.483 67.9772 309.465 68.1339 309.465 68.2993C309.465 83.2612 330.276 95.3857 355.947 95.3857C381.618 95.3857 402.428 83.2612 402.428 68.2993C402.428 68.1339 402.411 67.9772 402.411 67.8119C401.968 82.5475 381.349 94.4196 355.956 94.4196H355.938Z",
    fill: "url(#paint23_radial_812_1630)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.197 296.985C199.405 297.107 199.631 297.168 199.858 297.168C200.084 297.168 200.31 297.107 200.518 296.993L216.902 287.393C217.302 287.158 217.546 286.723 217.546 286.262C217.546 285.8 217.294 285.365 216.893 285.139L184.387 266.382L205.606 254.345C206.588 254.701 207.71 254.893 208.876 254.893C210.554 254.893 212.154 254.501 213.38 253.796C214.806 252.969 215.633 251.751 215.633 250.436C215.633 249.14 214.824 247.921 213.406 247.103C212.197 246.407 210.615 246.015 208.945 246.015C207.275 246.015 205.667 246.407 204.44 247.112C203.014 247.938 202.188 249.157 202.188 250.471C202.188 251.289 202.51 252.082 203.11 252.752L181.117 265.224C180.708 265.451 180.456 265.886 180.456 266.356C180.456 266.826 180.7 267.261 181.108 267.496L213.641 286.27L199.858 294.347L172.403 278.106C172.943 277.453 173.247 276.705 173.247 275.921C173.247 274.616 172.429 273.389 170.995 272.562C169.768 271.857 168.168 271.465 166.49 271.465C164.812 271.465 163.238 271.848 162.029 272.553C160.611 273.371 159.802 274.581 159.802 275.887C159.802 277.192 160.62 278.419 162.055 279.246C163.281 279.951 164.881 280.343 166.559 280.343C167.794 280.343 168.994 280.125 170.021 279.734L199.188 296.993L199.197 296.985ZM205.754 249.383C206.58 248.905 207.745 248.635 208.954 248.635C210.163 248.635 211.302 248.905 212.111 249.366C212.684 249.697 213.032 250.097 213.032 250.436C213.032 250.776 212.676 251.185 212.084 251.533C211.258 252.012 210.076 252.256 208.876 252.256C207.702 252.256 206.536 252.012 205.727 251.551C205.154 251.22 204.806 250.819 204.806 250.48C204.806 250.141 205.162 249.731 205.754 249.383ZM163.368 276.983C162.777 276.644 162.42 276.235 162.42 275.887C162.42 275.538 162.768 275.155 163.342 274.816C164.151 274.346 165.299 274.085 166.499 274.085C167.699 274.085 168.873 274.355 169.699 274.833C170.29 275.173 170.647 275.582 170.647 275.93C170.647 276.278 170.299 276.661 169.725 277.001C168.099 277.941 165.012 277.932 163.368 276.983Z",
    fill: "#45108A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M236.269 347.72L189.518 319.728L243.035 290.187C243.443 289.961 243.704 289.534 243.713 289.064C243.713 288.594 243.478 288.159 243.069 287.924L208.189 267.365L218.311 261.612C219.207 261.873 220.19 262.039 221.216 262.039C222.894 262.039 224.494 261.647 225.72 260.942C227.147 260.115 227.973 258.897 227.973 257.582C227.973 256.285 227.164 255.067 225.746 254.249C224.538 253.552 222.955 253.161 221.285 253.161C219.616 253.161 218.007 253.552 216.781 254.257C215.354 255.084 214.528 256.303 214.528 257.617C214.528 258.531 214.937 259.393 215.659 260.115L204.936 266.208C204.528 266.434 204.284 266.869 204.275 267.331C204.275 267.801 204.519 268.227 204.919 268.462L239.774 289.003L186.274 318.536C185.865 318.762 185.604 319.188 185.596 319.658C185.596 320.128 185.831 320.564 186.231 320.799L232.973 348.79L192.927 370.733L174.221 359.583L172.882 361.829L192.231 373.361C192.44 373.483 192.666 373.544 192.901 373.544C193.118 373.544 193.335 373.492 193.527 373.387L236.217 349.991C236.625 349.765 236.886 349.339 236.895 348.869C236.904 348.399 236.66 347.963 236.26 347.72H236.269ZM218.076 256.529C218.902 256.05 220.068 255.781 221.277 255.781C222.485 255.781 223.625 256.05 224.433 256.512C225.007 256.843 225.355 257.243 225.355 257.582C225.355 257.922 224.999 258.331 224.407 258.679C222.772 259.628 219.676 259.628 218.05 258.696C217.476 258.366 217.128 257.965 217.128 257.626C217.128 257.286 217.485 256.877 218.076 256.529Z",
    fill: "#45108A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M343.433 293.425L284.751 259.262C285.046 258.749 285.212 258.192 285.212 257.617C285.212 256.312 284.394 255.084 282.959 254.257C281.733 253.552 280.133 253.161 278.455 253.161C276.776 253.161 275.202 253.544 273.993 254.249C272.576 255.067 271.767 256.277 271.767 257.582C271.767 258.888 272.585 260.115 274.019 260.942C275.246 261.647 276.846 262.039 278.524 262.039C280.063 262.039 281.524 261.699 282.69 261.09L340.111 294.513L275.098 329.964C274.689 330.181 274.437 330.608 274.419 331.069C274.402 331.53 274.637 331.966 275.028 332.218L298.065 346.823L250.148 374.223C249.739 374.458 249.487 374.893 249.487 375.363C249.487 375.833 249.748 376.268 250.157 376.495L272.045 388.61C272.245 388.715 272.463 388.776 272.68 388.776C272.898 388.776 273.132 388.715 273.332 388.602L322.032 360.523L320.727 358.26L272.672 385.964L253.461 375.328L301.247 348.007C301.648 347.781 301.891 347.363 301.908 346.901C301.917 346.44 301.691 346.014 301.3 345.77L278.307 331.191L343.407 295.697C343.824 295.47 344.077 295.044 344.085 294.565C344.085 294.095 343.842 293.66 343.433 293.416V293.425ZM275.333 258.679C274.741 258.34 274.385 257.931 274.385 257.582C274.385 257.234 274.733 256.851 275.306 256.512C276.115 256.042 277.263 255.781 278.463 255.781C279.663 255.781 280.837 256.05 281.663 256.529C282.255 256.869 282.611 257.278 282.611 257.626C282.611 257.974 282.264 258.357 281.69 258.696C280.063 259.636 276.976 259.628 275.333 258.679Z",
    fill: "#45108A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M295.282 247.12C294.056 246.415 292.455 246.024 290.777 246.024C289.099 246.024 287.525 246.407 286.316 247.112C284.898 247.93 284.09 249.14 284.09 250.445C284.09 251.751 284.907 252.978 286.342 253.805C287.568 254.51 289.168 254.902 290.847 254.902C292.438 254.902 293.942 254.545 295.125 253.901L294.96 254.17L314.97 266.217C314.631 266.756 314.448 267.348 314.448 267.957C314.448 269.263 315.266 270.49 316.701 271.317C317.927 272.022 319.527 272.414 321.205 272.414C322.884 272.414 324.458 272.031 325.666 271.326C327.084 270.508 327.893 269.298 327.893 267.992C327.893 266.687 327.075 265.459 325.64 264.632C324.414 263.927 322.814 263.536 321.136 263.536C319.64 263.536 318.231 263.858 317.083 264.424L296.96 252.308C297.334 251.742 297.534 251.124 297.534 250.471C297.534 249.166 296.717 247.938 295.282 247.112V247.12ZM294.003 251.542C292.377 252.482 289.29 252.473 287.646 251.524C287.055 251.185 286.698 250.776 286.698 250.428C286.698 250.08 287.046 249.697 287.62 249.357C288.429 248.887 289.577 248.626 290.777 248.626C291.977 248.626 293.151 248.896 293.977 249.375C294.569 249.714 294.925 250.123 294.925 250.471C294.925 250.819 294.577 251.202 294.003 251.542ZM321.136 266.138C322.344 266.138 323.51 266.408 324.336 266.887C324.927 267.226 325.284 267.635 325.284 267.983C325.284 268.332 324.936 268.723 324.362 269.054C322.736 269.994 319.649 269.985 318.005 269.037C317.414 268.697 317.057 268.288 317.057 267.94C317.057 267.592 317.405 267.209 317.979 266.869C318.788 266.399 319.936 266.138 321.136 266.138Z",
    fill: "#45108A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M404.394 259.462C403.168 258.757 401.567 258.366 399.889 258.366C398.211 258.366 396.637 258.749 395.428 259.454C394.01 260.272 393.202 261.482 393.202 262.787C393.202 264.093 394.019 265.32 395.454 266.147C396.68 266.852 398.28 267.244 399.959 267.244C401.637 267.244 403.211 266.861 404.42 266.156C405.837 265.338 406.646 264.128 406.646 262.822C406.646 262.343 406.533 261.882 406.324 261.447L446.127 238.86L480.364 258.026L425.682 289.708C424.473 289.047 422.943 288.681 421.325 288.681C419.708 288.681 418.073 289.064 416.864 289.769C415.447 290.587 414.638 291.797 414.638 293.103C414.638 294.408 415.455 295.636 416.89 296.463C418.116 297.168 419.717 297.559 421.395 297.559C423.073 297.559 424.647 297.176 425.856 296.471C427.274 295.653 428.082 294.443 428.082 293.138C428.082 292.598 427.935 292.067 427.665 291.58L485.643 257.991L446.127 235.866L404.463 259.515C404.463 259.515 404.42 259.488 404.402 259.471L404.394 259.462ZM425.465 293.129C425.465 293.468 425.117 293.86 424.543 294.2C422.917 295.14 419.83 295.131 418.186 294.182C417.595 293.843 417.238 293.434 417.238 293.085C417.238 292.737 417.586 292.354 418.16 292.015C418.969 291.545 420.117 291.284 421.317 291.284C422.517 291.284 423.691 291.554 424.517 292.032C424.7 292.137 424.856 292.25 424.987 292.372L425.308 292.929L425.395 292.877C425.43 292.964 425.456 293.051 425.456 293.129H425.465ZM403.115 263.884C401.489 264.824 398.402 264.815 396.758 263.867C396.167 263.527 395.811 263.118 395.811 262.77C395.811 262.422 396.158 262.039 396.732 261.699C397.541 261.229 398.689 260.968 399.889 260.968C401.089 260.968 402.263 261.238 403.089 261.717C403.681 262.056 404.037 262.465 404.037 262.813C404.037 263.162 403.689 263.553 403.115 263.884Z",
    fill: "#45108A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.42 284.852L255.209 271.021C255.635 270.429 255.87 269.759 255.87 269.071C255.87 267.766 255.053 266.539 253.618 265.712C252.392 265.007 250.792 264.615 249.113 264.615C247.435 264.615 245.861 264.998 244.652 265.703C243.235 266.521 242.426 267.731 242.426 269.037C242.426 270.342 243.243 271.569 244.678 272.396C245.904 273.101 247.504 273.493 249.183 273.493C250.557 273.493 251.87 273.214 252.966 272.727L275.15 285.948L215.954 319.536C215.546 319.771 215.293 320.198 215.293 320.668C215.293 321.138 215.546 321.573 215.946 321.799L257.905 345.909C257.453 346.518 257.209 347.197 257.209 347.911C257.209 349.217 258.027 350.444 259.462 351.271C260.688 351.976 262.288 352.367 263.966 352.367C265.645 352.367 267.219 351.985 268.428 351.279C269.845 350.461 270.654 349.252 270.654 347.946C270.654 346.64 269.836 345.413 268.402 344.586C267.175 343.881 265.575 343.49 263.897 343.49C262.558 343.49 261.279 343.751 260.201 344.212L219.233 320.677L278.394 287.106C278.802 286.88 279.046 286.453 279.054 285.983C279.054 285.522 278.82 285.087 278.42 284.852ZM245.983 270.133C245.391 269.794 245.035 269.385 245.035 269.037C245.035 268.688 245.383 268.305 245.956 267.966C246.765 267.496 247.913 267.235 249.113 267.235C250.313 267.235 251.487 267.505 252.313 267.983C252.905 268.323 253.261 268.732 253.261 269.08C253.261 269.428 252.914 269.82 252.34 270.151C250.713 271.091 247.626 271.082 245.983 270.133ZM267.097 346.858C267.688 347.197 268.045 347.606 268.045 347.955C268.045 348.303 267.697 348.686 267.123 349.025C265.497 349.965 262.41 349.957 260.766 349.008C260.175 348.668 259.818 348.259 259.818 347.911C259.818 347.563 260.166 347.18 260.74 346.841C261.549 346.371 262.697 346.109 263.897 346.109C265.097 346.109 266.271 346.379 267.097 346.858Z",
    fill: "#45108A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5346 263.771C58.7607 264.476 60.3608 264.867 62.0392 264.867C63.7176 264.867 65.2916 264.485 66.5004 263.779C67.9179 262.961 68.7267 261.751 68.7267 260.446C68.7267 259.488 68.2831 258.575 67.4831 257.835L97.0591 238.643L139.436 263.736L181.274 240.131C182.187 240.418 183.196 240.592 184.248 240.592C185.926 240.592 187.526 240.201 188.753 239.496C190.179 238.669 191.005 237.45 191.005 236.145C191.005 234.848 190.196 233.629 188.779 232.811C187.57 232.115 185.987 231.723 184.317 231.723C182.648 231.723 181.039 232.115 179.813 232.82C178.387 233.647 177.56 234.865 177.56 236.18C177.56 237.067 177.943 237.912 178.639 238.617L139.462 260.724L96.9895 235.57L64.8568 256.416C63.9611 256.146 62.9871 255.99 61.9697 255.99C60.3087 255.99 58.7172 256.372 57.5085 257.077C56.091 257.896 55.2822 259.106 55.2822 260.411C55.2822 261.717 56.0997 262.944 57.5346 263.771ZM181.117 235.092C181.943 234.613 183.109 234.343 184.317 234.343C185.526 234.343 186.665 234.613 187.474 235.074C188.048 235.405 188.396 235.805 188.396 236.145C188.396 236.484 188.039 236.893 187.448 237.241C186.622 237.72 185.448 237.973 184.248 237.973C183.056 237.973 181.9 237.72 181.1 237.25C180.526 236.919 180.178 236.519 180.178 236.18C180.178 235.84 180.535 235.431 181.126 235.083L181.117 235.092ZM58.8129 259.341C59.6217 258.871 60.7696 258.609 61.9697 258.609C63.1697 258.609 64.3437 258.879 65.1699 259.358C65.7612 259.697 66.1178 260.106 66.1178 260.455C66.1178 260.803 65.7699 261.186 65.196 261.525C63.5698 262.465 60.4826 262.457 58.839 261.508C58.2477 261.168 57.8911 260.759 57.8911 260.411C57.8911 260.063 58.239 259.68 58.8129 259.341Z",
    fill: "#45108A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M231.686 82.8434C231.686 84.149 232.503 85.3763 233.938 86.2031C235.164 86.9081 236.764 87.2998 238.443 87.2998C240.121 87.2998 241.695 86.9168 242.904 86.2118C244.322 85.3937 245.13 84.1838 245.13 82.8783C245.13 81.5727 244.313 80.3454 242.878 79.5186C241.652 78.8135 240.052 78.4219 238.373 78.4219C236.695 78.4219 235.199 78.7961 233.999 79.4663L198.205 59.6911L229.094 41.0387L298.377 79.3445L270.819 96.5172C270.758 96.4824 270.706 96.4389 270.645 96.4041C269.419 95.6991 267.819 95.3074 266.14 95.3074C264.462 95.3074 262.888 95.6903 261.679 96.3954C260.262 97.2135 259.453 98.4234 259.453 99.7289C259.453 101.035 260.27 102.262 261.705 103.089C262.932 103.794 264.532 104.185 266.21 104.185C267.888 104.185 269.462 103.802 270.671 103.097C272.089 102.279 272.897 101.069 272.897 99.7638C272.897 99.3199 272.793 98.8847 272.61 98.4756L303.526 79.2139L229.033 38.0272L192.979 59.7956L232.042 81.3812C231.808 81.8425 231.677 82.3386 231.677 82.8434H231.686ZM269.367 100.834C267.741 101.774 264.653 101.766 263.01 100.817C262.418 100.477 262.062 100.068 262.062 99.7202C262.062 99.3721 262.41 98.9804 262.984 98.6497C263.792 98.1796 264.94 97.9185 266.14 97.9185C267.341 97.9185 268.515 98.1884 269.341 98.6671C269.932 99.0065 270.289 99.4156 270.289 99.7638C270.289 100.112 269.941 100.504 269.367 100.834ZM241.573 81.7816C242.165 82.121 242.521 82.5301 242.521 82.8783C242.521 83.2264 242.174 83.6181 241.6 83.9488C239.973 84.8888 236.886 84.8801 235.243 83.9314C234.651 83.592 234.295 83.1829 234.295 82.8347C234.295 82.7738 234.321 82.7042 234.338 82.6432L234.512 82.739L234.956 81.9382C235.043 81.8773 235.121 81.8164 235.217 81.7642C236.025 81.2941 237.173 81.033 238.373 81.033C239.573 81.033 240.747 81.3028 241.573 81.7816Z",
    fill: "#45108A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M322.849 112.141C321.431 112.959 320.623 114.169 320.623 115.474C320.623 116.78 321.44 118.007 322.875 118.834C324.101 119.539 325.701 119.931 327.38 119.931C328.71 119.931 329.98 119.678 331.058 119.217L350.538 130.758L386.097 109.225C386.097 109.225 386.114 109.242 386.132 109.242C387.358 109.947 388.958 110.339 390.636 110.339C392.315 110.339 393.889 109.956 395.097 109.251C396.515 108.433 397.324 107.223 397.324 105.917C397.324 104.612 396.506 103.385 395.071 102.558C393.845 101.853 392.245 101.461 390.567 101.461C388.888 101.461 387.314 101.844 386.105 102.549C384.688 103.367 383.879 104.577 383.879 105.883C383.879 106.37 383.992 106.857 384.218 107.301L350.529 127.703L333.345 117.528C333.806 116.91 334.067 116.223 334.067 115.509C334.067 114.203 333.25 112.976 331.815 112.149C330.588 111.444 328.988 111.053 327.31 111.053C325.632 111.053 324.058 111.436 322.849 112.141ZM387.41 104.812C388.219 104.342 389.367 104.081 390.567 104.081C391.767 104.081 392.941 104.351 393.767 104.829C394.358 105.169 394.715 105.578 394.715 105.926C394.715 106.274 394.367 106.666 393.793 106.997C392.167 107.937 389.08 107.928 387.436 106.979C386.845 106.64 386.488 106.231 386.488 105.883C386.488 105.534 386.836 105.143 387.41 104.812ZM331.458 115.509C331.458 115.718 331.31 115.953 331.067 116.179L331.041 116.162L330.988 116.249C330.858 116.362 330.71 116.475 330.528 116.58C328.901 117.52 325.814 117.511 324.171 116.562C323.579 116.223 323.223 115.814 323.223 115.466C323.223 115.117 323.571 114.726 324.145 114.395C324.953 113.925 326.101 113.664 327.301 113.664C328.501 113.664 329.675 113.934 330.502 114.412C331.093 114.752 331.449 115.161 331.449 115.509H331.458Z",
    fill: "#45108A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M309.065 245.44C309.57 244.805 309.848 244.083 309.848 243.334C309.848 242.029 309.031 240.801 307.596 239.974C306.369 239.269 304.769 238.878 303.091 238.878C301.413 238.878 299.847 239.261 298.63 239.966C297.212 240.784 296.404 241.994 296.404 243.299C296.404 244.605 297.221 245.832 298.656 246.65C299.882 247.355 301.482 247.747 303.161 247.747C304.595 247.747 305.952 247.451 307.074 246.92L306.909 247.216L437.3 321.147L426.674 327.666C425.726 327.353 424.673 327.17 423.578 327.17C421.917 327.17 420.325 327.553 419.117 328.258C417.699 329.076 416.89 330.286 416.89 331.591C416.89 332.897 417.708 334.124 419.143 334.951C420.369 335.656 421.969 336.048 423.647 336.048C425.326 336.048 426.9 335.665 428.109 334.96C429.526 334.142 430.335 332.932 430.335 331.626C430.335 330.73 429.943 329.877 429.239 329.163L442.44 321.06L309.065 245.44ZM306.317 244.405C304.691 245.345 301.604 245.336 299.96 244.387C299.369 244.048 299.012 243.639 299.012 243.291C299.012 242.942 299.36 242.559 299.934 242.22C300.743 241.75 301.891 241.489 303.091 241.489C304.291 241.489 305.465 241.759 306.291 242.237C306.883 242.577 307.239 242.986 307.239 243.334C307.239 243.682 306.891 244.065 306.317 244.405ZM427.726 331.635C427.726 331.974 427.378 332.366 426.804 332.705C425.178 333.645 422.091 333.637 420.447 332.688C419.856 332.349 419.499 331.94 419.499 331.591C419.499 331.243 419.847 330.852 420.421 330.521C421.23 330.051 422.378 329.79 423.578 329.79C424.7 329.79 425.778 330.033 426.587 330.451L426.743 330.704L426.891 330.617C427.413 330.947 427.726 331.322 427.726 331.644V331.635Z",
    fill: "#45108A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8843 215.412L142.793 247.895L168.568 232.872C169.577 233.246 170.734 233.455 171.934 233.455C173.612 233.455 175.212 233.064 176.438 232.359C177.865 231.532 178.691 230.313 178.691 229.008C178.691 227.711 177.882 226.492 176.465 225.674C175.256 224.978 173.673 224.586 172.003 224.586C170.334 224.586 168.725 224.978 167.499 225.683C166.072 226.51 165.246 227.728 165.246 229.042C165.246 229.843 165.559 230.609 166.125 231.279L142.793 244.883L88.1974 213.166L86.8843 215.421V215.412ZM168.794 227.946C169.621 227.467 170.786 227.197 171.995 227.197C173.203 227.197 174.343 227.467 175.151 227.928C175.725 228.259 176.073 228.659 176.073 228.999C176.073 229.338 175.717 229.747 175.125 230.096C174.299 230.574 173.134 230.835 171.925 230.835C170.734 230.835 169.577 230.574 168.768 230.104C168.194 229.773 167.847 229.373 167.847 229.034C167.847 228.694 168.203 228.285 168.794 227.937V227.946Z",
    fill: "#45108A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4655 283.929L66.1612 284.329L90.6934 268.419C91.8239 268.932 93.1718 269.228 94.5893 269.228C96.2503 269.228 97.8417 268.845 99.0505 268.14C100.468 267.322 101.277 266.112 101.277 264.807C101.277 263.501 100.459 262.274 99.0244 261.447C97.7982 260.742 96.1981 260.35 94.5197 260.35C92.8413 260.35 91.2673 260.733 90.0585 261.438C88.641 262.256 87.8323 263.466 87.8323 264.772C87.8323 265.459 88.0671 266.13 88.4932 266.73L66.0829 281.266L13.2444 250.567C13.3662 250.219 13.4444 249.862 13.4444 249.496C13.4444 248.191 12.627 246.964 11.1921 246.137C9.96592 245.432 8.36581 245.04 6.68743 245.04C5.00905 245.04 3.43503 245.423 2.22624 246.128C0.808753 246.946 0 248.156 0 249.462C0 250.767 0.817449 251.994 2.25233 252.821C3.47851 253.526 5.07862 253.918 6.757 253.918C8.43538 253.918 10.0094 253.535 11.2182 252.83C11.3399 252.76 11.453 252.682 11.5573 252.612L65.4655 283.938V283.929ZM91.363 263.71C92.1717 263.24 93.3196 262.979 94.5197 262.979C95.7198 262.979 96.8938 263.249 97.7199 263.727C98.3113 264.067 98.6678 264.476 98.6678 264.824C98.6678 265.172 98.32 265.555 97.746 265.895C96.1198 266.835 93.0327 266.826 91.3891 265.877C90.7977 265.538 90.4412 265.129 90.4412 264.78C90.4412 264.432 90.789 264.049 91.363 263.71ZM3.55677 250.558C2.96543 250.219 2.60888 249.81 2.60888 249.462C2.60888 249.113 2.95673 248.731 3.53068 248.391C4.33944 247.921 5.48734 247.66 6.68743 247.66C7.88751 247.66 9.06151 247.93 9.88766 248.408C10.479 248.748 10.8355 249.157 10.8355 249.505C10.8355 249.853 10.4877 250.236 9.91374 250.576C8.28754 251.516 5.20037 251.507 3.55677 250.558Z",
    fill: "#45108A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M193.753 247.46L193.666 247.312C194.562 247.582 195.536 247.747 196.562 247.747C198.24 247.747 199.84 247.355 201.066 246.65C202.493 245.823 203.319 244.605 203.319 243.299C203.319 242.002 202.51 240.784 201.093 239.966C199.884 239.269 198.301 238.878 196.631 238.878C194.962 238.878 193.353 239.269 192.127 239.974C190.7 240.801 189.874 242.02 189.874 243.334C189.874 244.3 190.318 245.214 191.127 245.954L72.666 313.844C72.6226 313.818 72.5791 313.783 72.5356 313.757C71.3094 313.052 69.7093 312.66 68.0309 312.66C66.3526 312.66 64.7872 313.043 63.5697 313.748C62.1523 314.567 61.3435 315.785 61.3435 317.082C61.3435 318.388 62.161 319.615 63.5958 320.433C64.822 321.138 66.4221 321.53 68.1005 321.53C69.7789 321.53 71.3529 321.147 72.5617 320.442C73.9792 319.624 74.7879 318.414 74.7879 317.108C74.7879 316.655 74.6836 316.22 74.4923 315.794L193.753 247.451V247.46ZM193.431 242.237C194.257 241.759 195.423 241.489 196.631 241.489C197.84 241.489 198.979 241.759 199.788 242.22C200.362 242.551 200.71 242.951 200.71 243.291C200.71 243.63 200.353 244.039 199.762 244.387C198.936 244.866 197.753 245.118 196.562 245.118C195.379 245.118 194.222 244.875 193.414 244.405C192.84 244.074 192.492 243.674 192.492 243.334C192.492 242.995 192.848 242.586 193.44 242.237H193.431ZM71.2573 318.187C69.631 319.127 66.5439 319.119 64.9003 318.17C64.3089 317.831 63.9524 317.421 63.9524 317.073C63.9524 316.734 64.3002 316.342 64.8742 316.003C65.6829 315.533 66.8309 315.272 68.0309 315.272C69.231 315.272 70.405 315.541 71.2312 316.02C71.8225 316.36 72.1791 316.769 72.1791 317.117C72.1791 317.465 71.8312 317.848 71.2573 318.187Z",
    fill: "#45108A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M370.974 253.77L333.424 231.462C334.111 230.757 334.493 229.913 334.493 229.034C334.493 227.728 333.676 226.501 332.241 225.674C331.015 224.969 329.415 224.577 327.736 224.577C326.058 224.577 324.493 224.96 323.275 225.665C321.858 226.483 321.049 227.693 321.049 228.999C321.049 230.304 321.866 231.532 323.301 232.35C324.527 233.055 326.127 233.446 327.806 233.446C328.884 233.446 329.919 233.272 330.85 232.968L370.974 256.799L429.761 222.149L428.439 219.895L370.983 253.761L370.974 253.77ZM324.606 230.096C324.014 229.756 323.658 229.347 323.658 228.999C323.658 228.651 324.006 228.268 324.58 227.928C325.388 227.458 326.536 227.197 327.736 227.197C328.936 227.197 330.11 227.467 330.936 227.946C331.528 228.285 331.884 228.694 331.884 229.042C331.884 229.39 331.537 229.773 330.963 230.113C329.336 231.053 326.249 231.044 324.606 230.096Z",
    fill: "#45108A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M402.385 286.819L428.082 270.699C429.213 271.221 430.57 271.517 431.996 271.517C433.657 271.517 435.248 271.134 436.457 270.429C437.874 269.611 438.683 268.401 438.683 267.096C438.683 265.79 437.866 264.563 436.431 263.736C435.205 263.031 433.605 262.639 431.926 262.639C430.248 262.639 428.674 263.022 427.465 263.727C426.047 264.545 425.239 265.755 425.239 267.061C425.239 267.748 425.465 268.401 425.891 268.993L402.324 283.781L321.44 238.234C321.918 237.616 322.179 236.911 322.179 236.18C322.179 234.874 321.362 233.647 319.927 232.82C318.701 232.115 317.101 231.723 315.422 231.723C313.744 231.723 312.179 232.106 310.961 232.811C309.544 233.629 308.735 234.839 308.735 236.145C308.735 237.45 309.552 238.678 310.987 239.496C312.213 240.201 313.813 240.592 315.492 240.592C316.892 240.592 318.222 240.305 319.336 239.8L319.231 239.983L402.385 286.81V286.819ZM428.769 265.99C429.578 265.52 430.726 265.259 431.926 265.259C433.126 265.259 434.3 265.529 435.126 266.008C435.718 266.347 436.074 266.756 436.074 267.104C436.074 267.444 435.726 267.835 435.153 268.175C434.344 268.645 433.196 268.906 431.996 268.906C430.796 268.906 429.622 268.636 428.796 268.158C428.204 267.818 427.848 267.409 427.848 267.061C427.848 266.713 428.195 266.33 428.769 265.99ZM318.64 237.25C317.014 238.19 313.927 238.181 312.283 237.233C311.692 236.893 311.335 236.484 311.335 236.136C311.335 235.788 311.683 235.405 312.257 235.065C313.066 234.595 314.214 234.334 315.414 234.334C316.614 234.334 317.788 234.604 318.614 235.083C319.205 235.422 319.562 235.831 319.562 236.18C319.562 236.528 319.214 236.911 318.64 237.25Z",
    fill: "#45108A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M390.854 207.344L354.06 229.39L345.598 224.464C346.372 223.733 346.807 222.836 346.807 221.888C346.807 220.582 345.99 219.355 344.555 218.528C343.329 217.823 341.729 217.431 340.05 217.431C338.372 217.431 336.807 217.814 335.589 218.519C334.172 219.338 333.363 220.556 333.363 221.853C333.363 223.15 334.18 224.386 335.615 225.204C336.841 225.909 338.441 226.301 340.12 226.301C341.094 226.301 342.033 226.153 342.885 225.909L354.077 232.419L396.002 207.3L358.043 185.392L391.541 165.582C392.61 166.018 393.863 166.261 395.167 166.261C396.828 166.261 398.42 165.878 399.628 165.173C401.046 164.355 401.855 163.145 401.855 161.84C401.855 160.534 401.037 159.307 399.602 158.48C398.376 157.775 396.776 157.383 395.098 157.383C393.419 157.383 391.845 157.766 390.636 158.471C389.219 159.29 388.41 160.499 388.41 161.805C388.41 162.562 388.697 163.285 389.202 163.929L352.86 185.419L390.845 207.344H390.854ZM336.92 222.95C336.328 222.61 335.972 222.201 335.972 221.853C335.972 221.505 336.32 221.122 336.893 220.782C337.702 220.312 338.85 220.051 340.05 220.051C341.25 220.051 342.424 220.321 343.25 220.8C343.842 221.139 344.198 221.548 344.198 221.896C344.198 222.245 343.85 222.628 343.277 222.967C341.65 223.907 338.563 223.898 336.92 222.95ZM391.95 160.734C392.758 160.264 393.906 160.003 395.106 160.003C396.306 160.003 397.48 160.273 398.307 160.752C398.898 161.091 399.254 161.5 399.254 161.848C399.254 162.197 398.907 162.58 398.333 162.919C396.706 163.859 393.619 163.85 391.976 162.902C391.384 162.562 391.028 162.153 391.028 161.805C391.028 161.457 391.376 161.074 391.95 160.734Z",
    fill: "#45108A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M329.475 139.897L292.116 161.666L293.429 163.929L334.772 139.836L296.873 118.991L331.432 97.4224L330.049 95.2029L291.716 119.13L329.475 139.897Z",
    fill: "#45108A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M259.297 159.794L300.647 135.702L237.312 101.165L273.776 78.4045L245.626 63.4251C245.826 62.9899 245.939 62.5373 245.939 62.0673C245.939 60.7617 245.122 59.5345 243.687 58.7076C242.461 58.0026 240.861 57.6109 239.182 57.6109C237.504 57.6109 235.93 57.9939 234.721 58.6989C233.303 59.5171 232.495 60.7269 232.495 62.0325C232.495 63.3381 233.312 64.5653 234.747 65.3922C235.973 66.0972 237.573 66.4889 239.252 66.4889C240.93 66.4889 242.504 66.1059 243.713 65.4009C243.722 65.4009 243.73 65.3922 243.739 65.3835L268.558 78.596L232.138 101.33L295.334 135.789L257.983 157.549L259.297 159.803V159.794ZM242.408 63.1292C240.782 64.0692 237.695 64.0605 236.052 63.1118C235.46 62.7723 235.104 62.3632 235.104 62.0151C235.104 61.6669 235.451 61.2752 236.025 60.9445C236.834 60.4745 237.982 60.2134 239.182 60.2134C240.382 60.2134 241.556 60.4832 242.382 60.9619C242.974 61.3014 243.33 61.7104 243.33 62.0586C243.33 62.4068 242.982 62.7984 242.408 63.1292Z",
    fill: "#45108A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.262 119.043C144.471 119.739 146.054 120.131 147.723 120.131C149.132 120.131 150.463 119.844 151.585 119.339L178.691 135.293L147.08 154.45L214.72 193.739L216.033 191.476L152.193 154.398L183.778 135.258L153.811 117.615C154.237 117.024 154.463 116.353 154.472 115.666C154.472 114.369 153.663 113.15 152.246 112.332C151.037 111.636 149.454 111.244 147.784 111.244C146.115 111.244 144.506 111.636 143.28 112.341C141.853 113.168 141.027 114.386 141.027 115.701C141.027 117.015 141.836 118.216 143.254 119.034L143.262 119.043ZM144.593 114.621C145.419 114.143 146.584 113.873 147.793 113.873C149.002 113.873 150.141 114.143 150.95 114.604C151.524 114.935 151.872 115.335 151.872 115.674C151.872 116.014 151.515 116.423 150.924 116.771C150.098 117.25 148.932 117.52 147.723 117.52C146.523 117.52 145.375 117.25 144.567 116.789C143.993 116.458 143.645 116.057 143.645 115.718C143.645 115.379 144.001 114.969 144.593 114.621Z",
    fill: "#45108A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3619 98.9978C75.5707 99.6941 77.1534 100.086 78.8231 100.086C80.4319 100.086 81.9624 99.7202 83.1625 99.0675L141.541 135.032C141.401 135.397 141.314 135.78 141.314 136.181C141.314 137.478 142.123 138.696 143.541 139.514C144.749 140.211 146.332 140.602 148.002 140.602C149.672 140.602 151.28 140.211 152.507 139.506C153.933 138.679 154.759 137.46 154.759 136.146C154.759 134.832 153.95 133.631 152.533 132.812C151.324 132.116 149.741 131.724 148.071 131.724C146.402 131.724 144.793 132.116 143.567 132.821C143.454 132.882 143.358 132.952 143.254 133.021L85.1366 97.2222C85.4148 96.7261 85.5714 96.1865 85.5714 95.6381C85.5714 94.3412 84.7626 93.1227 83.3451 92.3045C82.1364 91.6082 80.5536 91.2166 78.8839 91.2166C77.2143 91.2166 75.6055 91.6082 74.3793 92.3132C72.9531 93.1401 72.127 94.3674 72.127 95.6729C72.127 96.9698 72.9357 98.1884 74.3532 99.0065L74.3619 98.9978ZM148.071 134.327C149.272 134.327 150.419 134.597 151.228 135.058C151.802 135.389 152.15 135.789 152.15 136.129C152.15 136.468 151.793 136.877 151.202 137.225C149.567 138.174 146.471 138.174 144.845 137.243C144.271 136.912 143.923 136.512 143.923 136.172C143.923 135.833 144.28 135.424 144.871 135.075C145.697 134.597 146.863 134.327 148.071 134.327ZM75.6924 94.5763C76.5186 94.0975 77.6839 93.8277 78.8926 93.8277C80.1014 93.8277 81.2406 94.0975 82.0494 94.5588C82.6233 94.8896 82.9712 95.29 82.9712 95.6294C82.9712 95.9689 82.6146 96.378 82.0233 96.7261C81.1972 97.2048 80.0319 97.4746 78.8231 97.4746C77.623 97.4746 76.4751 97.2048 75.6663 96.7435C75.0924 96.4128 74.7445 96.0124 74.7445 95.6729C74.7445 95.3335 75.1011 94.9244 75.6924 94.5763Z",
    fill: "#45108A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M106.581 206.839L146.88 230.609L155.689 225.482C156.82 226.013 158.176 226.309 159.611 226.309C161.29 226.309 162.89 225.918 164.116 225.213C165.542 224.386 166.368 223.167 166.368 221.862C166.368 220.565 165.56 219.346 164.142 218.528C162.933 217.832 161.351 217.44 159.681 217.44C158.011 217.44 156.402 217.832 155.176 218.537C153.75 219.364 152.924 220.582 152.924 221.896C152.924 222.541 153.124 223.167 153.498 223.733L146.88 227.589L111.686 206.83L146.984 185.758L126.322 173.747C126.826 173.111 127.105 172.389 127.105 171.64C127.105 170.343 126.296 169.125 124.878 168.307C123.67 167.61 122.087 167.219 120.417 167.219C118.748 167.219 117.139 167.61 115.913 168.315C114.486 169.142 113.66 170.361 113.66 171.675C113.66 172.972 114.469 174.191 115.886 175.009C117.095 175.705 118.678 176.097 120.348 176.097C121.661 176.097 122.913 175.853 123.983 175.409L141.845 185.793L106.573 206.856L106.581 206.839ZM156.489 220.8C157.315 220.321 158.481 220.051 159.69 220.051C160.898 220.051 162.038 220.321 162.846 220.782C163.42 221.113 163.768 221.514 163.768 221.853C163.768 222.192 163.412 222.601 162.82 222.95C161.994 223.428 160.829 223.698 159.62 223.698C158.411 223.698 157.272 223.428 156.463 222.967C155.889 222.636 155.541 222.236 155.541 221.896C155.541 221.557 155.898 221.148 156.489 220.8ZM117.208 172.728C116.634 172.398 116.286 171.997 116.286 171.658C116.286 171.318 116.643 170.909 117.234 170.561C118.061 170.082 119.226 169.813 120.435 169.813C121.643 169.813 122.783 170.082 123.591 170.544C124.165 170.874 124.513 171.275 124.513 171.614C124.513 171.954 124.157 172.363 123.565 172.711C121.93 173.66 118.834 173.66 117.208 172.728Z",
    fill: "#45108A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M253.688 319.301C252.514 318.71 251.061 318.37 249.539 318.37C247.878 318.37 246.287 318.753 245.078 319.458C243.661 320.276 242.852 321.486 242.852 322.792C242.852 324.097 243.669 325.325 245.104 326.151C246.331 326.856 247.931 327.248 249.609 327.248C251.287 327.248 252.861 326.865 254.07 326.16C255.488 325.342 256.296 324.132 256.296 322.827C256.296 322.156 256.079 321.512 255.67 320.92L304.717 293.442C305.917 294.086 307.431 294.452 309.031 294.452C310.631 294.452 312.283 294.069 313.492 293.364C314.909 292.546 315.718 291.336 315.718 290.03C315.718 288.725 314.901 287.498 313.466 286.671C312.24 285.966 310.639 285.574 308.961 285.574C307.283 285.574 305.709 285.957 304.5 286.662C303.082 287.48 302.274 288.69 302.274 289.996C302.274 290.544 302.43 291.084 302.7 291.58L253.575 319.101L253.688 319.301ZM252.757 323.897C251.131 324.837 248.044 324.828 246.4 323.88C245.809 323.54 245.452 323.131 245.452 322.783C245.452 322.435 245.8 322.052 246.374 321.712C247.183 321.242 248.331 320.981 249.531 320.981C250.731 320.981 251.905 321.251 252.731 321.73C253.322 322.069 253.679 322.478 253.679 322.827C253.679 323.175 253.331 323.558 252.757 323.897ZM305.804 288.934C306.613 288.464 307.761 288.203 308.961 288.203C310.161 288.203 311.335 288.472 312.161 288.951C312.753 289.291 313.109 289.7 313.109 290.048C313.109 290.396 312.761 290.788 312.187 291.118C310.561 292.058 307.474 292.05 305.83 291.101C305.239 290.762 304.883 290.352 304.883 290.004C304.883 289.656 305.23 289.273 305.804 288.934Z",
    fill: "#45108A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M213.598 106.553L236.538 119.4L190.5 145.259L268.41 191.12L269.741 188.874L195.735 145.311L241.878 119.391L213.511 103.515L199.597 112.437L165.055 93.2272L163.785 95.5076L199.692 115.474L213.598 106.553Z",
    fill: "#45108A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M354.869 206.743C354.625 207.213 354.495 207.709 354.495 208.223C354.495 209.528 355.312 210.756 356.747 211.582C357.973 212.287 359.573 212.679 361.252 212.679C362.93 212.679 364.495 212.296 365.713 211.591C367.13 210.773 367.939 209.563 367.939 208.258C367.939 206.952 367.122 205.725 365.687 204.907C364.461 204.201 362.86 203.81 361.182 203.81C359.504 203.81 358.025 204.184 356.825 204.846L305.839 176.897L342.894 154.955C344.076 155.556 345.537 155.904 347.085 155.904C348.755 155.904 350.338 155.521 351.547 154.816C352.964 153.998 353.773 152.788 353.773 151.482C353.773 150.177 352.955 148.949 351.521 148.122C350.294 147.417 348.694 147.026 347.016 147.026C345.337 147.026 343.763 147.409 342.555 148.114C341.137 148.932 340.328 150.142 340.328 151.447C340.328 152.039 340.502 152.614 340.824 153.145L300.569 176.984L354.869 206.743ZM364.382 207.17C364.974 207.509 365.33 207.918 365.33 208.266C365.33 208.606 364.982 209.006 364.408 209.337C362.782 210.277 359.695 210.268 358.051 209.319C357.46 208.98 357.104 208.571 357.104 208.223C357.104 208.153 357.13 208.075 357.156 207.996L357.364 208.11L357.808 207.3C357.877 207.248 357.947 207.196 358.025 207.152C358.834 206.682 359.982 206.421 361.182 206.421C362.382 206.421 363.556 206.691 364.382 207.17ZM343.859 150.377C344.668 149.907 345.816 149.646 347.016 149.646C348.216 149.646 349.39 149.915 350.216 150.394C350.807 150.734 351.164 151.143 351.164 151.491C351.164 151.83 350.816 152.222 350.242 152.561C348.616 153.501 345.529 153.493 343.885 152.544C343.294 152.205 342.937 151.795 342.937 151.447C342.937 151.099 343.285 150.716 343.859 150.377Z",
    fill: "#45108A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M366.739 138.592L381.018 146.512L327.823 177.959L329.154 180.205L386.271 146.434L371.931 138.479L416.838 111.105C416.977 111.201 417.108 111.288 417.256 111.375C418.482 112.08 420.082 112.471 421.76 112.471C423.439 112.471 425.013 112.088 426.221 111.383C427.639 110.565 428.448 109.355 428.448 108.05C428.448 106.744 427.63 105.517 426.195 104.69C424.969 103.985 423.369 103.593 421.691 103.593C420.012 103.593 418.438 103.976 417.23 104.681C415.812 105.5 415.003 106.709 415.003 108.015C415.003 108.363 415.064 108.711 415.186 109.051L366.73 138.583L366.739 138.592ZM418.543 106.962C419.351 106.492 420.499 106.231 421.699 106.231C422.9 106.231 424.074 106.501 424.9 106.979C425.491 107.319 425.848 107.728 425.848 108.076C425.848 108.424 425.5 108.816 424.926 109.147C423.3 110.087 420.212 110.078 418.569 109.129C417.977 108.79 417.621 108.381 417.621 108.032C417.621 107.684 417.969 107.293 418.543 106.962Z",
    fill: "#45108A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M182.882 189.553L127.157 158.506L139.21 151.613L105.894 130.558C106.121 130.105 106.242 129.618 106.242 129.122C106.242 127.825 105.434 126.607 104.016 125.788C102.807 125.092 101.225 124.7 99.5549 124.7C97.8852 124.7 96.2764 125.092 95.0502 125.797C93.624 126.624 92.7979 127.842 92.7979 129.157C92.7979 130.454 93.6066 131.672 95.0241 132.49C96.2329 133.187 97.8156 133.578 99.4853 133.578C101.164 133.578 102.764 133.187 103.99 132.482C103.999 132.482 104.007 132.464 104.025 132.464L134.149 151.508L121.852 158.541L181.622 191.842L182.891 189.562L182.882 189.553ZM99.4853 130.958C98.2852 130.958 97.1373 130.689 96.3285 130.227C95.7546 129.897 95.4067 129.496 95.4067 129.157C95.4067 128.817 95.7633 128.408 96.3546 128.06C97.1808 127.581 98.3461 127.312 99.5549 127.312C100.764 127.312 101.903 127.581 102.712 128.043C103.286 128.373 103.633 128.774 103.633 129.113C103.633 129.453 103.277 129.862 102.686 130.21C101.859 130.689 100.694 130.958 99.4853 130.958Z",
    fill: "#45108A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M239.104 169.343L165.342 212.061C161.464 214.307 158.863 218.128 158.759 222.071C158.637 226.536 161.237 230.792 166.177 233.655L233.521 272.57C237.356 274.79 242.165 276 247.026 275.991C249.983 275.991 252.748 275.512 255.174 274.633C256.183 274.268 257.253 273.772 258.131 273.258L331.789 230.6C335.667 228.355 338.259 224.542 338.363 220.6C338.476 216.135 335.885 211.87 330.945 209.015L263.819 170.23C262.375 169.395 260.557 168.585 258.879 168.054C256.183 167.193 253.253 166.714 250.287 166.697C246.035 166.67 242.156 167.593 239.112 169.351L239.104 169.343Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M239.713 172.049L169.751 212.566C166.255 214.585 163.498 218.337 163.298 221.879C163.064 226.066 165.299 230.139 170.047 232.889L234.373 270.064C238.008 272.161 242.574 273.302 247.165 273.275C249.965 273.258 252.583 272.797 254.87 271.961C255.775 271.63 256.87 271.108 257.662 270.656L327.414 230.261C330.91 228.242 333.641 224.508 333.841 220.956C334.076 216.77 331.841 212.697 327.093 209.946L263.201 173.024C261.897 172.276 260.018 171.414 258.514 170.927C255.957 170.091 253.174 169.604 250.357 169.569C246.322 169.525 242.608 170.378 239.721 172.049H239.713Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M240.33 174.765L174.177 213.079C171.073 214.872 168.134 218.563 167.855 221.705C167.499 225.622 169.386 229.504 173.934 232.141L235.251 267.574C238.686 269.559 243.008 270.621 247.33 270.586C249.974 270.569 252.444 270.099 254.592 269.306C255.392 269.011 256.514 268.462 257.209 268.062L323.058 229.921C326.162 228.128 329.049 224.464 329.336 221.322C329.693 217.405 327.806 213.523 323.258 210.886L262.601 175.836C261.444 175.165 259.505 174.26 258.166 173.816C255.748 173.016 253.113 172.511 250.435 172.458C246.609 172.389 243.069 173.181 240.33 174.765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M240.939 177.472L178.586 213.584C175.873 215.151 172.751 218.772 172.395 221.514C171.916 225.178 173.447 228.851 177.804 231.375L236.112 265.068C239.338 266.93 243.426 267.923 247.478 267.879C249.965 267.853 252.287 267.392 254.296 266.634C255 266.373 256.14 265.808 256.748 265.451L318.692 229.573C321.405 228.007 324.466 224.421 324.823 221.679C325.301 218.015 323.771 214.342 319.414 211.817L261.992 178.638C260.983 178.055 258.975 177.089 257.809 176.697C255.531 175.923 253.044 175.409 250.513 175.339C246.896 175.252 243.53 175.984 240.939 177.472Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M241.556 180.179L183.004 214.089C180.674 215.438 177.352 218.989 176.943 221.322C176.343 224.751 177.526 228.198 181.682 230.609L236.973 262.561C239.999 264.31 243.843 265.233 247.626 265.172C249.957 265.137 252.131 264.685 254 263.962C254.601 263.736 255.766 263.144 256.288 262.84L314.326 229.225C316.657 227.876 319.909 224.368 320.318 222.036C320.918 218.606 319.736 215.16 315.579 212.749L261.384 181.432C260.514 180.927 258.453 179.918 257.453 179.57C255.314 178.821 252.974 178.299 250.592 178.212C247.183 178.099 243.991 178.769 241.556 180.17V180.179Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M242.165 182.894L187.413 214.603C185.474 215.725 181.482 219.163 181.482 221.139C180.073 224.116 181.587 227.554 185.552 229.852L237.834 260.063C240.66 261.699 244.261 262.544 247.774 262.474C249.957 262.43 251.966 261.987 253.713 261.299C254.209 261.107 255.392 260.489 255.835 260.237L309.978 228.886C311.918 227.763 315.822 224.377 315.822 222.401C317.231 219.425 315.718 215.987 311.752 213.689L260.792 184.244C260.07 183.826 257.94 182.755 257.114 182.459C255.114 181.746 252.922 181.206 250.678 181.11C247.478 180.971 244.452 181.58 242.174 182.903L242.165 182.894Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M242.782 185.601L191.831 215.107C190.283 216.004 186.031 219.372 186.031 220.948C184.387 223.629 185.665 226.901 189.431 229.086L238.695 257.556C241.321 259.071 244.678 259.845 247.922 259.767C249.948 259.715 251.809 259.271 253.418 258.627C253.818 258.47 255.018 257.835 255.375 257.626L305.613 228.529C307.161 227.632 311.309 224.325 311.309 222.749C312.953 220.069 311.674 216.796 307.909 214.611L260.184 187.029C259.601 186.698 257.418 185.567 256.757 185.323C254.896 184.635 252.853 184.087 250.757 183.974C247.774 183.817 244.913 184.365 242.791 185.593L242.782 185.601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M243.391 188.308L196.24 215.612C195.075 216.282 190.57 219.573 190.57 220.756C188.683 223.141 189.726 226.248 193.301 228.32L239.556 255.05C241.982 256.451 245.087 257.147 248.07 257.06C249.939 256.999 251.653 256.564 253.122 255.963C253.418 255.842 254.644 255.18 254.914 255.032L301.247 228.198C302.413 227.528 306.796 224.307 306.796 223.124C308.683 220.739 307.639 217.632 304.065 215.56L259.575 189.849C259.14 189.596 256.896 188.404 256.401 188.213C254.679 187.551 252.792 186.994 250.835 186.863C248.061 186.681 245.374 187.168 243.4 188.308H243.391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M244.008 191.024L200.657 216.126C199.884 216.578 195.118 219.781 195.118 220.573C192.996 222.662 193.805 225.604 197.179 227.563L240.417 252.552C242.634 253.831 245.504 254.466 248.217 254.362C249.931 254.301 251.496 253.866 252.826 253.3C253.026 253.213 254.27 252.525 254.453 252.43L296.882 227.859C297.656 227.406 302.282 224.281 302.282 223.489C304.404 221.4 303.595 218.458 300.221 216.5L258.957 192.66C258.67 192.495 256.357 191.233 256.035 191.102C254.453 190.467 252.713 189.901 250.896 189.753C248.33 189.553 245.817 189.971 244 191.024H244.008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M244.617 193.731L205.066 216.631C204.675 216.857 199.657 219.99 199.657 220.382C197.301 222.175 197.866 224.952 201.049 226.797L241.278 250.045C243.295 251.211 245.922 251.768 248.365 251.655C249.922 251.585 251.339 251.159 252.531 250.628C252.626 250.584 253.896 249.871 253.992 249.818L292.516 227.51C292.907 227.284 297.777 224.238 297.777 223.846C300.134 222.053 299.569 219.277 296.386 217.431L258.357 195.454C258.209 195.367 255.844 194.044 255.687 193.974C254.235 193.374 252.652 192.791 250.983 192.625C248.626 192.399 246.287 192.765 244.617 193.722V193.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.244 247.965L293.264 224.203C295.856 222.706 295.525 220.095 292.542 218.363L255.331 196.855C252.339 195.123 247.817 194.941 245.226 196.438L204.206 220.199C201.614 221.696 201.945 224.307 204.927 226.04L242.139 247.547C245.13 249.279 249.652 249.462 252.244 247.965Z",
    fill: "black"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M338.989 196.325H337.206C336.302 195.167 335.058 194.096 333.45 193.165L264.088 153.084C255.879 148.34 241.539 148.932 232.06 154.415L167.916 191.485C165.394 192.939 163.49 194.601 162.185 196.333H160.081V201.869H160.133C160.394 204.619 162.194 207.222 165.62 209.206L234.982 249.288C243.191 254.031 257.531 253.439 267.01 247.956L331.154 210.886C335.65 208.284 338.224 205.054 338.833 201.869H338.998V196.333L338.989 196.325Z",
    fill: "url(#paint24_linear_812_1630)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M234.982 245.057L165.62 204.976C157.411 200.233 158.437 191.946 167.916 186.472L232.06 149.402C241.539 143.927 255.879 143.327 264.088 148.07L333.449 188.152C341.659 192.895 340.633 201.181 331.154 206.656L267.01 243.726C257.531 249.201 243.191 249.801 234.982 245.057Z",
    fill: "url(#paint25_linear_812_1630)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M336.754 186.759H335.015C334.128 185.627 332.919 184.583 331.345 183.678L263.61 144.536C255.592 139.906 241.591 140.489 232.338 145.833L169.699 182.033C167.238 183.451 165.377 185.07 164.098 186.768H162.037V196.446H162.09C162.35 199.136 164.098 201.677 167.446 203.61L235.182 242.751C243.2 247.381 257.201 246.798 266.453 241.454L329.093 205.255C333.484 202.713 335.997 199.562 336.589 196.446H336.745V186.768L336.754 186.759Z",
    fill: "url(#paint26_linear_812_1630)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M338.85 180.327H337.067C336.163 179.169 334.919 178.099 333.31 177.167L263.949 137.086C255.74 132.342 241.4 132.934 231.921 138.418L167.777 175.487C165.255 176.941 163.351 178.603 162.046 180.336H159.942V191.964H159.994C160.255 194.714 162.055 197.317 165.481 199.301L234.843 239.383C243.052 244.126 257.392 243.534 266.871 238.051L331.015 200.981C335.511 198.379 338.085 195.149 338.693 191.964H338.859V180.336L338.85 180.327Z",
    fill: "url(#paint27_linear_812_1630)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M234.834 229.06L165.473 188.978C157.263 184.235 158.289 175.949 167.768 170.474L231.912 133.404C241.391 127.929 255.731 127.329 263.94 132.073L333.302 172.154C341.511 176.897 340.485 185.184 331.006 190.658L266.862 227.728C257.383 233.203 243.043 233.803 234.834 229.06Z",
    fill: "url(#paint28_linear_812_1630)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M238.121 218.128L184.395 187.081C178.038 183.408 178.839 176.993 186.178 172.746L235.86 144.04C243.2 139.802 254.305 139.34 260.662 143.013L314.387 174.06C320.744 177.733 319.944 184.148 312.604 188.395L262.923 217.101C255.583 221.339 244.478 221.801 238.121 218.128Z",
    fill: "url(#paint29_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M331.006 189.231L266.862 226.301C257.383 231.775 243.043 232.376 234.834 227.632L165.473 187.551C162.177 185.645 160.394 183.173 160.029 180.536C159.524 183.948 161.29 187.281 165.473 189.701L234.834 229.782C243.043 234.526 257.383 233.934 266.862 228.451L331.006 191.381C336.685 188.099 339.302 183.817 338.754 179.892C338.267 183.182 335.658 186.55 331.006 189.231Z",
    fill: "url(#paint30_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M251.44 273.931C263.522 272.596 271.849 258.209 270.039 241.796C268.229 225.384 256.966 213.161 244.884 214.497C232.801 215.832 224.474 230.219 226.284 246.631C228.095 263.044 239.357 275.266 251.44 273.931Z",
    fill: "url(#paint31_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.878 145.076L251.661 143.466L248.896 141.873L246.113 143.483L248.878 145.076Z",
    fill: "#2AF6FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M243.652 148.096L246.435 146.486L243.669 144.893L240.886 146.495L243.652 148.096Z",
    fill: "#2AF6FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M238.425 151.117L241.208 149.506L238.443 147.914L235.66 149.515L238.425 151.117Z",
    fill: "#2AF6FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M233.199 154.137L235.982 152.527L233.216 150.925L230.442 152.535L233.199 154.137Z",
    fill: "#2AF6FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.981 157.157L230.755 155.547L227.999 153.945L225.216 155.556L227.981 157.157Z",
    fill: "#2AF6FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M222.755 160.169L225.537 158.567L222.772 156.966L219.989 158.576L222.755 160.169Z",
    fill: "#2AF6FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M217.528 163.189L220.311 161.587L217.546 159.986L214.763 161.596L217.528 163.189Z",
    fill: "#2AF6FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.302 166.209L215.085 164.608L212.319 163.006L209.536 164.616L212.302 166.209Z",
    fill: "#2AF6FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M207.075 169.229L209.858 167.619L207.093 166.026L204.319 167.637L207.075 169.229Z",
    fill: "#2AF6FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M201.858 172.25L204.632 170.639L201.875 169.047L199.092 170.648L201.858 172.25Z",
    fill: "#2AF6FF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.631 175.27L199.414 173.66L196.649 172.067L193.866 173.668L196.631 175.27Z",
    fill: "#2AF6FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.405 178.29L194.188 176.68L191.422 175.087L188.639 176.689L191.405 178.29Z",
    fill: "#2AF6FF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M186.178 181.31L188.961 179.7L186.196 178.099L183.413 179.709L186.178 181.31Z",
    fill: "#2AF6FF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.818 147.931L256.601 146.321L253.835 144.728L251.052 146.329L253.818 147.931Z",
    fill: "#2AF6FF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.591 150.951L251.374 149.341L248.609 147.748L245.826 149.35L248.591 150.951Z",
    fill: "#2AF6FF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M243.365 153.971L246.148 152.361L243.382 150.76L240.599 152.37L243.365 153.971Z",
    fill: "#2AF6FF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M238.138 156.992L240.921 155.382L238.156 153.78L235.373 155.39L238.138 156.992Z",
    fill: "#2AF6FF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M232.921 160.003L235.695 158.402L232.929 156.8L230.155 158.41L232.921 160.003Z",
    fill: "#2AF6FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M227.694 163.024L230.477 161.422L227.712 159.82L224.929 161.431L227.694 163.024Z",
    fill: "#2AF6FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.468 166.044L225.251 164.442L222.485 162.841L219.702 164.451L222.468 166.044Z",
    fill: "#2AF6FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M217.241 169.064L220.024 167.454L217.259 165.861L214.476 167.471L217.241 169.064Z",
    fill: "#2AF6FF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M212.015 172.084L214.798 170.474L212.032 168.881L209.25 170.483L212.015 172.084Z",
    fill: "#2AF6FF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M206.788 175.104L209.571 173.494L206.806 171.901L204.032 173.503L206.788 175.104Z",
    fill: "#2AF6FF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.571 178.125L204.345 176.515L201.588 174.922L198.805 176.523L201.571 178.125Z",
    fill: "#2AF6FF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M196.344 181.145L199.127 179.535L196.362 177.933L193.579 179.543L196.344 181.145Z",
    fill: "#2AF6FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.118 184.157L193.901 182.555L191.135 180.953L188.352 182.564L191.118 184.157Z",
    fill: "#2AF6FF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M258.757 150.786L261.531 149.176L258.775 147.583L255.992 149.184L258.757 150.786Z",
    fill: "#2AF6FF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.531 153.806L256.314 152.196L253.548 150.594L250.765 152.205L253.531 153.806Z",
    fill: "#2AF6FF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M248.304 156.818L251.087 155.216L248.322 153.615L245.539 155.225L248.304 156.818Z",
    fill: "#2AF6FF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.078 159.838L245.861 158.236L243.095 156.635L240.312 158.245L243.078 159.838Z",
    fill: "#2AF6FF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.851 162.858L240.634 161.257L237.869 159.655L235.095 161.265L237.851 162.858Z",
    fill: "#2AF6FF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M232.634 165.878L235.408 164.268L232.651 162.675L229.868 164.286L232.634 165.878Z",
    fill: "#2AF6FF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M227.407 168.899L230.19 167.288L227.425 165.696L224.642 167.306L227.407 168.899Z",
    fill: "#2AF6FF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.181 171.919L224.964 170.309L222.198 168.716L219.415 170.317L222.181 171.919Z",
    fill: "#2AF6FF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.954 174.939L219.737 173.329L216.972 171.736L214.189 173.338L216.954 174.939Z",
    fill: "#2AF6FF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.728 177.959L214.511 176.349L211.745 174.756L208.962 176.358L211.728 177.959Z",
    fill: "#2AF6FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M206.501 180.98L209.284 179.369L206.519 177.768L203.745 179.378L206.501 180.98Z",
    fill: "#2AF6FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M201.284 183.991L204.058 182.39L201.301 180.788L198.518 182.398L201.284 183.991Z",
    fill: "#2AF6FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M196.057 187.011L198.84 185.41L196.075 183.808L193.292 185.419L196.057 187.011Z",
    fill: "#2AF6FF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M263.697 153.641L266.471 152.031L263.714 150.429L260.931 152.039L263.697 153.641Z",
    fill: "#2AF6FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M258.47 156.652L261.253 155.051L258.488 153.449L255.705 155.059L258.47 156.652Z",
    fill: "#2AF6FF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.244 159.673L256.026 158.071L253.261 156.469L250.478 158.08L253.244 159.673Z",
    fill: "#FF63CE"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M248.017 162.693L250.8 161.091L248.035 159.49L245.252 161.1L248.017 162.693Z",
    fill: "#FF63CE"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.791 165.713L245.574 164.103L242.808 162.51L240.025 164.12L242.791 165.713Z",
    fill: "#2AF6FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.564 168.733L240.347 167.123L237.582 165.53L234.808 167.132L237.564 168.733Z",
    fill: "#2AF6FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M227.12 174.774L229.903 173.164L227.138 171.571L224.355 173.172L227.12 174.774Z",
    fill: "#FF63CE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M221.894 177.794L224.677 176.184L221.911 174.582L219.128 176.192L221.894 177.794Z",
    fill: "#FF63CE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.441 183.826L214.224 182.224L211.458 180.623L208.676 182.233L211.441 183.826Z",
    fill: "#2AF6FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M206.214 186.846L208.997 185.244L206.232 183.643L203.458 185.253L206.214 186.846Z",
    fill: "#2AF6FF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M200.997 189.866L203.771 188.265L201.014 186.663L198.231 188.273L200.997 189.866Z",
    fill: "#2AF6FF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M268.628 156.487L271.41 154.885L268.645 153.284L265.871 154.894L268.628 156.487Z",
    fill: "#2AF6FF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M263.41 159.507L266.184 157.906L263.427 156.304L260.644 157.914L263.41 159.507Z",
    fill: "#2AF6FF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M258.183 162.527L260.966 160.926L258.201 159.324L255.418 160.935L258.183 162.527Z",
    fill: "#FF63CE"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M252.957 165.548L255.74 163.937L252.974 162.345L250.191 163.955L252.957 165.548Z",
    fill: "#FF63CE"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.504 171.588L245.287 169.978L242.521 168.385L239.739 169.987L242.504 171.588Z",
    fill: "#2AF6FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M232.06 177.629L234.834 176.018L232.077 174.417L229.294 176.027L232.06 177.629Z",
    fill: "#FF63CE"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M226.833 180.64L229.616 179.039L226.851 177.437L224.068 179.047L226.833 180.64Z",
    fill: "#FF63CE"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M216.38 186.681L219.163 185.079L216.398 183.478L213.615 185.088L216.38 186.681Z",
    fill: "#2AF6FF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211.154 189.701L213.937 188.091L211.171 186.498L208.397 188.108L211.154 189.701Z",
    fill: "#2AF6FF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M205.936 192.721L208.71 191.111L205.953 189.518L203.171 191.128L205.936 192.721Z",
    fill: "#2AF6FF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.567 159.342L276.35 157.74L273.585 156.139L270.802 157.749L273.567 159.342Z",
    fill: "#2AF6FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M268.341 162.362L271.124 160.76L268.358 159.159L265.584 160.769L268.341 162.362Z",
    fill: "#2AF6FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M263.123 165.382L265.897 163.772L263.14 162.179L260.357 163.789L263.123 165.382Z",
    fill: "#FF63CE"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M257.897 168.402L260.679 166.792L257.914 165.199L255.131 166.801L257.897 168.402Z",
    fill: "#FF63CE"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M242.217 177.463L245 175.853L242.234 174.251L239.452 175.862L242.217 177.463Z",
    fill: "#FF63CE"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M236.991 180.475L239.773 178.873L237.008 177.272L234.234 178.882L236.991 180.475Z",
    fill: "#FF63CE"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M231.773 183.495L234.556 181.893L231.79 180.292L229.008 181.902L231.773 183.495Z",
    fill: "#FF63CE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M226.546 186.515L229.329 184.914L226.564 183.312L223.781 184.922L226.546 186.515Z",
    fill: "#FF63CE"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M216.094 192.556L218.876 190.946L216.111 189.353L213.328 190.954L216.094 192.556Z",
    fill: "#2AF6FF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M210.867 195.576L213.65 193.966L210.884 192.373L208.11 193.974L210.867 195.576Z",
    fill: "#2AF6FF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M278.507 162.197L281.289 160.586L278.524 158.994L275.741 160.604L278.507 162.197Z",
    fill: "#2AF6FF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M273.28 165.217L276.063 163.607L273.297 162.014L270.515 163.624L273.28 165.217Z",
    fill: "#2AF6FF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M268.054 168.237L270.836 166.627L268.071 165.034L265.297 166.636L268.054 168.237Z",
    fill: "#FF63CE"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M262.836 171.257L265.61 169.647L262.853 168.054L260.07 169.656L262.836 171.257Z",
    fill: "#FF63CE"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M247.157 180.309L249.939 178.708L247.174 177.106L244.391 178.717L247.157 180.309Z",
    fill: "#FF63CE"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M231.486 189.37L234.269 187.76L231.503 186.167L228.72 187.777L231.486 189.37Z",
    fill: "#FF63CE"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M221.033 195.411L223.816 193.8L221.05 192.208L218.268 193.809L221.033 195.411Z",
    fill: "#2AF6FF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M215.806 198.431L218.589 196.821L215.824 195.228L213.041 196.829L215.806 198.431Z",
    fill: "#2AF6FF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M283.446 165.052L286.229 163.441L283.463 161.848L280.681 163.45L283.446 165.052Z",
    fill: "#2AF6FF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M278.22 168.072L281.002 166.462L278.237 164.869L275.454 166.47L278.22 168.072Z",
    fill: "#2AF6FF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.993 171.092L275.776 169.482L273.01 167.889L270.228 169.49L272.993 171.092Z",
    fill: "#FF63CE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M267.766 174.112L270.549 172.502L267.784 170.901L265.01 172.511L267.766 174.112Z",
    fill: "#FF63CE"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M252.096 183.164L254.879 181.563L252.113 179.961L249.331 181.571L252.096 183.164Z",
    fill: "#FF63CE"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M246.869 186.185L249.652 184.583L246.887 182.981L244.104 184.592L246.869 186.185Z",
    fill: "#FF63CE"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M241.643 189.205L244.426 187.595L241.66 186.002L238.886 187.612L241.643 189.205Z",
    fill: "#FF63CE"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M236.425 192.225L239.199 190.615L236.443 189.022L233.66 190.623L236.425 192.225Z",
    fill: "#FF63CE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M225.972 198.265L228.755 196.655L225.99 195.062L223.207 196.664L225.972 198.265Z",
    fill: "#2AF6FF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M220.746 201.286L223.529 199.675L220.763 198.074L217.98 199.684L220.746 201.286Z",
    fill: "#2AF6FF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.386 167.906L291.168 166.296L288.403 164.703L285.62 166.305L288.386 167.906Z",
    fill: "#2AF6FF"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M283.159 170.927L285.942 169.316L283.176 167.724L280.394 169.325L283.159 170.927Z",
    fill: "#2AF6FF"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M277.932 173.947L280.715 172.337L277.95 170.735L275.167 172.345L277.932 173.947Z",
    fill: "#FF63CE"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M272.706 176.958L275.489 175.357L272.724 173.755L269.949 175.366L272.706 176.958Z",
    fill: "#FF63CE"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M262.262 182.999L265.045 181.397L262.279 179.796L259.496 181.406L262.262 182.999Z",
    fill: "#FF63CE"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M257.035 186.019L259.818 184.409L257.053 182.816L254.27 184.426L257.035 186.019Z",
    fill: "#FF63CE"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M251.809 189.039L254.592 187.429L251.826 185.836L249.043 187.447L251.809 189.039Z",
    fill: "#FF63CE"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M246.583 192.06L249.365 190.449L246.6 188.857L243.817 190.458L246.583 192.06Z",
    fill: "#FF63CE"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M241.356 195.08L244.139 193.47L241.373 191.877L238.599 193.478L241.356 195.08Z",
    fill: "#FF63CE"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M236.138 198.1L238.912 196.49L236.156 194.897L233.373 196.499L236.138 198.1Z",
    fill: "#FF63CE"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M230.912 201.12L233.695 199.51L230.929 197.909L228.146 199.519L230.912 201.12Z",
    fill: "#2AF6FF"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M225.685 204.132L228.468 202.53L225.703 200.929L222.92 202.539L225.685 204.132Z",
    fill: "#2AF6FF"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.325 170.761L296.108 169.151L293.342 167.558L290.56 169.16L293.325 170.761Z",
    fill: "#2AF6FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M288.098 173.781L290.881 172.171L288.116 170.57L285.333 172.18L288.098 173.781Z",
    fill: "#2AF6FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M282.872 176.793L285.655 175.192L282.889 173.59L280.106 175.2L282.872 176.793Z",
    fill: "#FF63CE"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M277.646 179.813L280.428 178.212L277.663 176.61L274.88 178.22L277.646 179.813Z",
    fill: "#FF63CE"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M267.201 185.854L269.975 184.244L267.219 182.651L264.436 184.261L267.201 185.854Z",
    fill: "#FF63CE"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M261.975 188.874L264.758 187.264L261.992 185.671L259.209 187.272L261.975 188.874Z",
    fill: "#FF63CE"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M246.295 197.935L249.078 196.325L246.313 194.723L243.53 196.333L246.295 197.935Z",
    fill: "#FF63CE"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M241.069 200.955L243.852 199.345L241.086 197.743L238.312 199.353L241.069 200.955Z",
    fill: "#FF63CE"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M235.851 203.967L238.625 202.365L235.869 200.763L233.086 202.374L235.851 203.967Z",
    fill: "#2AF6FF"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M230.625 206.987L233.408 205.385L230.642 203.784L227.859 205.394L230.625 206.987Z",
    fill: "#2AF6FF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M298.264 173.616L301.038 172.006L298.282 170.404L295.499 172.015L298.264 173.616Z",
    fill: "#2AF6FF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M293.038 176.628L295.821 175.026L293.055 173.425L290.272 175.035L293.038 176.628Z",
    fill: "#2AF6FF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.811 179.648L290.594 178.046L287.829 176.445L285.046 178.055L287.811 179.648Z",
    fill: "#FF63CE"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M282.585 182.668L285.368 181.067L282.602 179.465L279.82 181.075L282.585 182.668Z",
    fill: "#FF63CE"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M272.132 188.709L274.915 187.098L272.149 185.506L269.375 187.107L272.132 188.709Z",
    fill: "#FF63CE"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M266.914 191.729L269.688 190.119L266.932 188.526L264.149 190.127L266.914 191.729Z",
    fill: "#FF63CE"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M251.235 200.79L254.018 199.179L251.252 197.578L248.469 199.188L251.235 200.79Z",
    fill: "#FF63CE"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M246.008 203.801L248.791 202.2L246.026 200.598L243.243 202.208L246.008 203.801Z",
    fill: "#FF63CE"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.791 206.821L243.565 205.22L240.799 203.618L238.025 205.229L240.791 206.821Z",
    fill: "#2AF6FF"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M235.564 209.842L238.347 208.231L235.582 206.639L232.799 208.249L235.564 209.842Z",
    fill: "#2AF6FF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M303.195 176.462L305.978 174.861L303.213 173.259L300.439 174.869L303.195 176.462Z",
    fill: "#2AF6FF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.978 179.483L300.752 177.881L297.995 176.279L295.212 177.89L297.978 179.483Z",
    fill: "#2AF6FF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M292.751 182.503L295.534 180.901L292.768 179.3L289.986 180.91L292.751 182.503Z",
    fill: "#2AF6FF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.525 185.523L290.307 183.913L287.542 182.32L284.759 183.93L287.525 185.523Z",
    fill: "#2AF6FF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M282.298 188.543L285.081 186.933L282.316 185.34L279.533 186.942L282.298 188.543Z",
    fill: "#2AF6FF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.072 191.563L279.855 189.953L277.089 188.36L274.306 189.962L277.072 191.563Z",
    fill: "#2AF6FF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M271.845 194.584L274.628 192.974L271.863 191.381L269.089 192.982L271.845 194.584Z",
    fill: "#2AF6FF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M266.627 197.604L269.402 195.994L266.645 194.392L263.862 196.002L266.627 197.604Z",
    fill: "#2AF6FF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M261.401 200.616L264.184 199.014L261.419 197.412L258.636 199.023L261.401 200.616Z",
    fill: "#2AF6FF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250.948 206.656L253.731 205.054L250.966 203.453L248.183 205.063L250.948 206.656Z",
    fill: "#2AF6FF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M245.722 209.676L248.505 208.066L245.739 206.473L242.965 208.083L245.722 209.676Z",
    fill: "#2AF6FF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M240.504 212.696L243.278 211.086L240.521 209.493L237.739 211.104L240.504 212.696Z",
    fill: "#2AF6FF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M308.135 179.317L310.918 177.716L308.152 176.114L305.369 177.724L308.135 179.317Z",
    fill: "#2AF6FF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M302.908 182.337L305.691 180.727L302.926 179.134L300.152 180.745L302.908 182.337Z",
    fill: "#2AF6FF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M297.69 185.358L300.465 183.747L297.708 182.155L294.925 183.765L297.69 185.358Z",
    fill: "#2AF6FF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.464 188.378L295.247 186.768L292.482 185.175L289.699 186.776L292.464 188.378Z",
    fill: "#2AF6FF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287.238 191.398L290.02 189.788L287.255 188.195L284.472 189.797L287.238 191.398Z",
    fill: "#2AF6FF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M282.011 194.418L284.794 192.808L282.029 191.215L279.246 192.817L282.011 194.418Z",
    fill: "#2AF6FF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M276.785 197.439L279.568 195.828L276.802 194.227L274.019 195.837L276.785 197.439Z",
    fill: "#2AF6FF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M271.567 200.45L274.341 198.849L271.584 197.247L268.802 198.857L271.567 200.45Z",
    fill: "#2AF6FF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M266.341 203.47L269.123 201.869L266.358 200.267L263.575 201.878L266.341 203.47Z",
    fill: "#2AF6FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M261.114 206.491L263.897 204.889L261.131 203.288L258.349 204.898L261.114 206.491Z",
    fill: "#2AF6FF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M255.888 209.511L258.671 207.901L255.905 206.308L253.122 207.918L255.888 209.511Z",
    fill: "#2AF6FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M250.661 212.531L253.444 210.921L250.679 209.328L247.896 210.93L250.661 212.531Z",
    fill: "#2AF6FF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M245.435 215.551L248.217 213.941L245.452 212.348L242.678 213.95L245.435 215.551Z",
    fill: "#2AF6FF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M313.074 182.172L315.857 180.562L313.091 178.969L310.309 180.579L313.074 182.172Z",
    fill: "#2AF6FF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M307.848 185.192L310.63 183.582L307.865 181.989L305.082 183.591L307.848 185.192Z",
    fill: "#2AF6FF"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M302.621 188.213L305.404 186.602L302.639 185.009L299.865 186.611L302.621 188.213Z",
    fill: "#2AF6FF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M297.403 191.233L300.177 189.623L297.421 188.03L294.638 189.631L297.403 191.233Z",
    fill: "#2AF6FF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M292.177 194.253L294.96 192.643L292.194 191.041L289.412 192.651L292.177 194.253Z",
    fill: "#2AF6FF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M286.95 197.273L289.733 195.663L286.968 194.062L284.185 195.672L286.95 197.273Z",
    fill: "#2AF6FF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M281.724 200.285L284.507 198.683L281.742 197.082L278.959 198.692L281.724 200.285Z",
    fill: "#2AF6FF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.498 203.305L279.28 201.704L276.515 200.102L273.741 201.712L276.498 203.305Z",
    fill: "#2AF6FF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.28 206.325L274.054 204.724L271.297 203.122L268.514 204.732L271.28 206.325Z",
    fill: "#2AF6FF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M266.053 209.346L268.836 207.735L266.071 206.142L263.288 207.753L266.053 209.346Z",
    fill: "#2AF6FF"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M260.827 212.366L263.61 210.756L260.844 209.163L258.062 210.764L260.827 212.366Z",
    fill: "#2AF6FF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M255.6 215.386L258.383 213.776L255.618 212.183L252.835 213.784L255.6 215.386Z",
    fill: "#2AF6FF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M250.374 218.406L253.157 216.796L250.391 215.203L247.609 216.805L250.374 218.406Z",
    fill: "#2AF6FF"
  }))), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M323.623 207.065L330.014 203.296L340.32 209.537C341.076 209.99 341.45 210.886 341.25 211.739L339.998 222.984L336.119 215.107C335.354 214.167 334.432 213.367 333.38 212.757L323.614 207.065H323.623Z",
    fill: "url(#paint32_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M336.624 214.446C335.858 213.506 334.937 212.714 333.884 212.096L324.44 206.586L323.623 207.065L333.389 212.757C334.432 213.367 335.363 214.159 336.128 215.107L340.007 222.984L340.059 222.767L336.624 214.446Z",
    fill: "url(#paint33_radial_812_1630)"
  }), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M311.335 214.176L317.727 210.407L328.032 216.648C328.788 217.101 329.162 217.997 328.962 218.85L327.71 230.096L323.831 222.219C323.066 221.279 322.144 220.486 321.092 219.868L311.326 214.176H311.335Z",
    fill: "url(#paint34_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M324.336 221.557C323.571 220.617 322.649 219.825 321.597 219.207L312.152 213.697L311.335 214.176L321.101 219.868C322.144 220.478 323.075 221.27 323.84 222.219L327.719 230.096L327.771 229.878L324.336 221.557Z",
    fill: "url(#paint35_radial_812_1630)"
  }), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M299.047 221.279L305.439 217.51L315.744 223.75C316.5 224.203 316.874 225.1 316.674 225.952L315.422 237.198L311.544 229.321C310.778 228.381 309.856 227.58 308.804 226.971L299.038 221.279H299.047Z",
    fill: "url(#paint36_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M312.039 228.659C311.274 227.719 310.352 226.927 309.3 226.309L299.856 220.8L299.038 221.279L308.804 226.971C309.848 227.58 310.778 228.372 311.544 229.321L315.422 237.198L315.474 236.98L312.039 228.659Z",
    fill: "url(#paint37_radial_812_1630)"
  }), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M286.751 228.39L293.142 224.621L303.447 230.861C304.204 231.314 304.578 232.211 304.378 233.064L303.126 244.309L299.247 236.432C298.482 235.492 297.56 234.691 296.508 234.082L286.742 228.39H286.751Z",
    fill: "url(#paint38_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M299.752 235.77C298.986 234.83 298.065 234.038 297.012 233.42L287.568 227.911L286.751 228.39L296.517 234.082C297.56 234.691 298.491 235.483 299.256 236.432L303.134 244.309L303.187 244.091L299.752 235.77Z",
    fill: "url(#paint39_radial_812_1630)"
  }), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M274.463 235.501L280.855 231.732L291.16 237.973C291.916 238.425 292.29 239.322 292.09 240.175L290.838 251.42L286.959 243.543C286.194 242.603 285.272 241.811 284.22 241.193L274.454 235.501H274.463Z",
    fill: "url(#paint40_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M287.464 242.882C286.699 241.941 285.777 241.149 284.725 240.531L275.28 235.022L274.463 235.501L284.229 241.193C285.272 241.802 286.203 242.594 286.968 243.543L290.847 251.42L290.899 251.202L287.464 242.882Z",
    fill: "url(#paint41_radial_812_1630)"
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M262.175 242.603L268.567 238.834L278.872 245.075C279.628 245.528 280.002 246.424 279.802 247.277L278.55 258.522L274.671 250.645C273.906 249.705 272.984 248.905 271.932 248.295L262.166 242.603H262.175Z",
    fill: "url(#paint42_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M275.167 249.984C274.402 249.044 273.48 248.252 272.428 247.634L262.984 242.124L262.166 242.603L271.932 248.295C272.976 248.905 273.906 249.697 274.671 250.645L278.55 258.522L278.602 258.305L275.167 249.984Z",
    fill: "url(#paint43_radial_812_1630)"
  }), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M175.499 207.065L169.108 203.296L158.802 209.537C158.046 209.99 157.672 210.886 157.872 211.739L159.124 222.984L163.003 215.107C163.768 214.167 164.69 213.367 165.742 212.757L175.508 207.065H175.499Z",
    fill: "url(#paint44_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M162.498 214.446C163.264 213.506 164.185 212.714 165.238 212.096L174.682 206.586L175.499 207.065L165.733 212.757C164.69 213.367 163.759 214.159 162.994 215.107L159.115 222.984L159.063 222.767L162.498 214.446Z",
    fill: "url(#paint45_radial_812_1630)"
  }), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M187.787 214.176L181.395 210.407L171.09 216.648C170.334 217.101 169.96 217.997 170.16 218.85L171.412 230.096L175.291 222.219C176.056 221.279 176.978 220.486 178.03 219.868L187.796 214.176H187.787Z",
    fill: "url(#paint46_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M174.795 221.557C175.56 220.617 176.482 219.825 177.534 219.207L186.978 213.697L187.796 214.176L178.03 219.868C176.986 220.478 176.056 221.27 175.291 222.219L171.412 230.096L171.36 229.878L174.795 221.557Z",
    fill: "url(#paint47_radial_812_1630)"
  }), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M200.084 221.279L193.692 217.51L183.387 223.75C182.63 224.203 182.256 225.1 182.456 225.952L183.708 237.198L187.587 229.321C188.352 228.381 189.274 227.58 190.318 226.971L200.084 221.279Z",
    fill: "url(#paint48_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M187.082 228.659C187.848 227.719 188.77 226.927 189.822 226.309L199.266 220.8L200.083 221.279L190.318 226.971C189.274 227.58 188.343 228.372 187.578 229.321L183.7 237.198L183.647 236.98L187.082 228.659Z",
    fill: "url(#paint49_radial_812_1630)"
  }), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M212.371 228.39L205.98 224.621L195.675 230.861C194.918 231.314 194.544 232.211 194.744 233.064L195.996 244.309L199.875 236.432C200.64 235.492 201.562 234.691 202.614 234.082L212.38 228.39H212.371Z",
    fill: "url(#paint50_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M199.37 235.77C200.136 234.83 201.057 234.038 202.11 233.42L211.554 227.911L212.371 228.39L202.605 234.082C201.562 234.691 200.631 235.483 199.866 236.432L195.987 244.309L195.935 244.091L199.37 235.77Z",
    fill: "url(#paint51_radial_812_1630)"
  }), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M224.659 235.501L218.267 231.732L207.962 237.973C207.206 238.425 206.832 239.322 207.032 240.175L208.284 251.42L212.163 243.543C212.928 242.603 213.85 241.811 214.902 241.193L224.668 235.501H224.659Z",
    fill: "url(#paint52_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M211.667 242.882C212.432 241.941 213.354 241.149 214.406 240.531L223.85 235.022L224.668 235.501L214.902 241.193C213.858 241.802 212.928 242.594 212.163 243.543L208.284 251.42L208.232 251.202L211.667 242.882Z",
    fill: "url(#paint53_radial_812_1630)"
  }), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M236.956 242.603L230.564 238.834L220.259 245.075C219.502 245.528 219.128 246.424 219.328 247.277L220.581 258.522L224.459 250.645C225.225 249.705 226.146 248.905 227.19 248.295L236.956 242.603Z",
    fill: "url(#paint54_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M223.955 249.984C224.72 249.044 225.642 248.252 226.694 247.634L236.138 242.124L236.956 242.603L227.19 248.295C226.146 248.905 225.216 249.697 224.45 250.645L220.572 258.522L220.52 258.305L223.955 249.984Z",
    fill: "url(#paint55_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M315.848 86.0726L250.226 47.8278L183.726 85.2631V180.005L249.983 218.624L315.848 180.692V86.0726Z",
    fill: "url(#paint56_linear_812_1630)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M342.798 311.999C344.094 311.25 345.729 310.85 347.364 310.867C348.024 310.867 348.651 310.963 349.233 311.094C349.859 311.242 350.59 311.538 351.094 311.825L390.862 334.803C392.228 335.595 392.941 336.848 392.862 338.206C392.836 338.589 392.749 338.964 392.619 339.329C392.271 340.295 391.288 341.322 390.175 341.966L367.843 354.874C367.565 355.04 367.191 355.222 366.887 355.353C365.808 355.797 364.582 356.049 363.347 356.058C361.93 356.058 360.643 355.762 359.634 355.179L319.718 332.114C318.344 331.322 317.64 330.068 317.727 328.702C317.744 328.371 317.822 328.049 317.918 327.736C318.24 326.708 319.257 325.62 320.423 324.942L342.807 312.008L342.798 311.999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M342.902 312.173C344.198 311.425 345.833 311.033 347.45 311.076C348.111 311.094 348.729 311.198 349.303 311.337C349.868 311.477 350.694 311.834 351.146 312.095L390.758 334.986C392.114 335.769 392.758 337.014 392.593 338.346C392.549 338.711 392.428 339.059 392.288 339.416C391.949 340.278 390.819 341.366 389.819 341.94L367.808 354.665C367.556 354.813 367.147 355.022 366.869 355.135C365.808 355.579 364.608 355.84 363.382 355.849C361.991 355.866 360.712 355.571 359.721 354.996L319.805 331.931C318.44 331.139 317.805 329.885 317.988 328.562C318.031 328.249 318.127 327.944 318.231 327.64C318.553 326.726 319.727 325.56 320.779 324.959L342.894 312.182L342.902 312.173Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M342.998 312.347C344.285 311.599 345.937 311.224 347.538 311.277C348.19 311.303 348.807 311.424 349.381 311.572C349.877 311.703 350.799 312.121 351.207 312.356L390.671 335.16C392.028 335.943 392.593 337.179 392.341 338.476C392.271 338.824 392.132 339.155 391.984 339.494C391.654 340.243 390.375 341.401 389.488 341.914L367.791 354.448C367.565 354.578 367.113 354.813 366.861 354.918C365.826 355.362 364.634 355.631 363.434 355.649C362.069 355.675 360.799 355.388 359.825 354.822L319.91 331.757C318.544 330.965 317.988 329.72 318.257 328.423C318.318 328.127 318.44 327.84 318.562 327.544C318.875 326.743 320.223 325.507 321.153 324.968L343.007 312.338L342.998 312.347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M343.094 312.512C344.381 311.773 346.033 311.407 347.616 311.477C348.268 311.512 348.877 311.651 349.442 311.799C349.877 311.921 350.894 312.399 351.242 312.6L390.558 335.317C391.906 336.091 392.41 337.327 392.071 338.581C391.984 338.911 391.81 339.216 391.654 339.547C391.349 340.199 389.906 341.409 389.132 341.862L367.756 354.213C367.556 354.326 367.061 354.587 366.843 354.683C365.826 355.127 364.66 355.405 363.478 355.431C362.13 355.457 360.877 355.188 359.921 354.639L320.005 331.574C318.648 330.791 318.161 329.546 318.527 328.275C318.605 327.988 318.753 327.727 318.883 327.44C319.179 326.752 320.701 325.446 321.518 324.976L343.102 312.504L343.094 312.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M343.198 312.687C344.485 311.947 346.146 311.59 347.711 311.686C348.364 311.729 348.964 311.886 349.52 312.042C349.894 312.147 350.999 312.695 351.303 312.869L390.462 335.499C391.801 336.274 392.236 337.493 391.81 338.72C391.697 339.033 391.506 339.312 391.341 339.634C391.054 340.182 389.453 341.462 388.784 341.845L367.73 354.013C367.565 354.108 367.017 354.396 366.834 354.483C365.834 354.926 364.686 355.214 363.53 355.248C362.208 355.283 360.964 355.022 360.025 354.483L320.109 331.417C318.753 330.634 318.335 329.389 318.796 328.162C318.901 327.892 319.075 327.657 319.205 327.37C319.483 326.787 321.188 325.42 321.883 325.011L343.198 312.695V312.687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M343.294 312.861C344.572 312.121 346.242 311.781 347.79 311.894C348.442 311.947 349.033 312.121 349.581 312.286C349.885 312.382 351.086 312.991 351.346 313.13L390.358 335.673C391.688 336.439 392.062 337.658 391.541 338.85C391.41 339.146 391.245 339.442 391.01 339.712C390.845 340.199 388.984 341.496 388.427 341.818L367.687 353.804C367.548 353.882 366.965 354.204 366.808 354.274C365.826 354.709 364.704 355.013 363.565 355.048C362.26 355.092 361.034 354.848 360.104 354.308L320.188 331.243C318.84 330.46 318.483 329.224 319.049 328.023C319.17 327.77 319.309 327.518 319.509 327.283C319.657 326.769 321.649 325.377 322.231 325.037L343.285 312.869L343.294 312.861Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M343.398 313.035C344.676 312.295 346.355 311.973 347.885 312.095C348.538 312.156 349.12 312.338 349.668 312.512C349.912 312.591 351.207 313.261 351.407 313.383L390.271 335.839C391.593 336.605 391.915 337.815 391.297 338.972C391.149 339.251 390.958 339.529 390.714 339.782C390.584 340.173 388.549 341.522 388.106 341.775L367.687 353.577C367.574 353.638 366.948 353.986 366.826 354.039C365.869 354.474 364.756 354.787 363.634 354.831C362.356 354.883 361.138 354.648 360.225 354.117L320.309 331.052C318.962 330.277 318.666 329.041 319.344 327.866C319.483 327.631 319.649 327.387 319.857 327.17C319.97 326.752 322.153 325.307 322.623 325.037L343.407 313.026L343.398 313.035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M343.494 313.209C344.763 312.478 346.459 312.156 347.964 312.304C348.607 312.365 349.19 312.573 349.729 312.756C349.912 312.817 351.294 313.557 351.451 313.644L390.158 336.013C391.48 336.779 391.732 337.98 391.019 339.103C390.854 339.364 390.645 339.625 390.375 339.86C390.28 340.156 388.071 341.557 387.74 341.749L367.643 353.36C367.556 353.412 366.895 353.778 366.8 353.821C365.861 354.256 364.774 354.578 363.669 354.631C362.417 354.691 361.208 354.465 360.312 353.952L320.397 330.886C319.049 330.112 318.823 328.876 319.596 327.744C319.753 327.518 319.936 327.3 320.162 327.091C320.249 326.778 322.623 325.264 322.971 325.063L343.485 313.209H343.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M343.598 313.383C344.868 312.652 346.563 312.347 348.059 312.512C348.703 312.582 349.277 312.808 349.807 313C349.929 313.043 351.407 313.853 351.503 313.914L390.062 336.196C391.375 336.953 391.575 338.154 390.758 339.233C390.575 339.477 390.34 339.721 390.062 339.938C390.001 340.13 387.619 341.592 387.401 341.723L367.626 353.151C367.574 353.186 366.861 353.586 366.8 353.612C365.878 354.047 364.817 354.378 363.73 354.43C362.495 354.5 361.304 354.282 360.425 353.778L320.509 330.712C319.17 329.938 318.996 328.702 319.883 327.605C320.057 327.396 320.257 327.187 320.501 326.996C320.562 326.787 323.118 325.211 323.353 325.081L343.607 313.383H343.598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M343.694 313.557C344.963 312.826 346.668 312.539 348.138 312.721C348.781 312.8 349.346 313.043 349.868 313.244C349.929 313.27 351.494 314.149 351.547 314.184L389.958 336.379C391.262 337.136 391.41 338.337 390.488 339.373C390.288 339.599 390.036 339.825 389.732 340.025C389.697 340.121 387.149 341.636 387.036 341.705L367.574 352.951C367.574 352.951 366.791 353.395 366.765 353.412C365.861 353.847 364.817 354.187 363.756 354.248C362.547 354.326 361.365 354.117 360.504 353.621L320.588 330.556C319.249 329.781 319.136 328.536 320.136 327.483C320.318 327.283 320.544 327.091 320.805 326.917C320.831 326.813 323.579 325.177 323.701 325.107L343.685 313.557H343.694Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.617 353.438L320.701 330.373C319.127 329.459 319.318 327.875 321.144 326.822L343.798 313.731C345.616 312.678 348.372 312.565 349.946 313.479L389.862 336.544C391.436 337.458 391.245 339.042 389.419 340.095L366.765 353.186C364.948 354.239 362.191 354.352 360.617 353.438Z",
    fill: "black"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M360.617 353.403L320.701 330.338C319.996 329.929 319.649 329.389 319.64 328.824C319.64 328.806 319.64 326.865 319.64 326.848C319.649 326.16 320.162 327.353 321.144 326.787L343.798 313.696C345.616 312.643 348.372 312.53 349.946 313.444L389.862 336.509C390.393 336.814 390.767 335.526 390.906 335.935C390.949 336.074 390.923 337.884 390.923 338.024C390.941 338.729 390.427 339.477 389.419 340.06L366.765 353.151C364.947 354.204 362.191 354.317 360.617 353.403Z",
    fill: "url(#paint57_linear_812_1630)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M360.617 351.462L320.701 328.397C319.127 327.483 319.318 325.899 321.144 324.846L343.798 311.755C345.616 310.702 348.372 310.589 349.946 311.503L389.862 334.568C391.436 335.482 391.245 337.066 389.419 338.119L366.765 351.21C364.948 352.263 362.191 352.376 360.617 351.462Z",
    fill: "url(#paint58_linear_812_1630)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.923 339.077C390.923 339.773 390.419 340.513 389.419 341.087L366.765 354.178C364.947 355.231 362.191 355.344 360.617 354.43L320.701 331.365C319.935 330.921 319.596 330.329 319.649 329.703C319.649 329.729 319.649 329.772 319.649 329.816C319.649 329.833 319.649 331.774 319.649 331.792C319.657 332.357 320.014 332.897 320.709 333.306L360.625 356.371C362.199 357.285 364.956 357.172 366.774 356.119L389.427 343.028C390.436 342.445 390.949 341.697 390.932 340.992C390.932 340.87 390.949 339.564 390.932 339.077H390.923Z",
    fill: "url(#paint59_linear_812_1630)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M363.286 351.28C362.391 351.28 361.582 351.097 361.017 350.775L321.101 327.709C320.849 327.57 320.431 327.266 320.431 326.856C320.431 326.447 320.849 325.934 321.536 325.533L344.189 312.443C345.024 311.955 346.155 311.677 347.268 311.677C348.164 311.677 348.972 311.86 349.538 312.182L389.453 335.247C389.706 335.395 390.123 335.691 390.123 336.1C390.123 336.509 389.706 337.023 389.019 337.423L366.365 350.514C365.521 351.001 364.399 351.28 363.286 351.28Z",
    fill: "url(#paint60_linear_812_1630)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M389.419 337.78L366.765 350.87C364.948 351.924 362.191 352.037 360.617 351.123L320.701 328.058C320.049 327.683 319.701 327.187 319.649 326.656C319.57 327.3 319.91 327.927 320.701 328.388L360.617 351.454C362.191 352.368 364.948 352.254 366.765 351.201L389.419 338.111C390.48 337.493 390.993 336.692 390.915 335.952C390.836 336.596 390.332 337.249 389.419 337.78Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M377.548 347.11C379.357 351.523 375.444 357.311 368.809 360.036C362.173 362.769 355.321 361.402 353.512 356.998C351.703 352.585 355.616 346.797 362.252 344.073C368.887 341.34 375.739 342.706 377.548 347.11Z",
    fill: "url(#paint61_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M352.321 316.803C353.381 319.876 350.016 323.827 344.816 325.612C339.615 327.405 334.537 326.36 333.476 323.288C332.415 320.215 335.78 316.264 340.981 314.48C346.181 312.687 351.26 313.731 352.321 316.803Z",
    fill: "url(#paint62_radial_812_1630)"
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M367.713 342.959L335.302 324.228C334.65 323.854 334.737 323.201 335.484 322.766L347.651 315.733C348.398 315.298 349.538 315.254 350.181 315.628L382.592 334.359C383.244 334.733 383.157 335.386 382.41 335.821L370.243 342.854C369.496 343.289 368.356 343.333 367.713 342.959Z",
    fill: "url(#paint63_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M348.355 317.108L350.433 318.309C350.694 318.466 351.12 318.466 351.39 318.309C351.651 318.161 351.651 317.909 351.39 317.761L349.311 316.56C349.051 316.403 348.624 316.403 348.355 316.56C348.094 316.708 348.094 316.96 348.355 317.108ZM351.912 319.162L352.894 319.728C353.155 319.885 353.581 319.885 353.851 319.728C354.112 319.58 354.112 319.328 353.851 319.18L352.868 318.614C352.607 318.457 352.181 318.457 351.912 318.614C351.651 318.762 351.651 319.014 351.912 319.162ZM354.373 320.59L355.355 321.155C355.616 321.312 356.042 321.312 356.312 321.155C356.573 321.007 356.573 320.755 356.312 320.607L355.329 320.041C355.068 319.885 354.642 319.885 354.373 320.041C354.112 320.189 354.112 320.442 354.373 320.59ZM356.834 322.017L357.816 322.583C358.077 322.74 358.503 322.74 358.773 322.583C359.034 322.435 359.034 322.182 358.773 322.034L357.79 321.469C357.529 321.312 357.103 321.312 356.834 321.469C356.573 321.617 356.573 321.869 356.834 322.017ZM359.295 323.445L360.277 324.01C360.538 324.167 360.964 324.167 361.234 324.01C361.495 323.862 361.495 323.61 361.234 323.462L360.251 322.896C359.99 322.74 359.564 322.74 359.295 322.896C359.034 323.044 359.034 323.297 359.295 323.445ZM361.756 324.872L362.738 325.438C362.999 325.594 363.425 325.594 363.695 325.438C363.956 325.29 363.956 325.037 363.695 324.889L362.712 324.324C362.451 324.167 362.025 324.167 361.756 324.324C361.495 324.472 361.495 324.724 361.756 324.872ZM364.217 326.299L365.2 326.865C365.46 327.022 365.887 327.022 366.156 326.865C366.426 326.708 366.417 326.465 366.156 326.317L365.173 325.751C364.913 325.594 364.486 325.594 364.217 325.751C363.956 325.899 363.956 326.151 364.217 326.299ZM366.678 327.727L367.661 328.293C367.921 328.449 368.348 328.449 368.617 328.293C368.878 328.145 368.878 327.892 368.617 327.744L367.634 327.178C367.374 327.022 366.947 327.022 366.678 327.178C366.417 327.326 366.417 327.579 366.678 327.727ZM369.139 329.154L370.122 329.72C370.382 329.877 370.809 329.877 371.078 329.72C371.339 329.572 371.339 329.32 371.078 329.172L370.095 328.606C369.835 328.449 369.409 328.449 369.139 328.606C368.878 328.754 368.878 329.006 369.139 329.154ZM371.6 330.582L372.583 331.147C372.844 331.304 373.27 331.304 373.539 331.147C373.8 330.999 373.8 330.747 373.539 330.599L372.557 330.033C372.296 329.877 371.87 329.877 371.6 330.033C371.339 330.181 371.339 330.434 371.6 330.582ZM374.061 332.009L375.044 332.575C375.305 332.732 375.731 332.732 376 332.575C376.261 332.427 376.261 332.175 376 332.027L375.018 331.461C374.757 331.304 374.331 331.304 374.061 331.461C373.8 331.609 373.8 331.861 374.061 332.009ZM376.522 333.437L377.505 334.002C377.766 334.159 378.192 334.159 378.461 334.002C378.722 333.854 378.722 333.602 378.461 333.454L377.479 332.888C377.218 332.732 376.792 332.732 376.522 332.888C376.261 333.036 376.261 333.289 376.522 333.437ZM379.035 334.89L380.018 335.456C380.279 335.613 380.705 335.613 380.975 335.456C381.235 335.308 381.235 335.055 380.975 334.908L379.992 334.342C379.731 334.185 379.305 334.185 379.035 334.342C378.774 334.49 378.774 334.742 379.035 334.89ZM346.12 318.509L346.972 319.006C347.276 319.18 347.755 319.18 348.059 319.006L348.903 318.518C349.198 318.344 349.198 318.066 348.903 317.891L348.05 317.395C347.746 317.221 347.268 317.221 346.963 317.395L346.12 317.883C345.824 318.057 345.824 318.335 346.12 318.509ZM350.52 320.424L351.364 319.937C351.659 319.763 351.659 319.484 351.364 319.31L350.512 318.814C350.207 318.64 349.729 318.64 349.424 318.814L348.581 319.301C348.285 319.476 348.285 319.754 348.581 319.928L349.433 320.424C349.738 320.598 350.216 320.598 350.52 320.424ZM351.042 321.356L351.894 321.852C352.199 322.026 352.677 322.026 352.981 321.852L353.825 321.364C354.12 321.19 354.12 320.912 353.825 320.738L352.973 320.241C352.668 320.067 352.19 320.067 351.886 320.241L351.042 320.729C350.746 320.903 350.746 321.182 351.042 321.356ZM353.503 322.783L354.355 323.279C354.66 323.453 355.138 323.453 355.442 323.279L356.286 322.792C356.582 322.618 356.582 322.339 356.286 322.165L355.434 321.669C355.129 321.495 354.651 321.495 354.347 321.669L353.503 322.156C353.207 322.33 353.207 322.609 353.503 322.783ZM358.747 323.584L357.895 323.088C357.59 322.914 357.112 322.914 356.808 323.088L355.964 323.575C355.668 323.749 355.668 324.028 355.964 324.202L356.816 324.698C357.121 324.872 357.599 324.872 357.903 324.698L358.747 324.21C359.043 324.036 359.043 323.758 358.747 323.584ZM361.208 325.011L360.356 324.515C360.051 324.341 359.573 324.341 359.269 324.515L358.425 325.003C358.129 325.177 358.129 325.455 358.425 325.629L359.277 326.125C359.582 326.299 360.06 326.299 360.364 326.125L361.208 325.638C361.504 325.464 361.504 325.185 361.208 325.011ZM363.669 326.439L362.817 325.943C362.512 325.768 362.034 325.768 361.73 325.943L360.886 326.43C360.59 326.604 360.59 326.883 360.886 327.057L361.738 327.553C362.043 327.727 362.521 327.727 362.825 327.553L363.669 327.065C363.965 326.891 363.965 326.613 363.669 326.439ZM366.13 327.866L365.278 327.37C364.973 327.196 364.495 327.196 364.191 327.37L363.347 327.857C363.052 328.031 363.052 328.31 363.347 328.484L364.199 328.98C364.504 329.154 364.982 329.154 365.286 328.98L366.13 328.493C366.426 328.319 366.426 328.04 366.13 327.866ZM368.591 329.294L367.739 328.797C367.434 328.623 366.956 328.623 366.652 328.797L365.808 329.285C365.513 329.459 365.513 329.737 365.808 329.912L366.66 330.408C366.965 330.582 367.443 330.582 367.748 330.408L368.591 329.92C368.887 329.746 368.887 329.468 368.591 329.294ZM371.052 330.721L370.2 330.225C369.896 330.051 369.417 330.051 369.113 330.225L368.269 330.712C367.974 330.886 367.974 331.165 368.269 331.339L369.122 331.835C369.426 332.009 369.904 332.009 370.209 331.835L371.052 331.348C371.348 331.174 371.348 330.895 371.052 330.721ZM370.739 332.766L371.591 333.263C371.896 333.437 372.374 333.437 372.678 333.263L373.522 332.775C373.817 332.601 373.817 332.322 373.522 332.148L372.67 331.652C372.365 331.478 371.887 331.478 371.583 331.652L370.739 332.14C370.443 332.314 370.443 332.592 370.739 332.766ZM375.983 333.567L375.131 333.071C374.826 332.897 374.348 332.897 374.044 333.071L373.2 333.558C372.904 333.733 372.904 334.011 373.2 334.185L374.052 334.681C374.357 334.855 374.835 334.855 375.139 334.681L375.983 334.194C376.279 334.02 376.279 333.741 375.983 333.567ZM379.592 335.656L377.644 334.533C377.34 334.359 376.861 334.359 376.557 334.533L375.713 335.021C375.418 335.195 375.418 335.473 375.713 335.647L377.661 336.77C377.966 336.944 378.444 336.944 378.748 336.77L379.592 336.283C379.888 336.109 379.888 335.83 379.592 335.656ZM343.833 319.859L345.781 320.981C346.085 321.155 346.563 321.155 346.868 320.981L347.711 320.494C348.007 320.32 348.007 320.041 347.711 319.867L345.763 318.744C345.459 318.57 344.981 318.57 344.676 318.744L343.833 319.232C343.537 319.406 343.537 319.684 343.833 319.859ZM347.39 321.913L348.242 322.409C348.546 322.583 349.024 322.583 349.329 322.409L350.172 321.921C350.468 321.747 350.468 321.469 350.172 321.295L349.32 320.799C349.016 320.624 348.537 320.624 348.233 320.799L347.39 321.286C347.094 321.46 347.094 321.739 347.39 321.913ZM350.703 323.827C351.007 324.002 351.485 324.002 351.79 323.827L352.633 323.34C352.929 323.166 352.929 322.887 352.633 322.713L351.781 322.217C351.477 322.043 350.998 322.043 350.694 322.217L349.851 322.705C349.555 322.879 349.555 323.157 349.851 323.331L350.703 323.827ZM353.164 325.255C353.468 325.429 353.947 325.429 354.251 325.255L355.094 324.768C355.39 324.593 355.39 324.315 355.094 324.141L354.242 323.645C353.938 323.471 353.46 323.471 353.155 323.645L352.312 324.132C352.016 324.306 352.016 324.585 352.312 324.759L353.164 325.255ZM355.616 325.072L354.773 325.56C354.477 325.734 354.477 326.012 354.773 326.186L355.625 326.682C355.929 326.856 356.408 326.856 356.712 326.682L357.555 326.195C357.851 326.021 357.851 325.742 357.555 325.568L356.703 325.072C356.399 324.898 355.921 324.898 355.616 325.072ZM358.129 326.465L357.182 327.013C356.912 327.17 356.912 327.422 357.182 327.579L358.138 328.136C358.408 328.293 358.851 328.293 359.121 328.136L360.069 327.588C360.338 327.431 360.338 327.178 360.069 327.022L359.112 326.465C358.843 326.308 358.399 326.308 358.129 326.465ZM360.59 327.892L359.643 328.441C359.373 328.597 359.373 328.85 359.643 329.006L360.599 329.563C360.869 329.72 361.312 329.72 361.582 329.563L362.53 329.015C362.799 328.858 362.799 328.606 362.53 328.449L361.573 327.892C361.304 327.736 360.86 327.736 360.59 327.892ZM363.052 329.32L362.104 329.868C361.834 330.025 361.834 330.277 362.104 330.434L363.06 330.991C363.33 331.147 363.773 331.147 364.043 330.991L364.991 330.442C365.26 330.286 365.26 330.033 364.991 329.877L364.034 329.32C363.765 329.163 363.321 329.163 363.052 329.32ZM365.513 330.747L364.565 331.295C364.295 331.452 364.295 331.705 364.565 331.861L365.521 332.418C365.791 332.575 366.234 332.575 366.504 332.418L367.452 331.87C367.721 331.713 367.721 331.461 367.452 331.304L366.495 330.747C366.226 330.59 365.782 330.59 365.513 330.747ZM367.974 332.175L367.026 332.723C366.756 332.88 366.756 333.132 367.026 333.289L367.982 333.846C368.252 334.002 368.695 334.002 368.965 333.846L369.913 333.297C370.182 333.141 370.182 332.888 369.913 332.732L368.956 332.183C368.687 332.027 368.243 332.027 367.974 332.183V332.175ZM371.426 335.264L372.374 334.716C372.644 334.559 372.644 334.307 372.374 334.15L371.417 333.593C371.148 333.437 370.704 333.437 370.435 333.593L369.487 334.142C369.217 334.298 369.217 334.551 369.487 334.707L370.443 335.264C370.713 335.421 371.156 335.421 371.426 335.264ZM373.887 336.692L374.835 336.143C375.105 335.987 375.105 335.734 374.835 335.578L373.878 335.021C373.609 334.864 373.165 334.864 372.896 335.021L371.948 335.569C371.678 335.726 371.678 335.978 371.948 336.135L372.904 336.683C373.174 336.84 373.617 336.84 373.887 336.683V336.692ZM377.348 337.031L376.392 336.474C376.122 336.318 375.679 336.318 375.409 336.474L374.461 337.023C374.191 337.179 374.191 337.432 374.461 337.588L375.418 338.145C375.687 338.302 376.131 338.302 376.4 338.145L377.348 337.597C377.618 337.44 377.618 337.188 377.348 337.031ZM341.485 321.173L344.572 322.957C344.842 323.114 345.285 323.114 345.555 322.957L346.503 322.409C346.772 322.252 346.772 322 346.503 321.843L343.415 320.059C343.146 319.902 342.702 319.902 342.433 320.059L341.485 320.607C341.215 320.764 341.215 321.016 341.485 321.173ZM346.076 323.827L347.033 324.385C347.303 324.541 347.746 324.541 348.016 324.385L348.964 323.836C349.233 323.68 349.233 323.427 348.964 323.27L348.007 322.713C347.737 322.557 347.294 322.557 347.024 322.713L346.076 323.262C345.807 323.418 345.807 323.671 346.076 323.827ZM348.537 325.255L349.494 325.812C349.764 325.969 350.207 325.969 350.477 325.812L351.425 325.264C351.694 325.107 351.694 324.855 351.425 324.698L350.468 324.141C350.198 323.984 349.755 323.984 349.485 324.141L348.537 324.689C348.268 324.846 348.268 325.098 348.537 325.255ZM350.999 326.682L351.955 327.239C352.225 327.396 352.668 327.396 352.938 327.239L353.886 326.691C354.155 326.534 354.155 326.282 353.886 326.125L352.929 325.568C352.659 325.412 352.216 325.412 351.946 325.568L350.999 326.117C350.729 326.273 350.729 326.526 350.999 326.682ZM355.399 328.658L356.347 328.11C356.616 327.953 356.616 327.701 356.347 327.544L355.39 326.996C355.121 326.839 354.677 326.839 354.407 326.996L353.46 327.544C353.19 327.701 353.19 327.953 353.46 328.11L354.416 328.667C354.686 328.824 355.129 328.824 355.399 328.667V328.658ZM357.86 330.086L358.808 329.537C359.077 329.381 359.077 329.128 358.808 328.971L357.851 328.414C357.582 328.258 357.138 328.258 356.868 328.414L355.921 328.963C355.651 329.119 355.651 329.372 355.921 329.529L356.877 330.086C357.147 330.242 357.59 330.242 357.86 330.086ZM360.321 331.513L361.269 330.965C361.538 330.808 361.538 330.556 361.269 330.399L360.312 329.842C360.043 329.685 359.599 329.685 359.33 329.842L358.382 330.39C358.112 330.547 358.112 330.799 358.382 330.956L359.338 331.513C359.608 331.67 360.051 331.67 360.321 331.513ZM362.782 332.94L363.73 332.392C363.999 332.235 363.999 331.983 363.73 331.826L362.773 331.269C362.504 331.113 362.06 331.113 361.791 331.269L360.843 331.818C360.573 331.974 360.573 332.227 360.843 332.383L361.799 332.94C362.069 333.097 362.512 333.097 362.782 332.94ZM365.243 334.368L366.191 333.82C366.46 333.663 366.46 333.41 366.191 333.254L365.234 332.697C364.965 332.54 364.521 332.54 364.252 332.697L363.304 333.245C363.034 333.402 363.034 333.654 363.304 333.811L364.26 334.368C364.53 334.525 364.973 334.525 365.243 334.368ZM367.704 335.795L368.652 335.247C368.922 335.09 368.922 334.838 368.652 334.681L367.695 334.124C367.426 333.968 366.982 333.968 366.713 334.124L365.765 334.673C365.495 334.829 365.495 335.082 365.765 335.238L366.721 335.787C366.991 335.943 367.434 335.943 367.704 335.787V335.795ZM368.226 336.666L369.182 337.223C369.452 337.379 369.895 337.379 370.165 337.223L371.113 336.674C371.383 336.518 371.383 336.265 371.113 336.109L370.156 335.552C369.887 335.395 369.443 335.395 369.174 335.552L368.226 336.1C367.956 336.257 367.956 336.509 368.226 336.666ZM375.052 338.38L372.617 336.979C372.348 336.822 371.904 336.822 371.635 336.979L370.687 337.527C370.417 337.684 370.417 337.936 370.687 338.093L373.122 339.494C373.391 339.651 373.835 339.651 374.104 339.494L375.052 338.946C375.322 338.789 375.322 338.537 375.052 338.38ZM339.198 322.592L343.581 325.124C343.885 325.298 344.381 325.298 344.685 325.124L345.511 324.646C345.816 324.472 345.816 324.184 345.511 324.002L341.128 321.469C340.824 321.295 340.328 321.295 340.024 321.469L339.198 321.947C338.893 322.122 338.893 322.409 339.198 322.592ZM345.215 326.064L346.042 326.543C346.346 326.717 346.842 326.717 347.146 326.543L347.972 326.064C348.277 325.89 348.277 325.603 347.972 325.42L347.146 324.942C346.842 324.768 346.346 324.768 346.042 324.942L345.215 325.42C344.911 325.594 344.911 325.882 345.215 326.064ZM347.677 327.492L348.503 327.971C348.807 328.145 349.303 328.145 349.607 327.971L350.433 327.492C350.738 327.318 350.738 327.031 350.433 326.848L349.607 326.369C349.303 326.195 348.807 326.195 348.503 326.369L347.677 326.848C347.372 327.022 347.372 327.309 347.677 327.492ZM350.138 328.919L350.964 329.398C351.268 329.572 351.764 329.572 352.068 329.398L352.894 328.919C353.199 328.745 353.199 328.458 352.894 328.275L352.068 327.796C351.764 327.622 351.268 327.622 350.964 327.796L350.138 328.275C349.833 328.449 349.833 328.736 350.138 328.919ZM352.599 330.347L353.425 330.825C353.729 330.999 354.225 330.999 354.529 330.825L355.355 330.347C355.66 330.173 355.66 329.885 355.355 329.703L354.529 329.224C354.225 329.05 353.729 329.05 353.425 329.224L352.599 329.703C352.294 329.877 352.294 330.164 352.599 330.347ZM355.06 331.774L355.886 332.253C356.19 332.427 356.686 332.427 356.99 332.253L357.816 331.774C358.121 331.6 358.121 331.313 357.816 331.13L356.99 330.651C356.686 330.477 356.19 330.477 355.886 330.651L355.06 331.13C354.755 331.304 354.755 331.591 355.06 331.774ZM357.521 333.202L358.347 333.68C358.651 333.854 359.147 333.854 359.451 333.68L360.277 333.202C360.582 333.027 360.582 332.74 360.277 332.557L359.451 332.079C359.147 331.905 358.651 331.905 358.347 332.079L357.521 332.557C357.216 332.732 357.216 333.019 357.521 333.202ZM359.982 334.629L360.808 335.108C361.112 335.282 361.608 335.282 361.912 335.108L362.738 334.629C363.043 334.455 363.043 334.168 362.738 333.985L361.912 333.506C361.608 333.332 361.112 333.332 360.808 333.506L359.982 333.985C359.677 334.159 359.677 334.446 359.982 334.629ZM362.443 336.056L363.269 336.535C363.573 336.709 364.069 336.709 364.373 336.535L365.2 336.056C365.504 335.882 365.504 335.595 365.2 335.412L364.373 334.934C364.069 334.76 363.573 334.76 363.269 334.934L362.443 335.412C362.138 335.586 362.138 335.874 362.443 336.056ZM364.904 337.484L365.73 337.963C366.034 338.137 366.53 338.137 366.834 337.963L367.661 337.484C367.965 337.31 367.965 337.023 367.661 336.84L366.834 336.361C366.53 336.187 366.034 336.187 365.73 336.361L364.904 336.84C364.599 337.014 364.599 337.301 364.904 337.484ZM367.365 338.911L368.191 339.39C368.495 339.564 368.991 339.564 369.295 339.39L370.122 338.911C370.426 338.737 370.426 338.45 370.122 338.267L369.295 337.789C368.991 337.614 368.495 337.614 368.191 337.789L367.365 338.267C367.061 338.441 367.061 338.729 367.365 338.911ZM372.644 339.729L371.817 339.251C371.513 339.077 371.017 339.077 370.713 339.251L369.887 339.729C369.582 339.904 369.582 340.191 369.887 340.374L370.713 340.852C371.017 341.026 371.513 341.026 371.817 340.852L372.644 340.374C372.948 340.199 372.948 339.912 372.644 339.729ZM340.754 323.941L338.832 322.827C338.528 322.652 338.032 322.652 337.728 322.827L336.902 323.305C336.597 323.479 336.597 323.767 336.902 323.949L338.824 325.063C339.128 325.238 339.624 325.238 339.928 325.063L340.754 324.585C341.059 324.411 341.059 324.123 340.754 323.941ZM343.215 325.368L342.389 324.889C342.085 324.715 341.589 324.715 341.285 324.889L340.459 325.368C340.154 325.542 340.154 325.829 340.459 326.012L341.285 326.491C341.589 326.665 342.085 326.665 342.389 326.491L343.215 326.012C343.52 325.838 343.52 325.551 343.215 325.368ZM345.676 326.796L344.85 326.317C344.546 326.143 344.05 326.143 343.746 326.317L342.92 326.796C342.615 326.97 342.615 327.257 342.92 327.44L343.746 327.918C344.05 328.092 344.546 328.092 344.85 327.918L345.676 327.44C345.981 327.266 345.981 326.978 345.676 326.796ZM362.921 336.761L347.311 327.744C347.007 327.57 346.511 327.57 346.207 327.744L345.381 328.223C345.076 328.397 345.076 328.684 345.381 328.867L360.991 337.884C361.295 338.058 361.791 338.058 362.095 337.884L362.921 337.406C363.225 337.231 363.225 336.944 362.921 336.761ZM365.382 338.189L364.556 337.71C364.252 337.536 363.756 337.536 363.452 337.71L362.625 338.189C362.321 338.363 362.321 338.65 362.625 338.833L363.452 339.312C363.756 339.486 364.252 339.486 364.556 339.312L365.382 338.833C365.687 338.659 365.687 338.372 365.382 338.189ZM367.843 339.616L367.017 339.138C366.713 338.964 366.217 338.964 365.913 339.138L365.086 339.616C364.782 339.79 364.782 340.078 365.086 340.26L365.913 340.739C366.217 340.913 366.713 340.913 367.017 340.739L367.843 340.26C368.148 340.086 368.148 339.799 367.843 339.616ZM370.356 341.07L369.53 340.591C369.226 340.417 368.73 340.417 368.426 340.591L367.6 341.07C367.295 341.244 367.295 341.531 367.6 341.714L368.426 342.193C368.73 342.367 369.226 342.367 369.53 342.193L370.356 341.714C370.661 341.54 370.661 341.253 370.356 341.07Z",
    fill: "url(#paint64_linear_812_1630)"
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M389.227 334.255L350.772 312.016C349.285 311.155 348.077 308.848 348.077 306.864V276.67C348.077 274.685 349.285 273.772 350.772 274.633L389.227 296.872C390.714 297.733 391.923 300.04 391.923 302.024V332.218C391.923 334.203 390.714 335.116 389.227 334.255Z",
    fill: "url(#paint65_linear_812_1630)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M389.575 332.697L351.529 310.702C350.329 309.936 349.59 308.413 349.59 306.855V276.513C349.59 276.148 349.99 275.913 350.312 276.104C350.346 276.122 350.381 276.139 350.399 276.156L388.48 298.177C389.906 299.004 390.419 300.466 390.419 302.024V332.296C390.419 332.688 389.993 332.94 389.645 332.74C389.619 332.723 389.593 332.714 389.584 332.705L389.575 332.697Z",
    fill: "url(#paint66_linear_812_1630)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M388.471 298.177L350.39 276.156C350.39 276.156 350.346 276.13 350.303 276.104C349.981 275.921 349.581 276.148 349.581 276.513V306.855C349.581 308.413 350.32 309.936 351.52 310.702L389.566 332.697C389.566 332.697 389.601 332.714 389.627 332.732C389.975 332.932 390.401 332.679 390.401 332.288V302.016C390.401 300.458 389.888 298.995 388.462 298.169L388.471 298.177ZM390.106 332.296C390.106 332.427 389.993 332.514 389.888 332.514C389.853 332.514 389.819 332.505 389.784 332.488L351.677 310.458C350.599 309.771 349.885 308.361 349.885 306.881V276.539C349.885 276.435 349.981 276.365 350.059 276.365C350.085 276.365 350.12 276.365 350.146 276.391L388.314 298.456C389.793 299.309 390.106 300.875 390.106 302.033V332.305V332.296Z",
    fill: "url(#paint67_linear_812_1630)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M389.993 296.454L351.538 274.215C350.946 273.876 350.407 273.815 349.964 273.98C349.912 274.007 349.155 274.398 349.103 274.433C349.564 274.215 350.146 274.25 350.781 274.625L389.236 296.863C390.723 297.725 391.932 300.031 391.932 302.016V332.209C391.932 333.445 391.462 334.272 390.749 334.507C390.81 334.507 390.88 334.49 390.984 334.429C391.019 334.411 391.836 333.95 391.862 333.924C392.375 333.567 392.697 332.827 392.697 331.809V301.615C392.697 299.631 391.488 297.324 390.001 296.463L389.993 296.454Z",
    fill: "url(#paint68_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M389.358 296.793L350.903 274.555C350.294 274.198 349.729 274.155 349.277 274.346C349.659 274.285 350.103 274.381 350.581 274.651L389.036 296.889C390.523 297.751 391.732 300.057 391.732 302.042V332.235C391.732 333.41 391.306 334.203 390.662 334.481C391.497 334.35 392.054 333.498 392.054 332.14V301.946C392.054 299.961 390.845 297.655 389.358 296.793Z",
    fill: "url(#paint69_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M392.584 301.781C391.601 302.19 390.306 301.311 389.697 299.822C389.088 298.334 389.393 296.802 390.375 296.402C391.358 295.993 392.654 296.872 393.262 298.36C393.871 299.848 393.567 301.38 392.584 301.781Z",
    fill: "url(#paint70_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M448.649 203.061C464.22 203.061 476.842 196.62 476.842 188.674C476.842 180.728 464.22 174.286 448.649 174.286C433.078 174.286 420.456 180.728 420.456 188.674C420.456 196.62 433.078 203.061 448.649 203.061Z",
    fill: "url(#paint71_radial_812_1630)"
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M468.085 182.52H422.534V189.553C422.534 196.882 432.735 202.826 445.31 202.826C457.885 202.826 468.085 196.882 468.085 189.553C468.085 189.492 468.085 189.431 468.085 189.37V182.52Z",
    fill: "url(#paint72_linear_812_1630)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 195.881C457.888 195.881 468.085 189.938 468.085 182.607C468.085 175.277 457.888 169.334 445.31 169.334C432.731 169.334 422.534 175.277 422.534 182.607C422.534 189.938 432.731 195.881 445.31 195.881Z",
    fill: "url(#paint73_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 195.828C432.865 195.828 422.76 190.014 422.543 182.79C422.543 182.868 422.534 182.947 422.534 183.025C422.534 190.354 432.735 196.298 445.31 196.298C457.885 196.298 468.085 190.354 468.085 183.025C468.085 182.947 468.085 182.868 468.077 182.79C467.859 190.014 457.754 195.828 445.31 195.828Z",
    fill: "url(#paint74_radial_812_1630)"
  }), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 175.47H424.1V181.267C424.1 181.328 424.1 181.38 424.1 181.441C424.1 188.265 433.596 193.8 445.31 193.8C457.024 193.8 466.52 188.265 466.52 181.441C466.52 181.38 466.52 181.328 466.52 181.267V175.47Z",
    fill: "url(#paint75_linear_812_1630)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 174.46H424.1V180.257C424.1 180.318 424.1 180.37 424.1 180.431C424.1 187.255 433.596 192.791 445.31 192.791C457.024 192.791 466.52 187.255 466.52 180.431C466.52 180.37 466.52 180.318 466.52 180.257V174.46Z",
    fill: "url(#paint76_linear_812_1630)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M468.085 170.039H422.534V177.072C422.534 184.4 432.735 190.345 445.31 190.345C457.885 190.345 468.085 184.4 468.085 177.072C468.085 177.011 468.085 176.95 468.085 176.889V170.039Z",
    fill: "url(#paint77_linear_812_1630)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 183.408C457.888 183.408 468.085 177.465 468.085 170.135C468.085 162.804 457.888 156.861 445.31 156.861C432.731 156.861 422.534 162.804 422.534 170.135C422.534 177.465 432.731 183.408 445.31 183.408Z",
    fill: "url(#paint78_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 183.356C432.865 183.356 422.76 177.542 422.543 170.317C422.543 170.396 422.534 170.474 422.534 170.552C422.534 177.881 432.735 183.826 445.31 183.826C457.885 183.826 468.085 177.881 468.085 170.552C468.085 170.474 468.085 170.396 468.077 170.317C467.859 177.542 457.754 183.356 445.31 183.356Z",
    fill: "url(#paint79_radial_812_1630)"
  }), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 162.997H424.1V168.794C424.1 168.855 424.1 168.907 424.1 168.968C424.1 175.792 433.596 181.328 445.31 181.328C457.024 181.328 466.52 175.792 466.52 168.968C466.52 168.907 466.52 168.855 466.52 168.794V162.997Z",
    fill: "url(#paint80_linear_812_1630)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 161.988H424.1V167.785C424.1 167.845 424.1 167.898 424.1 167.959C424.1 174.782 433.596 180.318 445.31 180.318C457.024 180.318 466.52 174.782 466.52 167.959C466.52 167.898 466.52 167.845 466.52 167.785V161.988Z",
    fill: "url(#paint81_linear_812_1630)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M468.085 157.914H422.534V164.947C422.534 172.276 432.735 178.22 445.31 178.22C457.885 178.22 468.085 172.276 468.085 164.947C468.085 164.886 468.085 164.825 468.085 164.764V157.914Z",
    fill: "url(#paint82_linear_812_1630)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 171.275C457.888 171.275 468.085 165.332 468.085 158.001C468.085 150.671 457.888 144.728 445.31 144.728C432.731 144.728 422.534 150.671 422.534 158.001C422.534 165.332 432.731 171.275 445.31 171.275Z",
    fill: "url(#paint83_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 171.231C432.865 171.231 422.76 165.417 422.543 158.193C422.543 158.271 422.534 158.35 422.534 158.428C422.534 165.757 432.735 171.701 445.31 171.701C457.885 171.701 468.085 165.757 468.085 158.428C468.085 158.35 468.085 158.271 468.077 158.193C467.859 165.417 457.754 171.231 445.31 171.231Z",
    fill: "url(#paint84_radial_812_1630)"
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 150.864H424.1V156.661C424.1 156.722 424.1 156.774 424.1 156.835C424.1 163.659 433.596 169.195 445.31 169.195C457.024 169.195 466.52 163.659 466.52 156.835C466.52 156.774 466.52 156.722 466.52 156.661V150.864Z",
    fill: "url(#paint85_linear_812_1630)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 149.863H424.1V155.66C424.1 155.721 424.1 155.773 424.1 155.834C424.1 162.658 433.596 168.194 445.31 168.194C457.024 168.194 466.52 162.658 466.52 155.834C466.52 155.773 466.52 155.721 466.52 155.66V149.863Z",
    fill: "url(#paint86_linear_812_1630)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M468.085 145.651H422.534V152.683C422.534 160.012 432.735 165.957 445.31 165.957C457.885 165.957 468.085 160.012 468.085 152.683C468.085 152.622 468.085 152.561 468.085 152.501V145.651Z",
    fill: "url(#paint87_linear_812_1630)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 159.011C457.888 159.011 468.085 153.068 468.085 145.738C468.085 138.407 457.888 132.464 445.31 132.464C432.731 132.464 422.534 138.407 422.534 145.738C422.534 153.068 432.731 159.011 445.31 159.011Z",
    fill: "url(#paint88_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 158.967C432.865 158.967 422.76 153.153 422.543 145.929C422.543 146.007 422.534 146.086 422.534 146.164C422.534 153.493 432.735 159.438 445.31 159.438C457.885 159.438 468.085 153.493 468.085 146.164C468.085 146.086 468.085 146.007 468.077 145.929C467.859 153.153 457.754 158.967 445.31 158.967Z",
    fill: "url(#paint89_radial_812_1630)"
  }), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 138.6H424.1V144.397C424.1 144.458 424.1 144.51 424.1 144.571C424.1 151.395 433.596 156.931 445.31 156.931C457.024 156.931 466.52 151.395 466.52 144.571C466.52 144.51 466.52 144.458 466.52 144.397V138.6Z",
    fill: "url(#paint90_linear_812_1630)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M466.52 137.599H424.1V143.396C424.1 143.457 424.1 143.509 424.1 143.57C424.1 150.394 433.596 155.93 445.31 155.93C457.024 155.93 466.52 150.394 466.52 143.57C466.52 143.509 466.52 143.457 466.52 143.396V137.599Z",
    fill: "url(#paint91_linear_812_1630)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M468.085 133.387H422.534V140.42C422.534 147.748 432.735 153.693 445.31 153.693C457.885 153.693 468.085 147.748 468.085 140.42C468.085 140.359 468.085 140.298 468.085 140.237V133.387Z",
    fill: "url(#paint92_linear_812_1630)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 146.756C457.888 146.756 468.085 140.813 468.085 133.483C468.085 126.152 457.888 120.209 445.31 120.209C432.731 120.209 422.534 126.152 422.534 133.483C422.534 140.813 432.731 146.756 445.31 146.756Z",
    fill: "url(#paint93_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 146.704C432.865 146.704 422.76 140.89 422.543 133.665C422.543 133.744 422.534 133.822 422.534 133.9C422.534 141.229 432.735 147.174 445.31 147.174C457.885 147.174 468.085 141.229 468.085 133.9C468.085 133.822 468.085 133.744 468.077 133.665C467.859 140.89 457.754 146.704 445.31 146.704Z",
    fill: "url(#paint94_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M447.04 138.418C453.404 138.418 458.563 135.783 458.563 132.534C458.563 129.284 453.404 126.65 447.04 126.65C440.677 126.65 435.518 129.284 435.518 132.534C435.518 135.783 440.677 138.418 447.04 138.418Z",
    fill: "url(#paint95_radial_812_1630)"
  }), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M454.423 129.078H436.196V132.699C436.196 135.632 440.275 138.009 445.31 138.009C450.345 138.009 454.423 135.632 454.423 132.699C454.423 132.673 454.423 132.647 454.423 132.63V129.087V129.078Z",
    fill: "url(#paint96_linear_812_1630)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M436.196 129.113C436.196 132.046 440.275 134.423 445.31 134.423C450.345 134.423 454.423 132.046 454.423 129.113C454.423 126.18 450.345 123.804 445.31 123.804C440.275 123.804 436.196 126.18 436.196 129.113Z",
    fill: "url(#paint97_linear_812_1630)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 132.482C448.475 132.482 451.041 130.985 451.041 129.139C451.041 127.293 448.475 125.797 445.31 125.797C442.145 125.797 439.579 127.293 439.579 129.139C439.579 130.985 442.145 132.482 445.31 132.482Z",
    fill: "url(#paint98_linear_812_1630)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M445.31 128.965C447.493 128.965 449.388 129.679 450.362 130.723C450.797 130.253 451.049 129.714 451.049 129.139C451.049 127.294 448.484 125.797 445.319 125.797C442.153 125.797 439.588 127.294 439.588 129.139C439.588 129.714 439.84 130.253 440.275 130.723C441.24 129.679 443.144 128.965 445.327 128.965H445.31Z",
    fill: "url(#paint99_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M445.31 134.405C440.327 134.405 436.283 132.081 436.196 129.192C436.196 129.226 436.196 129.252 436.196 129.287C436.196 132.22 440.275 134.597 445.31 134.597C450.345 134.597 454.423 132.22 454.423 129.287C454.423 129.252 454.423 129.226 454.423 129.192C454.336 132.081 450.293 134.405 445.31 134.405Z",
    fill: "url(#paint100_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M106.121 66.837L114.373 71.5632L114.426 74.2353L125.383 80.6153L141.123 86.8733L171.221 79.6926L168.577 78.4654L179.248 62.4851L146.48 42.736L106.121 66.837Z",
    fill: "url(#paint101_linear_812_1630)"
  }), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M124.417 28.4355L156.272 46.9835L174.586 49.6034L142.714 31.421L124.417 28.4355Z",
    fill: "url(#paint102_linear_812_1630)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M156.263 46.9835V78.2739L159.559 76.4113V75.7237L171.264 68.7867L171.977 69.0565L174.586 67.5072V49.6034L156.263 46.9835Z",
    fill: "url(#paint103_linear_812_1630)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M156.272 46.9835V78.2739L124.417 59.7173V28.4355L156.272 46.9835Z",
    fill: "url(#paint104_linear_812_1630)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M158.802 60.3613L172.743 51.9795V68.6039L171.977 69.0565L171.264 68.7867L159.559 75.7237V76.4113L158.802 76.8552V60.3613Z",
    fill: "#D1B4E3"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 68.7867V53.7551L159.559 60.7878V75.7237L171.264 68.7867Z",
    fill: "url(#paint105_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 54.8953V53.7551L159.559 60.7878V61.8323L171.264 54.8953Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 55.1129V54.5036L159.559 61.5451V62.0499L171.264 55.1129Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 56.3053V55.6961L159.559 62.7288V63.2336L171.264 56.3053Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 57.4891V56.8798L159.559 63.9212V64.426L171.264 57.4891Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 58.6728V58.0635L159.559 65.105V65.6098L171.264 58.6728Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 59.8565V59.2472L159.559 66.2887V66.7935L171.264 59.8565Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 61.0489V60.4397L159.559 67.4724V67.9772L171.264 61.0489Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 62.2327V61.6234L159.559 68.6561V69.1697L171.264 62.2327Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 63.4164V62.8071L159.559 69.8486V70.3534L171.264 63.4164Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 64.6001V63.9909L159.559 71.0323V71.5371L171.264 64.6001Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 65.7926V65.1833L159.559 72.216V72.7208L171.264 65.7926Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 66.9763V66.367L159.559 73.3997V73.9133L171.264 66.9763Z",
    fill: "#E6E7E8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 68.16V67.5507L159.559 74.5922V75.097L171.264 68.16Z",
    fill: "#E6E7E8"
  }))), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M138.714 65.5314V85.4546L106.121 66.837V46.8007L138.714 65.5314Z",
    fill: "url(#paint106_linear_812_1630)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M138.714 65.7142L154.002 39.4024L121.409 20.7848L106.121 46.9835L138.714 65.7142Z",
    fill: "url(#paint107_linear_812_1630)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M108.399 68.0469V50.5869L115.356 54.6777V72.1029L108.399 68.0469Z",
    fill: "#F1E8F6"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M114.608 55.1042V70.7886L109.156 67.6117V51.9099L114.608 55.1042Z",
    fill: "#D1B4E3"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M138.714 85.4546V65.7142L153.933 39.2022V76.9248L138.714 85.4546Z",
    fill: "url(#paint108_linear_812_1630)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M139.462 40.856L125.383 49.0985V80.6153L127.679 79.2749V59.3256L139.462 40.856Z",
    fill: "url(#paint109_linear_812_1630)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M109.851 67.2722L114.599 70.0401V55.1042L109.851 52.319V67.2722Z",
    fill: "url(#paint110_linear_812_1630)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.851 67.2722L114.599 55.1042L109.851 52.319V67.2722Z",
    fill: "url(#paint111_linear_812_1630)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.851 52.319V67.2722L114.608 70.0401V55.1129L109.851 52.319ZM114.234 69.3786L110.234 67.0459V52.9718L114.234 55.3218V69.3786Z",
    fill: "url(#paint112_linear_812_1630)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M125.383 49.0985V80.6153L114.426 74.2353V42.6664L125.383 49.0985Z",
    fill: "url(#paint113_linear_812_1630)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M116.426 75.3233V57.872L123.383 61.9542V79.3793L116.426 75.3233Z",
    fill: "#F1E8F6"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M122.635 62.3893V78.065L117.182 74.8881V59.1863L122.635 62.3893Z",
    fill: "#D1B4E3"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M129.601 80.1191V62.6592L136.558 66.7413V84.1664L129.601 80.1191Z",
    fill: "#F1E8F6"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M135.801 67.1765V82.8521L130.357 79.6839V63.9734L135.801 67.1765Z",
    fill: "#D1B4E3"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M116.426 55.5742V46.1479L123.383 50.23V59.6302L116.426 55.5742Z",
    fill: "#F1E8F6"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M122.635 50.6652V58.3159L117.182 55.139V47.4709L122.635 50.6652Z",
    fill: "#D1B4E3"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M117.878 74.5487L122.635 77.3165V62.3893L117.878 59.5954V74.5487Z",
    fill: "url(#paint114_linear_812_1630)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M117.878 74.5487L122.635 62.3893L117.878 59.5954V74.5487Z",
    fill: "url(#paint115_linear_812_1630)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M131.044 79.3358L135.801 82.1036V67.1765L131.044 64.3825V79.3358Z",
    fill: "url(#paint116_linear_812_1630)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.044 79.3358L135.801 67.1765L131.044 64.3825V79.3358Z",
    fill: "url(#paint117_linear_812_1630)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M117.878 54.7909L122.635 57.5587V50.6652L117.878 47.8713V54.7909Z",
    fill: "url(#paint118_linear_812_1630)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131.044 64.3825V79.3358L135.801 82.1036V67.1765L131.044 64.3825ZM135.427 81.4421L131.427 79.1095V65.0353L135.427 67.3854V81.4421Z",
    fill: "url(#paint119_linear_812_1630)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M117.878 54.7909L122.635 50.6652L117.878 47.8713V54.7909Z",
    fill: "url(#paint120_linear_812_1630)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.878 47.8713V54.7909L122.635 57.5587V50.6652L117.878 47.8713ZM122.261 56.9059L118.261 54.5733V48.5328L122.261 50.8828V56.9059Z",
    fill: "url(#paint121_linear_812_1630)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M117.878 59.5954V74.5487L122.635 77.3165V62.3893L117.878 59.5954ZM122.261 76.655L118.261 74.3224V60.2482L122.261 62.5982V76.655Z",
    fill: "url(#paint122_linear_812_1630)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M142.793 63.6253L143.993 62.9377L151.002 58.8556V48.6546L142.793 63.6253Z",
    fill: "#D1B4E3"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M144.802 61.5886L150.254 58.4204V51.6923L144.802 61.5886Z",
    fill: "#F1E8F6"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M142.923 65.6968L151.002 61.0664V78.5263L142.923 83.122V65.6968Z",
    fill: "#D1B4E3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M143.68 66.132V81.8077L150.254 78.0911V62.3893L143.68 66.132Z",
    fill: "#F1E8F6"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M149.619 77.743V62.7549L143.68 66.132V81.094L149.619 77.743Z",
    fill: "url(#paint123_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M143.68 66.132V81.094L149.628 77.743V62.7549L143.68 66.132ZM149.245 77.5254L144.054 80.4499V66.3496L149.245 63.4077V77.5254Z",
    fill: "#E6E7E8"
  }))), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M149.619 52.8325L145.375 60.5441L149.619 58.0722V52.8325Z",
    fill: "url(#paint124_linear_812_1630)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.375 60.5441L149.619 58.0722V52.8325L145.375 60.5354V60.5441ZM149.237 57.8546L146.358 59.5258L149.237 54.3034V57.8546Z",
    fill: "url(#paint125_linear_812_1630)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M125.383 49.0985L139.462 40.856L128.513 34.476L114.426 42.6664L125.383 49.0985Z",
    fill: "url(#paint126_linear_812_1630)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M141.123 85.9594V86.8733L156.289 78.2652V77.3426L141.123 85.9594Z",
    fill: "url(#paint127_linear_812_1630)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M141.123 85.9594V86.8733L138.706 85.4546V84.5407L141.123 85.9594Z",
    fill: "url(#paint128_linear_812_1630)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M138.706 84.5407L141.123 85.9594L156.289 77.3426L153.924 75.9674L138.706 84.5407Z",
    fill: "url(#paint129_linear_812_1630)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M145.045 72.216C145.045 72.4597 144.871 72.7644 144.654 72.8862C144.436 73.0081 144.262 72.9123 144.262 72.6686C144.262 72.4249 144.436 72.1203 144.654 71.9984C144.871 71.8766 145.045 71.9723 145.045 72.216Z",
    fill: "url(#paint130_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M127.679 59.3256L139.462 40.856L130.992 61.2317L127.679 59.3256Z",
    fill: "url(#paint131_linear_812_1630)"
  }), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M138.706 84.5407L156.289 77.3426L153.924 75.9674L138.706 84.5407Z",
    fill: "url(#paint132_linear_812_1630)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M171.264 53.7551V68.7867L171.977 69.0565V53.3634L171.264 53.7551Z",
    fill: "#F1E8F6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M334.85 57.3498L335.528 56.9668C335.589 56.932 338.006 55.5133 338.085 55.4959C339.589 54.6777 341.441 54.2512 343.285 54.2947C343.529 54.2947 343.772 54.3209 344.007 54.3383C345.242 54.4427 346.607 54.8779 347.52 55.4088L360.425 62.8681L373.322 70.3273C374.47 70.9888 375.444 72.1203 375.74 73.2257C375.818 73.5216 375.879 73.8262 375.896 74.1309C375.992 75.8368 374.966 77.4732 373.061 78.5698L372.383 78.9528C372.322 78.9876 369.904 80.4064 369.826 80.4238C368.322 81.2419 366.469 81.6684 364.626 81.6249C364.382 81.6249 364.139 81.5988 363.904 81.5814C362.669 81.4769 361.304 81.0417 360.391 80.5108L347.485 73.0516L334.589 65.5924C333.441 64.9309 332.467 63.7994 332.171 62.694C332.093 62.398 332.032 62.0934 332.015 61.7888C331.919 60.0828 332.945 58.4465 334.85 57.3498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M334.963 57.55L335.633 57.1844C335.754 57.1148 338.007 55.8092 338.154 55.7831C339.659 55.0172 341.485 54.6342 343.268 54.7299C343.503 54.7386 343.737 54.7735 343.972 54.7996C345.085 54.9127 346.572 55.435 347.399 55.9137L360.069 63.2423L372.713 70.5536C373.748 71.1541 374.861 72.3292 375.157 73.3127C375.244 73.5999 375.322 73.8785 375.357 74.1744C375.54 75.8194 374.583 77.4383 372.696 78.535L372.026 78.9006C371.905 78.9702 369.652 80.2758 369.504 80.3019C368 81.0679 366.174 81.4421 364.391 81.3551C364.156 81.3377 363.921 81.3116 363.687 81.2854C362.574 81.1723 361.086 80.6501 360.26 80.1714L347.59 72.8427L334.946 65.5314C333.911 64.9309 332.798 63.7559 332.502 62.7723C332.415 62.4851 332.337 62.2066 332.302 61.9106C332.119 60.2656 333.076 58.6467 334.963 57.55Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M335.076 57.7502L335.737 57.402C335.919 57.2976 338.006 56.1052 338.224 56.0616C339.728 55.3479 341.528 55.0172 343.25 55.1564C343.485 55.1738 343.711 55.2174 343.937 55.2435C344.929 55.3653 346.537 55.9746 347.268 56.3924L359.704 63.5818L372.104 70.7538C373.026 71.2847 374.287 72.5206 374.574 73.3823C374.67 73.6522 374.774 73.922 374.818 74.2005C375.096 75.7846 374.209 77.3948 372.322 78.4828L371.661 78.831C371.478 78.9354 369.391 80.1278 369.174 80.1714C367.669 80.8851 365.869 81.2071 364.147 81.0766C363.913 81.0591 363.686 81.0156 363.46 80.9895C362.469 80.8677 360.86 80.2584 360.13 79.8406L347.694 72.6512L335.293 65.4792C334.371 64.9483 333.11 63.7123 332.823 62.8506C332.728 62.5808 332.623 62.311 332.58 62.0325C332.302 60.4484 333.189 58.8382 335.076 57.7502Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M335.198 57.9504L335.85 57.6283C336.093 57.4891 338.015 56.4098 338.311 56.3489C339.815 55.6874 341.598 55.4001 343.25 55.5916C343.476 55.6177 343.694 55.67 343.911 55.7048C344.772 55.8266 346.503 56.5316 347.146 56.8972L359.347 63.9473L371.504 70.9801C372.313 71.4501 373.722 72.7295 374.009 73.4781C374.105 73.7392 374.235 73.9829 374.305 74.2527C374.687 75.7759 373.861 77.3687 371.983 78.4567L371.331 78.7787C371.087 78.918 369.165 79.9973 368.87 80.0582C367.365 80.7197 365.582 80.9982 363.93 80.8154C363.704 80.7893 363.487 80.7371 363.269 80.7023C362.408 80.5804 360.678 79.8754 360.034 79.5099L347.833 72.4597L335.676 65.427C334.867 64.957 333.458 63.6775 333.171 62.929C333.076 62.6679 332.945 62.4242 332.876 62.1543C332.493 60.6312 333.319 59.0384 335.198 57.9504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M335.311 58.1506L335.963 57.8459C336.267 57.6718 338.024 56.7057 338.389 56.6361C339.894 56.0268 341.65 55.7918 343.242 56.0268C343.468 56.0616 343.677 56.1226 343.885 56.1574C344.624 56.2705 346.477 57.08 347.033 57.3933L358.999 64.3129L370.913 71.1977C371.6 71.598 373.174 72.9297 373.444 73.5564C373.548 73.8088 373.705 74.0351 373.783 74.2875C374.261 75.7498 373.505 77.3252 371.635 78.4132L370.983 78.7178C370.678 78.8919 368.922 79.858 368.557 79.9276C367.052 80.5369 365.296 80.7632 363.704 80.5369C363.487 80.5021 363.269 80.4412 363.061 80.4064C362.321 80.2932 360.469 79.4837 359.913 79.1704L347.946 72.2508L336.033 65.3661C335.346 64.9657 333.772 63.634 333.502 63.0073C333.398 62.7549 333.241 62.5286 333.163 62.2762C332.684 60.8139 333.441 59.2385 335.311 58.1506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M335.424 58.3508L336.067 58.0722C336.432 57.8633 338.024 57.0191 338.459 56.9233C339.963 56.3576 341.694 56.1748 343.224 56.462C343.442 56.5055 343.642 56.5752 343.85 56.61C344.459 56.7231 346.442 57.6283 346.903 57.8894L358.634 64.6698L370.296 71.4153C370.87 71.746 372.722 73.0864 372.852 73.6435C373.018 73.8611 373.139 74.0874 373.235 74.3224C373.809 75.7237 373.113 77.2904 371.252 78.361L370.609 78.6395C370.244 78.8484 368.652 79.6926 368.217 79.7884C366.713 80.3541 364.982 80.5195 363.452 80.2497C363.234 80.2062 363.034 80.1365 362.826 80.1017C362.217 79.9886 360.234 79.0834 359.773 78.8223L348.042 72.0419L336.38 65.2964C335.806 64.9657 333.954 63.6253 333.824 63.0682C333.658 62.8507 333.537 62.6244 333.441 62.3893C332.867 60.988 333.563 59.4213 335.424 58.3508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M335.537 58.5509L336.171 58.2898C336.598 58.0461 338.024 57.315 338.537 57.2105C340.041 56.697 341.754 56.5665 343.215 56.8972C343.424 56.9407 343.624 57.0278 343.824 57.0713C344.311 57.167 346.416 58.1854 346.781 58.3943L358.277 65.044L369.696 71.6503C370.156 71.9201 372.183 73.304 372.287 73.7479C372.47 73.9481 372.609 74.1657 372.722 74.3833C373.4 75.7237 372.765 77.273 370.913 78.3435L370.278 78.6047C369.852 78.8484 368.426 79.5795 367.913 79.6839C366.408 80.1975 364.704 80.3193 363.234 79.9973C363.026 79.9451 362.826 79.8667 362.626 79.8232C362.139 79.7275 360.034 78.7091 359.669 78.5002L348.172 71.8505L336.754 65.2442C336.293 64.9744 334.267 63.5905 334.163 63.1466C333.98 62.9464 333.841 62.7288 333.728 62.5112C333.05 61.1708 333.684 59.6215 335.537 58.5509Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M335.658 58.7511L336.285 58.5074C336.763 58.2289 338.033 57.6109 338.615 57.4891C340.12 57.0278 341.807 56.9494 343.207 57.315C343.416 57.3672 343.598 57.463 343.798 57.5065C344.163 57.5848 346.39 58.7163 346.659 58.873L357.921 65.3835L369.096 71.8417C369.443 72.0419 371.635 73.4694 371.713 73.8088C371.905 73.9916 372.061 74.1918 372.191 74.4007C372.974 75.6715 372.4 77.2207 370.548 78.2826L369.922 78.5263C369.435 78.8048 368.174 79.4228 367.591 79.5447C366.087 80.006 364.4 80.0756 363 79.7187C362.8 79.6665 362.608 79.5708 362.408 79.5273C362.043 79.4489 359.817 78.3174 359.547 78.1608L348.285 71.6503L337.111 65.192C336.763 64.9918 334.571 63.5644 334.493 63.2249C334.302 63.0421 334.145 62.8419 334.015 62.6331C333.232 61.3623 333.806 59.813 335.658 58.7511Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M335.772 58.9513L336.389 58.7337C336.928 58.4204 338.033 57.9156 338.685 57.785C340.189 57.3759 341.85 57.3498 343.19 57.7589C343.39 57.8198 343.581 57.8894 343.755 57.9765C344.007 57.9939 346.346 59.2821 346.529 59.3865L357.556 65.7577L368.487 72.0768C368.713 72.2073 371.078 73.687 371.131 73.9046C371.339 74.0786 371.513 74.2614 371.652 74.4529C372.548 75.6627 372.018 77.1946 370.183 78.2565L369.565 78.4741C369.026 78.7874 367.922 79.2923 367.27 79.4228C365.765 79.8319 364.104 79.8493 362.765 79.4489C362.565 79.388 362.374 79.3184 362.2 79.2313C361.947 79.2139 359.608 77.9258 359.425 77.8213L348.399 71.4501L337.467 65.1311C337.241 65.0005 334.876 63.5209 334.824 63.3033C334.615 63.1292 334.441 62.9464 334.302 62.7549C333.406 61.5451 333.937 60.0132 335.772 58.9513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M335.885 59.1515L336.502 58.9513C337.102 58.6032 338.041 58.2115 338.772 58.0635C340.276 57.7067 341.92 57.7328 343.19 58.1854C343.381 58.255 343.563 58.3333 343.737 58.4204C343.859 58.4204 346.32 59.8217 346.416 59.8739L357.208 66.1146L367.887 72.2943C368 72.364 370.539 73.8785 370.565 73.9916C370.791 74.1483 370.983 74.3136 371.139 74.4964C372.139 75.6366 371.67 77.1598 369.844 78.2217L369.226 78.4219C368.626 78.77 367.687 79.1617 366.956 79.3097C365.452 79.6665 363.817 79.6404 362.539 79.1878C362.347 79.1182 362.165 79.0398 361.991 78.9528C361.869 78.9528 359.408 77.5515 359.312 77.4993L348.52 71.2586L337.841 65.0788C337.728 65.0092 335.189 63.4947 335.163 63.3816C334.937 63.2249 334.745 63.0595 334.589 62.8768C333.589 61.7366 334.058 60.2134 335.885 59.1515Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.773 78.6482L348.633 71.0497L335.493 63.4512C333.676 62.3981 333.902 60.5615 336.006 59.3517L336.615 59.1689C338.72 57.9504 341.894 57.8198 343.711 58.873L356.851 66.4715L369.991 74.0699C371.809 75.1231 371.583 76.9596 369.478 78.1695L368.87 78.3522C366.765 79.5621 363.591 79.7013 361.773 78.6482Z",
    fill: "black"
  }))), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M364.434 77.8648L340.154 63.7384C337.928 62.4503 336.128 59.0035 336.128 56.0355V3.47285C336.128 1.96708 334.885 1.62763 335.641 1.08799C335.667 1.07058 337.398 0.278525 337.433 0.269821C338.241 -0.043518 339.102 -0.174076 340.154 0.426491L364.434 14.5529C366.661 15.841 368.461 19.2878 368.461 22.2558V74.8185C368.461 76.3939 367.948 77.5167 367.139 78.0389C367.087 78.065 365.008 79.066 364.948 79.0834C364.226 79.3271 365.4 78.4393 364.426 77.8735L364.434 77.8648Z",
    fill: "url(#paint133_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M362.904 78.5611L338.624 64.4348C336.398 63.1466 334.598 59.6998 334.598 56.7318V4.16915C334.598 1.20113 336.398 -0.165376 338.624 1.1228L362.904 15.2492C365.13 16.5374 366.93 19.9841 366.93 22.9521V75.5148C366.93 78.4828 365.13 79.8493 362.904 78.5611Z",
    fill: "url(#paint134_radial_812_1630)"
  }), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M362.547 78.7526L338.267 64.6262C336.041 63.3381 334.241 59.8913 334.241 56.9233V4.36064C334.241 1.39262 336.041 0.0261142 338.267 1.31429L362.547 15.4407C364.774 16.7288 366.574 20.1756 366.574 23.1436V75.7063C366.574 78.6743 364.774 80.0408 362.547 78.7526Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M334.798 57.2715V4.64787C334.798 2.04541 336.38 0.852983 338.328 1.97578L362.504 16.0412C364.452 17.164 366.035 20.193 366.035 22.7954V75.419C366.035 78.0215 364.452 79.2139 362.504 78.0911L338.328 64.0257C336.38 62.9029 334.798 59.8739 334.798 57.2715Z",
    fill: "url(#paint135_linear_812_1630)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M335.58 52.2319V5.23103C335.58 3.05506 336.902 2.05412 338.537 2.99413L362.295 16.8159C363.93 17.7559 365.252 20.2887 365.252 22.4647V69.4656C365.252 71.6416 363.93 72.6425 362.295 71.7025L338.537 57.8807C336.902 56.9407 335.58 54.4079 335.58 52.2319Z",
    fill: "url(#paint136_linear_812_1630)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M338.754 3.57729C337.215 2.6895 335.972 3.40322 335.972 5.1701V52.7629C335.972 54.5298 337.215 56.6796 338.754 57.5674L362.069 71.1367C363.608 72.0245 364.852 71.3108 364.852 69.5439V21.9512C364.852 20.1843 363.608 18.0344 362.069 17.1466L338.754 3.57729Z",
    fill: "url(#paint137_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M362.069 17.1466L338.754 3.57729C337.215 2.6895 335.972 3.40322 335.972 5.1701V52.7629C335.972 54.5298 337.215 56.6796 338.754 57.5674L362.069 71.1367C363.608 72.0245 364.852 71.3108 364.852 69.5439V21.9512C364.852 20.1843 363.608 18.0344 362.069 17.1466ZM364.608 69.5439C364.608 70.0923 364.478 70.5449 364.235 70.8495C364.008 71.128 363.695 71.276 363.313 71.276C362.974 71.276 362.582 71.1541 362.182 70.9278L338.868 57.3585C337.398 56.5055 336.206 54.4427 336.206 52.7629V5.1614C336.206 4.09082 336.702 3.42933 337.502 3.42933C337.841 3.42933 338.233 3.55118 338.633 3.77748L361.947 17.3468C363.417 18.1998 364.608 20.2626 364.608 21.9425V69.5352V69.5439Z",
    fill: "#BCBEC0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M351.86 68.8737C351.86 69.9095 351.129 70.3273 350.233 69.805C349.329 69.2828 348.607 68.0207 348.607 66.9937C348.607 65.9666 349.338 65.5401 350.233 66.0624C351.138 66.5846 351.86 67.8467 351.86 68.8737Z",
    fill: "#8969C3"
  }))), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M349.494 65.8361C349.712 65.8361 349.964 65.9057 350.225 66.0624C351.129 66.5846 351.851 67.8467 351.851 68.8737C351.851 69.6048 351.486 70.0313 350.955 70.0313C350.738 70.0313 350.486 69.9617 350.225 69.805C349.32 69.2828 348.598 68.0207 348.598 66.9937C348.598 66.2626 348.964 65.8361 349.494 65.8361ZM349.494 65.4792C348.746 65.4792 348.242 66.0885 348.242 66.9937C348.242 68.16 349.033 69.5352 350.051 70.1184C350.364 70.3012 350.668 70.3882 350.964 70.3882C351.712 70.3882 352.216 69.7789 352.216 68.8737C352.216 67.7074 351.425 66.3322 350.407 65.749C350.094 65.5663 349.79 65.4792 349.494 65.4792Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M49.1601 176.14L34.6373 184.661C34.6373 184.661 34.4895 184.748 34.4808 184.757C33.3416 185.427 32.8285 186.489 32.8894 187.629C32.9589 188.787 33.8199 190.075 35.0808 190.798L46.8643 202.052C47.9861 202.704 49.4297 203.026 50.795 202.957C51.882 202.957 53.0995 202.583 53.8821 202.139L75.475 189.588C76.5707 188.952 77.1968 187.951 77.1968 186.846C77.1968 185.636 76.4316 184.505 75.1097 183.739L56.0823 176.41C55.6997 176.184 55.1518 175.966 54.7083 175.818C53.9517 175.574 53.1256 175.427 52.2907 175.418C51.108 175.409 50.0123 175.662 49.1688 176.149L49.1601 176.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M49.247 176.279L34.7068 184.801C34.7068 184.801 34.559 184.888 34.5503 184.896C33.4111 185.575 33.0458 186.637 33.1763 187.769C33.298 188.804 34.2546 190.197 35.3764 190.85L46.9425 201.895C48.1078 202.565 49.6296 202.87 50.9949 202.731C51.9776 202.731 53.3168 202.252 54.0212 201.843L75.3879 189.422C76.4402 188.813 77.0315 187.864 77.0228 186.811C77.0141 185.671 76.2924 184.592 75.0227 183.861L56.1083 176.584C55.7605 176.384 55.143 176.132 54.743 176.001C53.9951 175.749 53.1777 175.592 52.3515 175.574C51.1775 175.548 50.0818 175.792 49.247 176.279Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M49.3252 176.427L34.7764 184.957C34.7764 184.957 34.6285 185.044 34.6199 185.053C33.4806 185.749 33.0632 186.846 33.4546 187.917C33.4546 188.848 34.672 190.328 35.6721 190.902L47.0207 201.747C48.2208 202.443 49.8296 202.722 51.1949 202.513C52.0646 202.513 53.5342 201.93 54.1604 201.564L75.301 189.274C76.3097 188.691 76.8663 187.795 76.8489 186.802C76.8315 185.723 76.1445 184.705 74.927 184.009L56.1344 176.776C55.83 176.602 55.1256 176.323 54.7778 176.201C54.0386 175.949 53.2299 175.766 52.4124 175.749C51.2471 175.714 50.1514 175.949 49.3252 176.427Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M49.4121 176.575L34.8459 185.114C34.8459 185.114 34.7067 185.201 34.6806 185.21C33.5414 185.915 33.2023 187.029 33.7327 188.073C33.7327 188.883 35.0894 190.458 35.9677 190.972L47.1076 201.608C48.3512 202.321 50.0469 202.583 51.4036 202.304C52.1688 202.304 53.7602 201.608 54.3081 201.294L75.2226 189.135C76.1879 188.578 76.7097 187.725 76.6923 186.794C76.6749 185.784 76.014 184.818 74.8574 184.148L56.1865 176.958C55.9169 176.802 55.1429 176.506 54.8386 176.393C54.1081 176.132 53.3167 175.94 52.4993 175.905C51.3427 175.862 50.2556 176.079 49.4295 176.558L49.4121 176.575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M49.4903 176.715L34.9067 185.262C34.9067 185.262 34.7676 185.34 34.7415 185.358C33.611 186.071 33.3501 187.203 34.0023 188.221C34.0023 188.918 35.5067 190.589 36.2546 191.024L47.1771 201.46C48.4555 202.2 50.2382 202.435 51.5861 202.086C52.2384 202.086 53.9689 201.286 54.4298 201.016L75.1182 188.996C76.0313 188.465 76.527 187.664 76.5009 186.794C76.4749 185.845 75.8574 184.94 74.753 184.304L56.1952 177.159C55.9604 177.028 55.1168 176.697 54.8472 176.602C54.1254 176.34 53.3428 176.132 52.5253 176.088C51.3774 176.036 50.2904 176.245 49.4729 176.715H49.4903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M49.5773 176.863L34.985 185.419C34.985 185.419 34.8458 185.497 34.8197 185.523C33.6892 186.245 33.5066 187.403 34.298 188.387C34.298 188.97 35.9416 190.737 36.5677 191.093L47.2728 201.321C48.5946 202.086 50.4643 202.295 51.8035 201.878C52.3514 201.878 54.2037 200.964 54.595 200.746L75.0574 188.857C75.927 188.352 76.3879 187.603 76.3531 186.785C76.327 185.906 75.7357 185.062 74.6834 184.452L56.2473 177.359C56.056 177.246 55.1255 176.897 54.9081 176.81C54.195 176.541 53.4211 176.314 52.6123 176.271C51.4731 176.201 50.3861 176.401 49.5773 176.871V176.863Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M49.6557 177.002L35.046 185.567C35.046 185.567 34.9156 185.645 34.8808 185.671C33.7503 186.402 33.6546 187.577 34.5764 188.526C34.5764 188.987 36.3591 190.85 36.8635 191.146L47.3599 201.173C48.7165 201.956 50.6732 202.147 52.0124 201.66C52.4472 201.66 54.43 200.642 54.743 200.459L74.9706 188.7C75.7967 188.221 76.2228 187.516 76.188 186.759C76.1533 185.95 75.5967 185.157 74.6053 184.583L56.291 177.533C56.1345 177.446 55.1344 177.063 54.9605 176.993C54.2561 176.723 53.4908 176.48 52.6907 176.427C51.5689 176.349 50.4732 176.541 49.6731 177.002H49.6557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M49.7425 177.15L35.1241 185.723C35.0806 185.749 34.9936 185.802 34.9502 185.828C33.8283 186.567 33.8023 187.76 34.8545 188.683C34.8545 189.031 36.7851 190.989 37.159 191.207L47.438 201.025C48.8381 201.834 50.873 201.999 52.2036 201.442C52.534 201.442 54.6385 200.32 54.8733 200.18L74.8747 188.552C75.6574 188.099 76.04 187.447 76.0052 186.75C75.9705 186.002 75.44 185.271 74.5008 184.731L56.2995 177.724C56.1864 177.655 55.0994 177.246 54.9777 177.193C54.282 176.915 53.5254 176.662 52.734 176.593C51.6209 176.506 50.5252 176.689 49.7338 177.141L49.7425 177.15Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M49.8295 177.298L35.1937 185.88C35.1415 185.906 35.0632 185.958 35.0198 185.984C33.8979 186.733 33.9588 187.943 35.1415 188.839C35.1415 189.074 37.2112 191.128 37.4634 191.276L47.5337 200.894C48.9686 201.721 51.0992 201.869 52.421 201.242C52.6384 201.242 54.8733 200.006 55.0299 199.919L74.8052 188.421C75.5357 187.995 75.8922 187.394 75.8574 186.75C75.8139 186.071 75.327 185.392 74.4399 184.879L56.3604 177.916C56.2821 177.872 55.1255 177.428 55.0386 177.394C54.3516 177.106 53.6037 176.837 52.8123 176.767C51.7079 176.662 50.6122 176.837 49.8295 177.289V177.298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.91,
    d: "M49.908 177.437L35.2547 186.028C35.1939 186.063 35.133 186.106 35.0808 186.141C33.959 186.907 34.0981 188.125 35.4113 188.996C35.4113 189.109 37.6201 191.268 37.7506 191.337L47.6034 200.746C49.0818 201.599 51.2907 201.721 52.6125 201.025C52.7255 201.025 55.0909 199.684 55.1692 199.641L74.7184 188.273C75.4054 187.873 75.7272 187.316 75.6837 186.733C75.6315 186.124 75.1793 185.497 74.3532 185.018L56.3954 178.107C56.3954 178.107 55.1257 177.611 55.0822 177.594C54.4039 177.307 53.6647 177.019 52.8821 176.941C51.7864 176.828 50.6906 176.993 49.9167 177.437H49.908Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8123 200.816L74.6313 188.134C75.9444 187.377 75.7792 186.045 74.266 185.175L55.1169 177.803C53.6037 176.924 51.3079 176.828 49.9948 177.594L35.3328 186.193C34.0197 186.95 34.1849 188.282 35.6981 189.153L47.6902 200.607C49.2034 201.486 51.4992 201.582 52.8123 200.816Z",
    fill: "black"
  }))), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8125 200.781L74.6314 188.099C75.2141 187.76 75.5098 187.307 75.5185 186.837C75.5185 186.82 75.5185 185.201 75.5185 185.184C75.5098 184.609 75.0836 185.61 74.2662 185.131L55.117 177.759C53.6039 176.88 51.3081 176.784 49.9949 177.55L35.333 186.15C34.8982 186.402 34.5764 185.332 34.4634 185.671C34.4286 185.784 34.446 187.29 34.446 187.412C34.4373 188.004 34.8547 188.63 35.6983 189.109L47.6904 200.563C49.2036 201.442 51.4994 201.538 52.8125 200.772V200.781Z",
    fill: "url(#paint138_linear_812_1630)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8123 199.162L74.6313 186.48C75.9444 185.723 75.7792 184.392 74.266 183.521L55.1169 176.149C53.6037 175.27 51.3079 175.174 49.9948 175.94L35.3328 184.539C34.0197 185.297 34.1849 186.628 35.6981 187.499L47.6902 198.953C49.2034 199.832 51.4992 199.928 52.8123 199.162Z",
    fill: "url(#paint139_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.82,
    d: "M35.3243 184.531L49.9862 175.931C51.2993 175.174 53.5952 175.27 55.1083 176.14L64.7525 179.857C64.6655 179.926 64.5611 179.996 64.4568 180.066L42.6379 192.747C42.3335 192.921 41.9769 193.052 41.5943 193.13L35.6895 187.49C34.1764 186.611 34.0112 185.288 35.3243 184.531Z",
    fill: "url(#paint140_linear_812_1630)"
  }), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6981 187.22L47.6903 198.675C49.2034 199.554 51.4992 199.649 52.8124 198.883L74.6313 186.202C75.1792 185.889 75.4661 185.471 75.5096 185.036C75.5792 185.575 75.2922 186.097 74.6313 186.48L52.8124 199.162C51.4992 199.919 49.2034 199.823 47.6903 198.953L35.6981 187.499C34.8111 186.985 34.3937 186.315 34.4545 185.706C34.5241 186.237 34.9415 186.794 35.6981 187.229V187.22Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M40.7072 197.299C39.5332 200.163 42.0725 203.923 46.3859 205.69C50.6992 207.465 55.143 206.578 56.317 203.714C57.491 200.851 54.9517 197.09 50.6383 195.324C46.325 193.548 41.8812 194.436 40.7072 197.299Z",
    fill: "url(#paint141_radial_812_1630)"
  }), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M24.306 199.232L77.8924 168.246C80.6317 166.662 82.8493 162.414 82.8493 158.759V117.737C82.8493 114.082 80.6317 112.402 77.8924 113.986L24.306 144.972C21.5667 146.556 19.3491 150.803 19.3491 154.459V195.48C19.3491 199.136 21.5667 200.816 24.306 199.232Z",
    fill: "url(#paint142_linear_812_1630)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6712 196.377L76.501 165.826C78.7098 164.425 80.0665 161.622 80.0665 158.759V117.476C80.0665 116.797 79.3273 116.371 78.7446 116.719C78.6751 116.762 78.6229 116.789 78.5881 116.806L25.7061 147.391C23.0798 148.906 22.1406 151.595 22.1406 154.468V195.628C22.1406 196.359 22.932 196.812 23.5581 196.455C23.6103 196.429 23.6451 196.403 23.6712 196.385V196.377Z",
    fill: "url(#paint143_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1318 154.459V195.619C22.1318 196.351 22.9232 196.803 23.5493 196.446C23.6015 196.42 23.6363 196.394 23.6624 196.377L76.4922 165.826C78.6924 164.425 80.0577 161.622 80.0577 158.759V117.476C80.0577 116.797 79.3185 116.371 78.7358 116.719C78.6663 116.762 78.6141 116.789 78.5793 116.806L25.6973 147.391C23.071 148.906 22.1318 151.595 22.1318 154.468V154.459ZM22.6884 154.459C22.6884 152.318 23.2624 149.437 25.9756 147.87L79.0228 117.189C79.075 117.163 79.1272 117.145 79.188 117.145C79.3446 117.145 79.5098 117.267 79.5098 117.467V158.75C79.5098 161.483 78.2141 164.068 76.2226 165.339L23.2797 195.95C23.2189 195.985 23.1493 196.002 23.0884 196.002C22.8971 196.002 22.6971 195.855 22.6971 195.611V154.45L22.6884 154.459Z",
    fill: "#BCBEC0"
  }))), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M22.906 144.232L76.4924 113.246C77.5794 112.619 78.5795 112.506 79.3969 112.82C79.5013 112.863 80.884 113.594 80.9797 113.646C80.1361 113.237 79.0665 113.316 77.8925 113.995L24.3061 144.98C21.5668 146.564 19.3492 150.812 19.3492 154.468V195.489C19.3492 197.769 20.2102 199.284 21.532 199.71C21.4276 199.71 21.2885 199.675 21.0972 199.562C21.0363 199.528 19.5318 198.675 19.471 198.64C18.5318 197.978 17.9404 196.62 17.9404 194.74V153.719C17.9404 150.063 20.158 145.816 22.8973 144.232H22.906Z",
    fill: "url(#paint144_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M24.0712 144.859L77.6576 113.873C78.7794 113.22 79.8143 113.133 80.6491 113.49C79.936 113.377 79.1273 113.551 78.2577 114.047L24.6713 145.033C21.9319 146.617 19.7144 150.864 19.7144 154.52V195.541C19.7144 197.7 20.4884 199.162 21.6884 199.676C20.1579 199.432 19.123 197.856 19.123 195.358V154.337C19.123 150.681 21.3406 146.434 24.0799 144.85L24.0712 144.859Z",
    fill: "url(#paint145_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M18.1403 154.024C19.9492 154.772 22.3319 153.162 23.4538 150.429C24.5756 147.696 24.019 144.876 22.2015 144.136C20.384 143.396 18.0099 144.998 16.8881 147.731C15.7663 150.464 16.3228 153.284 18.1403 154.032V154.024Z",
    fill: "url(#paint146_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M141.114 348.494C153.241 348.494 163.072 343.6 163.072 337.562C163.072 331.525 153.241 326.63 141.114 326.63C128.987 326.63 119.156 331.525 119.156 337.562C119.156 343.6 128.987 348.494 141.114 348.494Z",
    fill: "url(#paint147_radial_812_1630)"
  }), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M120.713 333.263H150.315V336.422C150.315 336.422 150.315 336.5 150.315 336.544C150.315 341.305 143.688 345.169 135.514 345.169C127.339 345.169 120.713 341.305 120.713 336.544C120.713 336.5 120.713 336.466 120.713 336.422V333.263Z",
    fill: "url(#paint148_linear_812_1630)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M135.505 342.254C143.68 342.254 150.306 338.392 150.306 333.628C150.306 328.864 143.68 325.003 135.505 325.003C127.331 325.003 120.704 328.864 120.704 333.628C120.704 338.392 127.331 342.254 135.505 342.254Z",
    fill: "url(#paint149_linear_812_1630)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M121.957 313.766H149.063V332.479C149.063 332.479 149.063 332.549 149.063 332.592C149.063 336.953 142.993 340.487 135.514 340.487C128.035 340.487 121.965 336.953 121.965 332.592C121.965 332.557 121.965 332.523 121.965 332.479V313.766H121.957Z",
    fill: "url(#paint150_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M135.505 322.087C142.988 322.087 149.054 318.552 149.054 314.192C149.054 309.832 142.988 306.298 135.505 306.298C128.023 306.298 121.957 309.832 121.957 314.192C121.957 318.552 128.023 322.087 135.505 322.087Z",
    fill: "url(#paint151_radial_812_1630)"
  }), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M135.505 321.712C142.988 321.712 149.054 318.178 149.054 313.818C149.054 309.458 142.988 305.924 135.505 305.924C128.023 305.924 121.957 309.458 121.957 313.818C121.957 318.178 128.023 321.712 135.505 321.712Z",
    fill: "url(#paint152_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M143.923 318.483C142.793 318.492 141.897 321.878 141.94 326.038C141.975 330.199 142.923 333.567 144.054 333.558C145.184 333.55 146.08 330.164 146.036 326.003C146.002 321.843 145.054 318.475 143.923 318.483Z",
    fill: "url(#paint153_radial_812_1630)"
  }), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M105.112 266.112C105.112 266.756 105.329 267.209 105.694 267.426C105.703 267.426 108.747 269.228 108.756 269.237C109.129 269.446 108.886 268.967 109.46 268.645C110.599 267.983 111.53 266.382 111.53 265.076C111.53 264.424 112.13 264.424 111.764 264.206C111.756 264.206 108.643 262.396 108.625 262.387C108.251 262.187 107.747 262.222 107.182 262.544C106.042 263.205 105.112 264.807 105.112 266.112Z",
    fill: "url(#paint154_linear_812_1630)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M106.703 267.792C106.703 268.671 107.008 269.289 107.495 269.585C107.512 269.594 111.669 272.048 111.677 272.057C112.191 272.344 111.86 271.691 112.634 271.247C114.199 270.342 115.46 268.158 115.46 266.365C115.46 265.477 116.278 265.468 115.773 265.172C115.756 265.172 111.504 262.7 111.486 262.692C110.973 262.413 110.277 262.465 109.512 262.909C107.947 263.814 106.686 265.999 106.686 267.792H106.703Z",
    fill: "url(#paint155_linear_812_1630)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M126.861 264.789L126.739 264.485L127.513 264.093C127.705 263.962 127.905 263.849 128.131 263.78L128.252 263.719V263.736C128.531 263.666 128.818 263.632 129.131 263.649C131.574 263.78 134.462 266.695 135.575 270.142L146.619 308.039C147.515 310.824 146.984 313.113 145.462 313.827L144.715 314.262L144.628 314.044C144.497 314.053 144.358 314.062 144.21 314.044C141.766 313.914 138.879 310.998 137.766 307.551L126.722 269.655C126.07 267.627 126.174 265.868 126.861 264.78V264.789Z",
    fill: "url(#paint156_linear_812_1630)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M143.288 314.549C145.732 314.68 146.81 311.99 145.697 308.543L134.653 270.647C133.54 267.191 130.653 264.284 128.209 264.154C125.765 264.023 124.687 266.713 125.8 270.159L136.844 308.056C137.958 311.512 140.845 314.419 143.288 314.549Z",
    fill: "url(#paint157_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M143.288 314.549C145.732 314.68 146.81 311.99 145.697 308.543L134.653 270.647C133.54 267.191 130.653 264.284 128.209 264.154C125.765 264.023 124.687 266.713 125.8 270.159L136.844 308.056C137.958 311.512 140.845 314.419 143.288 314.549Z",
    fill: "url(#paint158_linear_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M145.593 308.683L134.549 270.786C133.436 267.331 130.548 264.424 128.105 264.293C127.487 264.258 126.957 264.406 126.522 264.702C126.992 264.267 127.618 264.032 128.374 264.075C130.818 264.206 133.705 267.122 134.818 270.569L145.862 308.465C146.697 311.042 146.306 313.2 145.028 314.062C146.08 313.087 146.358 311.068 145.584 308.683H145.593Z",
    fill: "url(#paint159_radial_812_1630)"
  }), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M135.279 311.137V319.258L127.287 314.628V306.437L135.279 311.137Z",
    fill: "url(#paint160_linear_812_1630)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M135.271 311.137V319.258L143.228 314.645V306.455L135.271 311.137Z",
    fill: "url(#paint161_linear_812_1630)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M143.228 306.455L135.271 311.137L127.287 306.437L135.262 301.772L143.228 306.455Z",
    fill: "url(#paint162_linear_812_1630)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M172.751 292.894L141.236 274.572C140.227 273.989 139.41 274.607 139.41 275.956V276.583C139.41 277.932 140.227 279.499 141.236 280.082L172.751 298.404C173.76 298.987 174.578 298.369 174.578 297.02V296.393C174.578 295.044 173.76 293.477 172.751 292.894Z",
    fill: "url(#paint163_linear_812_1630)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M173.699 292.337L142.184 274.015C141.749 273.763 141.358 273.737 141.045 273.893H141.036L140.036 274.468C140.358 274.285 140.775 274.302 141.245 274.564L172.76 292.885C173.769 293.468 174.586 295.035 174.586 296.384V297.011C174.586 297.664 174.395 298.142 174.073 298.403L174.63 298.038C175.099 297.768 175.526 297.35 175.526 296.463V295.836C175.526 294.487 174.708 292.92 173.699 292.337Z",
    fill: "url(#paint164_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M172.856 292.807L141.341 274.485C140.836 274.198 140.384 274.207 140.053 274.45C140.349 274.337 140.723 274.381 141.114 274.607L172.63 292.929C173.638 293.512 174.456 295.079 174.456 296.428V297.054C174.456 297.733 174.247 298.229 173.917 298.473C174.378 298.299 174.682 297.751 174.682 296.933V296.306C174.682 294.957 173.865 293.39 172.856 292.807Z",
    fill: "url(#paint165_radial_812_1630)"
  }), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M169.829 293.93L169.769 293.773L170.169 293.573C170.264 293.503 170.786 293.294 170.899 293.26L170.96 293.225C171.099 293.199 171.247 293.181 171.403 293.19C172.656 293.26 174.134 294.748 174.708 296.515L177.63 305.515C178.091 306.942 177.821 308.117 177.039 308.483L176.239 308.857L176.195 308.744C176.126 308.744 176.056 308.744 175.978 308.744C174.725 308.674 173.247 307.186 172.673 305.419L169.751 296.419C169.421 295.383 169.473 294.478 169.821 293.921L169.829 293.93Z",
    fill: "url(#paint166_linear_812_1630)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M175.508 309.014C176.76 309.083 177.317 307.708 176.743 305.932L173.821 296.933C173.247 295.166 171.769 293.677 170.517 293.608C169.264 293.538 168.708 294.913 169.282 296.689L172.204 305.689C172.778 307.456 174.256 308.944 175.508 309.014Z",
    fill: "url(#paint167_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M176.691 306.011L173.769 297.011C173.195 295.244 171.717 293.756 170.464 293.686C170.151 293.669 169.873 293.747 169.656 293.895C169.899 293.669 170.221 293.555 170.603 293.573C171.856 293.642 173.334 295.131 173.908 296.898L176.83 305.898C177.256 307.221 177.056 308.317 176.404 308.77C176.943 308.265 177.082 307.238 176.691 306.011Z",
    fill: "url(#paint168_radial_812_1630)"
  }), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M172.673 317.709H171.76V327.988C171.76 328.136 171.96 328.258 172.212 328.258C172.464 328.258 172.664 328.136 172.664 327.997V317.717L172.673 317.709Z",
    fill: "url(#paint169_linear_812_1630)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M170.49 313.896H173.951V319.232V319.241C173.951 319.806 173.177 320.25 172.221 320.25C171.264 320.25 170.49 319.798 170.49 319.241C170.49 319.241 170.49 319.232 170.49 319.223V313.888V313.896Z",
    fill: "url(#paint170_linear_812_1630)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M169.108 306.35H175.325V313.444C175.325 313.444 175.325 313.461 175.325 313.47C175.325 314.471 173.934 315.28 172.212 315.28C170.49 315.28 169.099 314.471 169.099 313.47C169.099 313.47 169.099 313.452 169.099 313.444V306.35H169.108Z",
    fill: "url(#paint171_linear_812_1630)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M175.325 306.368C175.325 307.368 173.934 308.178 172.212 308.178C170.49 308.178 169.099 307.368 169.099 306.368C169.099 305.367 170.49 304.557 172.212 304.557C173.934 304.557 175.325 305.367 175.325 306.368Z",
    fill: "url(#paint172_linear_812_1630)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M174.447 306.341C174.447 307.055 173.447 307.638 172.221 307.638C170.995 307.638 169.995 307.055 169.995 306.341C169.995 305.628 170.995 305.045 172.221 305.045C173.447 305.045 174.447 305.628 174.447 306.341Z",
    fill: "url(#paint173_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M174.447 306.341C174.447 307.055 173.447 307.638 172.221 307.638C170.995 307.638 169.995 307.055 169.995 306.341C169.995 305.628 170.995 305.045 172.221 305.045C173.447 305.045 174.447 305.628 174.447 306.341Z",
    fill: "url(#paint174_linear_812_1630)"
  }), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M169.986 310.746C169.986 311.72 169.299 312.121 168.447 311.625C167.594 311.129 166.907 309.936 166.907 308.961C166.907 307.986 167.594 307.586 168.447 308.082C169.299 308.578 169.986 309.771 169.986 310.746Z",
    fill: "url(#paint175_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M168.525 308.047C168.116 307.812 167.742 307.778 167.473 307.917C167.734 307.847 168.047 307.899 168.394 308.1C169.247 308.596 169.934 309.788 169.934 310.763C169.934 311.277 169.742 311.625 169.447 311.773C169.821 311.668 170.064 311.294 170.064 310.711C170.064 309.736 169.377 308.544 168.525 308.047Z",
    fill: "#E6E7E8"
  }))), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54 275.408V286.279L110.234 275.112V264.415L129.54 275.408Z",
    fill: "url(#paint176_linear_812_1630)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M129.522 275.408V286.279L138.653 281.344V270.36L129.522 275.408Z",
    fill: "url(#paint177_linear_812_1630)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M138.653 270.36L129.522 275.408L110.234 264.415L119.4 259.401L138.653 270.36Z",
    fill: "url(#paint178_linear_812_1630)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M139.21 280.961V289.717L130.348 284.538V275.913L139.21 280.961Z",
    fill: "url(#paint179_linear_812_1630)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M139.192 280.961V289.717L146.558 285.739V276.879L139.192 280.961Z",
    fill: "url(#paint180_linear_812_1630)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M146.558 276.879L139.192 280.961L130.348 275.913L137.732 271.874L146.558 276.879Z",
    fill: "url(#paint181_linear_812_1630)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M139.74 285.374C139.74 287.437 141.193 288.263 142.984 287.228C144.775 286.192 146.228 283.685 146.228 281.622C146.228 279.56 144.775 278.733 142.984 279.769C141.193 280.804 139.74 283.311 139.74 285.374Z",
    fill: "url(#paint182_linear_812_1630)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M140.358 285.069C140.358 285.922 140.653 286.523 141.132 286.819C141.149 286.827 166.664 301.415 166.673 301.424C167.168 301.702 166.855 301.067 167.603 300.632C169.125 299.753 170.351 297.629 170.351 295.888C170.351 295.026 171.151 295.018 170.656 294.73C170.638 294.73 145.028 280.125 145.019 280.117C144.523 279.847 143.845 279.899 143.097 280.326C141.575 281.205 140.349 283.328 140.349 285.069H140.358Z",
    fill: "url(#paint183_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M140.358 285.069C140.358 285.922 140.653 286.523 141.132 286.819C141.149 286.827 166.664 301.415 166.673 301.424C167.168 301.702 166.855 301.067 167.603 300.632C169.125 299.753 170.351 297.629 170.351 295.888C170.351 295.026 171.151 295.018 170.656 294.73C170.638 294.73 145.028 280.125 145.019 280.117C144.523 279.847 143.845 279.899 143.097 280.326C141.575 281.205 140.349 283.328 140.349 285.069H140.358Z",
    fill: "url(#paint184_linear_812_1630)"
  }), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M165.977 299.692C165.977 301.432 167.212 302.137 168.725 301.258C170.247 300.379 171.473 298.256 171.473 296.515C171.473 294.774 170.238 294.069 168.725 294.948C167.203 295.827 165.977 297.951 165.977 299.692Z",
    fill: "url(#paint185_linear_812_1630)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M166.847 299.169C166.847 300.353 167.682 300.832 168.708 300.231C169.734 299.639 170.569 298.195 170.569 297.011C170.569 295.827 169.734 295.348 168.708 295.949C167.682 296.541 166.847 297.986 166.847 299.169Z",
    fill: "url(#paint186_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M166.847 299.169C166.847 300.353 167.682 300.832 168.708 300.231C169.734 299.639 170.569 298.195 170.569 297.011C170.569 295.827 169.734 295.348 168.708 295.949C167.682 296.541 166.847 297.986 166.847 299.169Z",
    fill: "url(#paint187_linear_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M168.595 294.878C169.325 294.461 169.986 294.4 170.473 294.643C170.012 294.513 169.447 294.609 168.829 294.965C167.308 295.845 166.081 297.968 166.081 299.709C166.081 300.614 166.412 301.241 166.951 301.511C166.281 301.319 165.847 300.658 165.847 299.622C165.847 297.881 167.082 295.758 168.595 294.878Z",
    fill: "url(#paint188_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M156.22 289.021C155.872 289.63 152.637 288.229 157.95 291.327C163.264 294.426 167.864 296.445 168.212 295.845C168.56 295.235 164.542 292.232 159.22 289.134C153.907 286.035 156.568 288.42 156.211 289.021H156.22Z",
    fill: "url(#paint189_radial_812_1630)"
  }), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M116.156 270.629L116.034 270.325L116.808 269.933C117 269.803 117.2 269.689 117.426 269.62L117.547 269.559V269.576C117.826 269.507 118.113 269.472 118.426 269.489C120.869 269.62 123.757 272.536 124.87 275.982L135.914 313.879C136.81 316.664 136.279 318.953 134.757 319.667L134.009 320.102L133.922 319.885C133.792 319.893 133.653 319.902 133.505 319.885C131.061 319.754 128.174 316.838 127.061 313.392L116.017 275.495C115.365 273.467 115.469 271.709 116.156 270.621V270.629Z",
    fill: "url(#paint190_linear_812_1630)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M132.583 320.398C135.027 320.529 136.105 317.839 134.992 314.392L123.948 276.496C122.835 273.04 119.948 270.133 117.504 270.003C115.06 269.872 113.982 272.562 115.095 276.008L126.139 313.905C127.253 317.361 130.14 320.268 132.583 320.398Z",
    fill: "url(#paint191_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M134.888 314.523L123.844 276.626C122.73 273.171 119.843 270.264 117.4 270.133C116.782 270.099 116.252 270.246 115.817 270.542C116.286 270.107 116.913 269.872 117.669 269.916C120.113 270.046 123 272.962 124.113 276.409L135.157 314.305C135.992 316.882 135.601 319.04 134.323 319.902C135.375 318.927 135.653 316.908 134.879 314.523H134.888Z",
    fill: "url(#paint192_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M133.201 316.394C133.201 317.874 132.157 318.466 130.87 317.726C129.583 316.986 128.54 315.176 128.54 313.696C128.54 312.217 129.583 311.625 130.87 312.365C132.157 313.113 133.201 314.915 133.201 316.394Z",
    fill: "#B086CC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M121.339 277.088C121.339 278.567 120.295 279.159 119.008 278.419C117.721 277.68 116.678 275.869 116.678 274.39C116.678 272.91 117.721 272.318 119.008 273.058C120.295 273.798 121.339 275.608 121.339 277.088Z",
    fill: "#B086CC"
  }))), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M120.73 276.983C120.73 277.575 120.522 278.002 120.191 278.202C120.183 278.202 119.226 278.768 119.217 278.776C118.869 278.968 119.095 278.533 118.565 278.228C117.504 277.619 116.643 276.13 116.643 274.912C116.643 274.311 116.087 274.302 116.426 274.102C116.434 274.102 117.452 273.528 117.469 273.519C117.817 273.328 118.287 273.362 118.808 273.667C119.869 274.276 120.73 275.765 120.73 276.983Z",
    fill: "url(#paint193_linear_812_1630)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M119.704 277.575C119.704 278.794 118.843 279.281 117.782 278.672C116.721 278.063 115.86 276.574 115.86 275.356C115.86 274.137 116.721 273.65 117.782 274.259C118.843 274.868 119.704 276.357 119.704 277.575Z",
    fill: "url(#paint194_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M117.878 274.215C117.373 273.92 116.904 273.885 116.565 274.05C116.886 273.963 117.278 274.024 117.713 274.276C118.774 274.886 119.634 276.374 119.634 277.593C119.634 278.228 119.4 278.663 119.026 278.846C119.495 278.715 119.8 278.245 119.8 277.523C119.8 276.304 118.939 274.825 117.878 274.207V274.215Z",
    fill: "url(#paint195_radial_812_1630)"
  }), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M132.548 316.333C132.548 316.925 132.34 317.352 132.009 317.552C132.001 317.552 131.044 318.118 131.035 318.126C130.687 318.318 130.914 317.883 130.383 317.578C129.322 316.969 128.461 315.48 128.461 314.262C128.461 313.661 127.905 313.653 128.244 313.452C128.253 313.452 129.27 312.878 129.287 312.869C129.635 312.678 130.105 312.713 130.627 313.017C131.688 313.627 132.548 315.115 132.548 316.333Z",
    fill: "url(#paint196_linear_812_1630)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M131.531 316.917C131.531 318.135 130.67 318.623 129.609 318.013C128.548 317.404 127.687 315.916 127.687 314.697C127.687 313.479 128.548 312.991 129.609 313.6C130.67 314.21 131.531 315.698 131.531 316.917Z",
    fill: "url(#paint197_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M129.705 313.557C129.2 313.261 128.731 313.226 128.392 313.392C128.713 313.305 129.105 313.365 129.54 313.618C130.6 314.227 131.461 315.716 131.461 316.934C131.461 317.569 131.227 318.005 130.853 318.187C131.322 318.057 131.627 317.587 131.627 316.864C131.627 315.646 130.766 314.166 129.705 313.548V313.557Z",
    fill: "url(#paint198_radial_812_1630)"
  }), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M166.725 300.658C166.725 301.633 166.038 302.033 165.186 301.537C164.333 301.041 163.646 299.848 163.646 298.874C163.646 297.899 164.333 297.498 165.186 297.994C166.038 298.491 166.725 299.683 166.725 300.658Z",
    fill: "url(#paint199_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M165.255 297.96C164.847 297.725 164.473 297.69 164.203 297.829C164.464 297.759 164.777 297.812 165.125 298.012C165.977 298.508 166.664 299.7 166.664 300.675C166.664 301.189 166.473 301.537 166.177 301.685C166.551 301.58 166.795 301.206 166.795 300.623C166.795 299.648 166.108 298.456 165.255 297.96Z",
    fill: "#E6E7E8"
  }))), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M162.968 297.777L162.907 297.62L163.307 297.42C163.403 297.35 163.925 297.141 164.038 297.107L164.099 297.072C164.238 297.046 164.386 297.028 164.542 297.037C165.794 297.107 167.273 298.595 167.847 300.362L170.769 309.362C171.23 310.789 170.96 311.964 170.177 312.33L169.377 312.704L169.334 312.591C169.264 312.591 169.195 312.591 169.116 312.591C167.864 312.521 166.386 311.033 165.812 309.266L162.89 300.266C162.559 299.23 162.612 298.325 162.959 297.768L162.968 297.777Z",
    fill: "url(#paint200_linear_812_1630)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M168.655 312.861C169.908 312.93 170.464 311.555 169.89 309.779L166.968 300.78C166.394 299.013 164.916 297.524 163.664 297.455C162.411 297.385 161.855 298.76 162.429 300.536L165.351 309.536C165.925 311.303 167.403 312.791 168.655 312.861Z",
    fill: "url(#paint201_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M169.829 309.849L166.908 300.849C166.334 299.082 164.855 297.594 163.603 297.524C163.29 297.507 163.012 297.585 162.794 297.733C163.038 297.507 163.359 297.394 163.742 297.411C164.994 297.481 166.473 298.969 167.047 300.736L169.969 309.736C170.395 311.059 170.195 312.156 169.543 312.608C170.082 312.103 170.221 311.076 169.829 309.849Z",
    fill: "url(#paint202_radial_812_1630)"
  }), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M164.377 297.725L132.862 279.403C131.853 278.82 131.035 279.438 131.035 280.787V281.414C131.035 282.763 131.853 284.329 132.862 284.913L164.377 303.234C165.386 303.817 166.203 303.199 166.203 301.85V301.224C166.203 299.874 165.386 298.308 164.377 297.725Z",
    fill: "url(#paint203_linear_812_1630)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M165.316 297.168L133.801 278.846C133.366 278.593 132.975 278.567 132.662 278.724H132.653L131.653 279.299C131.975 279.116 132.392 279.133 132.862 279.403L164.377 297.725C165.386 298.308 166.203 299.874 166.203 301.224V301.85C166.203 302.503 166.012 302.982 165.69 303.243L166.247 302.877C166.716 302.607 167.142 302.19 167.142 301.302V300.675C167.142 299.326 166.325 297.759 165.316 297.176V297.168Z",
    fill: "url(#paint204_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M164.481 297.638L132.966 279.316C132.462 279.029 132.009 279.037 131.679 279.281C131.975 279.168 132.349 279.211 132.74 279.438L164.255 297.759C165.264 298.343 166.081 299.909 166.081 301.258V301.885C166.081 302.564 165.873 303.06 165.542 303.304C166.003 303.13 166.307 302.581 166.307 301.763V301.137C166.307 299.787 165.49 298.221 164.481 297.638Z",
    fill: "url(#paint205_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M164.907 300.893C164.907 301.711 164.325 302.05 163.612 301.633C162.899 301.215 162.316 300.214 162.316 299.396C162.316 298.578 162.899 298.238 163.612 298.656C164.325 299.074 164.907 300.075 164.907 300.893Z",
    fill: "#B086CC"
  }))), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M171.299 307.516H173.056C173.056 305.053 174.734 303.626 176.352 302.242C178.065 300.788 180.187 298.969 178.3 296.132C177.595 295.079 176.778 294.487 175.856 294.374C174.282 294.165 172.925 295.392 171.734 296.471C171.282 296.88 170.203 297.846 169.96 297.742C168.299 297.124 167.908 296.828 167.89 296.811L166.699 298.108C167.003 298.412 167.942 298.865 169.342 299.396C170.603 299.866 171.777 298.813 172.917 297.786C173.83 296.967 174.847 296.027 175.638 296.132C176.03 296.184 176.43 296.515 176.83 297.115C177.778 298.534 177.204 299.204 175.212 300.91C173.473 302.399 171.299 304.244 171.299 307.525V307.516Z",
    fill: "#45108A"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M164.473 300.814C164.473 301.145 164.36 301.389 164.168 301.502C164.168 301.502 163.629 301.824 163.62 301.824C163.429 301.937 163.551 301.685 163.255 301.511C162.655 301.163 162.177 300.327 162.177 299.648C162.177 299.309 161.864 299.309 162.055 299.196C162.055 299.196 162.638 298.874 162.638 298.865C162.829 298.76 163.099 298.778 163.394 298.952C163.994 299.3 164.473 300.136 164.473 300.814Z",
    fill: "url(#paint206_linear_812_1630)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M163.899 301.145C163.899 301.833 163.412 302.103 162.82 301.763C162.22 301.415 161.742 300.579 161.742 299.901C161.742 299.222 162.229 298.943 162.82 299.283C163.42 299.631 163.899 300.466 163.899 301.145Z",
    fill: "url(#paint207_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M162.872 299.256C162.585 299.091 162.325 299.065 162.133 299.169C162.316 299.117 162.533 299.161 162.777 299.3C163.377 299.648 163.855 300.484 163.855 301.163C163.855 301.519 163.725 301.763 163.516 301.868C163.777 301.798 163.951 301.528 163.951 301.128C163.951 300.44 163.464 299.605 162.872 299.265V299.256Z",
    fill: "url(#paint208_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M169.195 311.181C169.195 311.999 168.612 312.338 167.899 311.921C167.186 311.503 166.603 310.502 166.603 309.684C166.603 308.866 167.186 308.526 167.899 308.944C168.612 309.362 169.195 310.363 169.195 311.181Z",
    fill: "#B086CC"
  }))), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M168.768 311.111C168.768 311.442 168.655 311.686 168.464 311.799L167.925 312.121C167.725 312.234 167.847 311.982 167.551 311.816C166.951 311.468 166.472 310.632 166.472 309.954C166.472 309.614 166.159 309.614 166.351 309.501L166.933 309.179C167.133 309.074 167.403 309.092 167.69 309.257C168.29 309.605 168.768 310.441 168.768 311.12V311.111Z",
    fill: "url(#paint209_linear_812_1630)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M168.186 311.442C168.186 312.13 167.699 312.399 167.107 312.06C166.507 311.712 166.029 310.876 166.029 310.197C166.029 309.518 166.516 309.24 167.107 309.579C167.707 309.927 168.186 310.763 168.186 311.442Z",
    fill: "url(#paint210_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M167.16 309.553C166.873 309.388 166.612 309.362 166.42 309.466C166.603 309.414 166.82 309.457 167.064 309.597C167.664 309.945 168.142 310.78 168.142 311.459C168.142 311.816 168.012 312.06 167.803 312.164C168.064 312.095 168.238 311.825 168.238 311.424C168.238 310.737 167.751 309.901 167.16 309.562V309.553Z",
    fill: "url(#paint211_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M134.957 283.328C134.957 284.147 134.375 284.486 133.662 284.068C132.949 283.65 132.366 282.65 132.366 281.831C132.366 281.013 132.949 280.674 133.662 281.092C134.375 281.509 134.957 282.51 134.957 283.328Z",
    fill: "#B086CC"
  }))), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M134.531 283.259C134.531 283.59 134.418 283.833 134.227 283.946L133.688 284.268C133.488 284.382 133.609 284.129 133.314 283.964C132.714 283.616 132.235 282.78 132.235 282.101C132.235 281.762 131.922 281.762 132.114 281.649C132.114 281.649 132.696 281.327 132.696 281.318C132.888 281.213 133.157 281.231 133.453 281.405C134.053 281.753 134.531 282.589 134.531 283.267V283.259Z",
    fill: "url(#paint212_linear_812_1630)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M133.957 283.59C133.957 284.277 133.47 284.547 132.879 284.207C132.279 283.859 131.801 283.024 131.801 282.345C131.801 281.666 132.288 281.387 132.879 281.727C133.479 282.075 133.957 282.911 133.957 283.59Z",
    fill: "url(#paint213_linear_812_1630)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M132.922 281.701C132.635 281.535 132.374 281.509 132.183 281.614C132.366 281.562 132.583 281.605 132.827 281.744C133.427 282.092 133.905 282.928 133.905 283.607C133.905 283.964 133.775 284.207 133.566 284.312C133.827 284.242 134.001 283.972 134.001 283.572C134.001 282.884 133.514 282.049 132.922 281.709V281.701Z",
    fill: "url(#paint214_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M449.899 224.563C451.826 212.575 443.678 201.293 431.7 199.364C419.722 197.435 408.45 205.59 406.523 217.578C404.596 229.567 412.743 240.849 424.721 242.778C436.699 244.706 447.971 236.551 449.899 224.563Z",
    fill: "url(#paint215_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M373.774 250.941L375.783 254.362L428.317 223.489L426.3 220.069L373.774 250.941Z",
    fill: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M378.644 248.408L426.36 220.365L428.091 223.289L380.366 251.333L378.644 248.408Z",
    fill: "url(#paint216_linear_812_1630)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M383.514 245.876L426.421 220.652L427.865 223.098L384.949 248.313L383.514 245.876Z",
    fill: "url(#paint217_linear_812_1630)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M388.375 243.334L426.482 220.948L427.639 222.906L389.532 245.292L388.375 243.334Z",
    fill: "url(#paint218_linear_812_1630)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M393.245 240.801L426.543 221.235L427.413 222.706L394.115 242.272L393.245 240.801Z",
    fill: "url(#paint219_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M320.405 381.76C332.537 381.76 342.372 371.917 342.372 359.774C342.372 347.632 332.537 337.789 320.405 337.789C308.273 337.789 298.438 347.632 298.438 359.774C298.438 371.917 308.273 381.76 320.405 381.76Z",
    fill: "url(#paint220_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M265.94 389.629L267.949 393.041L320.483 362.168L318.466 358.756L265.94 389.629Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M270.81 387.087L318.527 359.043L320.257 361.977L272.532 390.02L270.81 387.087Z",
    fill: "url(#paint221_linear_812_1630)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M275.68 384.554L318.588 359.339L320.031 361.776L277.115 387L275.68 384.554Z",
    fill: "url(#paint222_linear_812_1630)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M280.542 382.022L318.649 359.627L319.805 361.585L281.698 383.971L280.542 382.022Z",
    fill: "url(#paint223_linear_812_1630)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M285.411 379.48L318.709 359.914L319.579 361.385L286.281 380.951L285.411 379.48Z",
    fill: "url(#paint224_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M352.504 98.8048C354.431 86.8165 346.283 75.5344 334.305 73.6056C322.327 71.6768 311.055 79.8316 309.128 91.82C307.201 103.808 315.349 115.09 327.327 117.019C339.304 118.948 350.577 110.793 352.504 98.8048Z",
    fill: "url(#paint225_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M276.376 125.17L278.385 128.591L330.919 97.7184L328.901 94.2977L276.376 125.17Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M281.246 122.638L328.962 94.5937L330.693 97.5182L282.968 125.562L281.246 122.638Z",
    fill: "url(#paint226_linear_812_1630)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M286.116 120.105L329.023 94.8809L330.467 97.3267L287.551 122.542L286.116 120.105Z",
    fill: "url(#paint227_linear_812_1630)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M290.977 117.563L329.084 95.1768L330.241 97.1352L292.134 119.522L290.977 117.563Z",
    fill: "url(#paint228_linear_812_1630)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M295.847 115.03L329.145 95.4641L330.015 96.935L296.717 116.501L295.847 115.03Z",
    fill: "url(#paint229_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M182.338 110.861C190.917 102.275 190.917 88.354 182.338 79.7679C173.76 71.1819 159.851 71.1819 151.272 79.7679C142.694 88.354 142.694 102.275 151.272 110.861C159.851 119.447 173.76 119.447 182.338 110.861Z",
    fill: "url(#paint230_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M201.692 113.203L199.675 116.623L166.733 97.7184L168.751 94.2977L201.692 113.203Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M201.718 113.664L199.988 116.588L166.959 97.5182L168.69 94.5937L201.718 113.664Z",
    fill: "url(#paint231_linear_812_1630)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M201.745 114.116L200.301 116.562L167.186 97.3267L168.629 94.8809L201.745 114.116Z",
    fill: "url(#paint232_linear_812_1630)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M201.771 114.569L200.623 116.527L167.412 97.1352L168.568 95.1768L201.771 114.569Z",
    fill: "url(#paint233_linear_812_1630)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M201.805 115.03L168.507 95.4641L167.638 96.935L200.936 116.501L201.805 115.03Z",
    fill: "url(#paint234_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M174.343 383.066C186.475 383.066 196.31 373.223 196.31 361.08C196.31 348.938 186.475 339.094 174.343 339.094C162.211 339.094 152.376 348.938 152.376 361.08C152.376 373.223 162.211 383.066 174.343 383.066Z",
    fill: "url(#paint235_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M197.197 372.508L195.179 375.92L174.273 363.474L176.282 360.062L197.197 372.508Z",
    fill: "black"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M196.423 372.395L194.692 375.328L174.499 363.282L176.23 360.349L196.423 372.395Z",
    fill: "url(#paint236_linear_812_1630)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M195.649 372.282L194.205 374.728L174.725 363.082L176.169 360.645L195.649 372.282Z",
    fill: "url(#paint237_linear_812_1630)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M194.875 372.169L193.718 374.127L174.951 362.89L176.108 360.932L194.875 372.169Z",
    fill: "url(#paint238_linear_812_1630)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M194.092 372.056L176.047 361.219L175.177 362.69L193.222 373.527L194.092 372.056Z",
    fill: "url(#paint239_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M103.855 229.889C112.433 221.303 112.433 207.382 103.855 198.796C95.2761 190.21 81.3675 190.21 72.789 198.796C64.2104 207.382 64.2104 221.303 72.789 229.889C81.3675 238.475 95.2761 238.475 103.855 229.889Z",
    fill: "url(#paint240_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M131.844 237.746L129.827 241.167L88.2498 216.744L90.2673 213.323L131.844 237.746Z",
    fill: "black"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M129.714 236.824L127.983 239.757L88.4758 216.544L90.2064 213.619L129.714 236.824Z",
    fill: "url(#paint241_linear_812_1630)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M127.583 235.901L126.139 238.347L88.7019 216.352L90.1455 213.906L127.583 235.901Z",
    fill: "url(#paint242_linear_812_1630)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M125.452 234.978L124.296 236.937L88.928 216.161L90.0846 214.202L125.452 234.978Z",
    fill: "url(#paint243_linear_812_1630)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M123.322 234.056L90.0237 214.489L89.1541 215.96L122.452 235.527L123.322 234.056Z",
    fill: "url(#paint244_linear_812_1630)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M358.973 238.277C354.834 235.84 349.503 237.224 347.068 241.376C344.633 245.519 346.016 250.854 350.164 253.291C354.303 255.728 359.634 254.345 362.069 250.193C364.504 246.041 363.121 240.714 358.973 238.277Z",
    fill: "url(#paint245_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M352.051 235.466C348.424 233.333 343.763 234.543 341.633 238.173C339.502 241.802 340.711 246.468 344.337 248.6C347.964 250.732 352.625 249.523 354.755 245.893C356.886 242.264 355.677 237.598 352.051 235.466Z",
    fill: "url(#paint246_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M345.764 233.029C342.659 231.201 338.659 232.245 336.832 235.353C335.006 238.46 336.05 242.464 339.154 244.292C342.259 246.119 346.259 245.075 348.085 241.968C349.912 238.86 348.868 234.857 345.764 233.029Z",
    fill: "url(#paint247_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M340.537 231.218C337.946 229.695 334.615 230.566 333.102 233.151C331.58 235.744 332.45 239.078 335.032 240.592C337.624 242.116 340.955 241.245 342.468 238.66C343.99 236.066 343.12 232.733 340.537 231.218Z",
    fill: "url(#paint248_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M335.945 229.782C333.876 228.564 331.215 229.26 329.997 231.331C328.78 233.403 329.475 236.066 331.545 237.285C333.615 238.503 336.276 237.807 337.493 235.736C338.711 233.664 338.015 231.001 335.945 229.782Z",
    fill: "url(#paint249_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M276.767 379.785C272.628 377.348 267.297 378.732 264.862 382.883C262.427 387.026 263.81 392.362 267.958 394.799C272.098 397.236 277.428 395.852 279.863 391.7C282.298 387.557 280.916 382.222 276.767 379.785Z",
    fill: "url(#paint250_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M269.837 376.973C266.21 374.841 261.549 376.051 259.419 379.68C257.288 383.31 258.497 387.975 262.123 390.108C265.749 392.24 270.411 391.03 272.541 387.401C274.672 383.771 273.463 379.106 269.837 376.973Z",
    fill: "url(#paint251_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M263.549 374.536C260.445 372.708 256.444 373.753 254.618 376.86C252.792 379.967 253.835 383.971 256.94 385.799C260.045 387.627 264.045 386.582 265.871 383.475C267.697 380.368 266.654 376.364 263.549 374.536Z",
    fill: "url(#paint252_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M258.323 372.726C255.731 371.203 252.401 372.073 250.888 374.658C249.366 377.252 250.235 380.585 252.818 382.1C255.41 383.623 258.74 382.753 260.253 380.168C261.775 377.574 260.906 374.24 258.323 372.726Z",
    fill: "url(#paint253_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M253.731 371.29C251.661 370.071 249 370.767 247.783 372.839C246.565 374.911 247.261 377.583 249.331 378.792C251.4 380.011 254.062 379.315 255.279 377.243C256.496 375.172 255.801 372.508 253.731 371.29Z",
    fill: "url(#paint254_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M200.501 301.781C204.684 299.422 209.989 300.893 212.346 305.079C214.702 309.266 213.233 314.575 209.05 316.934C204.867 319.301 199.562 317.822 197.205 313.635C194.849 309.449 196.318 304.139 200.501 301.781Z",
    fill: "url(#paint255_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M207.476 299.091C211.137 297.02 215.781 298.316 217.842 301.981C219.911 305.645 218.616 310.293 214.954 312.356C211.293 314.419 206.649 313.13 204.588 309.466C202.519 305.802 203.814 301.154 207.476 299.091Z",
    fill: "url(#paint256_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M221.027 307.555C223.868 305.338 224.376 301.237 222.161 298.393C219.946 295.55 215.848 295.042 213.007 297.259C210.166 299.475 209.659 303.577 211.873 306.42C214.088 309.264 218.186 309.772 221.027 307.555Z",
    fill: "url(#paint257_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M219.068 295.044C221.685 293.564 224.999 294.487 226.477 297.107C227.955 299.726 227.034 303.043 224.416 304.522C221.798 306.002 218.485 305.079 217.007 302.46C215.528 299.84 216.45 296.523 219.068 295.044Z",
    fill: "url(#paint258_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M223.677 293.686C225.764 292.502 228.416 293.242 229.599 295.34C230.782 297.429 230.042 300.083 227.947 301.267C225.86 302.451 223.207 301.711 222.024 299.613C220.842 297.524 221.581 294.87 223.677 293.686Z",
    fill: "url(#paint259_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M144.845 234.761C149.028 232.402 154.333 233.873 156.689 238.06C159.046 242.246 157.576 247.555 153.393 249.914C149.21 252.282 143.906 250.802 141.549 246.615C139.192 242.429 140.662 237.12 144.845 234.761Z",
    fill: "url(#paint260_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M151.819 232.071C155.48 230 160.124 231.297 162.185 234.961C164.255 238.625 162.959 243.273 159.298 245.336C155.637 247.399 150.993 246.111 148.932 242.446C146.862 238.782 148.158 234.134 151.819 232.071Z",
    fill: "url(#paint261_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M165.361 240.578C168.203 238.363 168.713 234.261 166.5 231.417C164.286 228.572 160.188 228.062 157.346 230.277C154.504 232.493 153.995 236.594 156.208 239.439C158.421 242.283 162.519 242.793 165.361 240.578Z",
    fill: "url(#paint262_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M163.412 228.024C166.029 226.544 169.342 227.467 170.821 230.087C172.299 232.707 171.377 236.023 168.76 237.503C166.142 238.982 162.829 238.06 161.351 235.44C159.872 232.82 160.794 229.504 163.412 228.024Z",
    fill: "url(#paint263_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M168.021 226.666C170.108 225.482 172.76 226.222 173.943 228.32C175.125 230.409 174.386 233.064 172.29 234.247C170.203 235.431 167.551 234.691 166.368 232.594C165.186 230.505 165.925 227.85 168.021 226.666Z",
    fill: "url(#paint264_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M222.02 111.148C224.984 107.366 224.325 101.894 220.546 98.927C216.768 95.9596 211.301 96.6198 208.337 100.402C205.372 104.183 206.031 109.655 209.81 112.622C213.588 115.589 219.055 114.929 222.02 111.148Z",
    fill: "url(#paint265_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M225.433 103.028C229.042 105.178 230.225 109.852 228.077 113.464C225.929 117.076 221.259 118.259 217.65 116.11C214.041 113.96 212.859 109.286 215.007 105.674C217.154 102.062 221.824 100.878 225.433 103.028Z",
    fill: "url(#paint266_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M230.59 107.371C233.686 109.216 234.704 113.22 232.86 116.319C231.016 119.417 227.016 120.435 223.92 118.59C220.824 116.745 219.807 112.741 221.651 109.643C223.494 106.544 227.494 105.526 230.59 107.371Z",
    fill: "url(#paint267_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M234.695 111.079C237.278 112.619 238.121 115.953 236.582 118.538C235.043 121.123 231.712 121.967 229.129 120.427C226.546 118.886 225.703 115.553 227.242 112.968C228.781 110.382 232.112 109.538 234.695 111.079Z",
    fill: "url(#paint268_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M238.165 114.412C240.226 115.64 240.904 118.312 239.678 120.375C238.452 122.437 235.782 123.116 233.721 121.889C231.66 120.662 230.982 117.99 232.208 115.927C233.434 113.864 236.104 113.185 238.165 114.412Z",
    fill: "url(#paint269_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M326.971 132.656C322.84 135.119 321.492 140.454 323.944 144.589C326.405 148.723 331.736 150.072 335.867 147.618C339.998 145.154 341.346 139.819 338.893 135.685C336.432 131.55 331.101 130.201 326.971 132.656Z",
    fill: "url(#paint270_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.83,
    d: "M321.179 137.373C317.57 139.523 316.388 144.197 318.536 147.809C320.684 151.421 325.353 152.605 328.962 150.455C332.571 148.305 333.754 143.631 331.606 140.019C329.458 136.407 324.788 135.223 321.179 137.373Z",
    fill: "url(#paint271_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.65,
    d: "M316.014 141.716C312.918 143.562 311.9 147.565 313.744 150.664C315.587 153.763 319.588 154.781 322.684 152.936C325.779 151.09 326.797 147.087 324.953 143.988C323.11 140.89 319.109 139.871 316.014 141.716Z",
    fill: "url(#paint272_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.48,
    d: "M311.909 145.433C309.326 146.974 308.483 150.307 310.022 152.892C311.561 155.477 314.892 156.322 317.475 154.781C320.057 153.24 320.901 149.907 319.362 147.322C317.822 144.737 314.492 143.892 311.909 145.433Z",
    fill: "url(#paint273_radial_812_1630)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M308.439 148.767C306.378 149.994 305.7 152.666 306.926 154.729C308.152 156.792 310.822 157.47 312.883 156.243C314.944 155.016 315.622 152.344 314.396 150.281C313.17 148.218 310.5 147.539 308.439 148.767Z",
    fill: "url(#paint274_radial_812_1630)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.321 362.248) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_812_1630",
    x1: 309.9,
    y1: 351.985,
    x2: 401.385,
    y2: 351.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_812_1630",
    x1: 410.516,
    y1: 275.782,
    x2: 336.807,
    y2: 354.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.015 357.703) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.523 616.63) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_812_1630",
    x1: 95.1024,
    y1: 0.0000717635,
    x2: 186.587,
    y2: 0.0000717635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_812_1630",
    x1: 195.718,
    y1: 275.782,
    x2: 122.009,
    y2: 354.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.218 0.434916) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.91 217.026) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_812_1630",
    x1: 400.489,
    y1: 207.5,
    x2: 491.974,
    y2: 207.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_812_1630",
    x1: 501.105,
    y1: 131.298,
    x2: 427.396,
    y2: 210.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.604 213.219) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9339 217.026) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_812_1630",
    x1: 4.51333,
    y1: 207.5,
    x2: 95.9981,
    y2: 207.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_812_1630",
    x1: 105.138,
    y1: 131.298,
    x2: 31.429,
    y2: 210.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6374 213.219) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.523 93.9659) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_812_1630",
    x1: 95.1024,
    y1: 85.0629,
    x2: 186.587,
    y2: 85.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_812_1630",
    x1: 195.718,
    y1: 8.86055,
    x2: 122.009,
    y2: 87.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.218 90.7901) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(355.321 93.9659) scale(38.4549 23.478)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_812_1630",
    x1: -47.673,
    y1: 85.0629,
    x2: -46.8034,
    y2: 85.0629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#310964"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#2B0658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0C76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_812_1630",
    x1: 410.516,
    y1: 8.86055,
    x2: 336.807,
    y2: 87.8274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(341.015 90.7901) scale(34.2807 34.3107)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_812_1630",
    x1: 160.072,
    y1: 201.181,
    x2: 338.989,
    y2: 201.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#26054F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2B0758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#320967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3D0D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4D1294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6517AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6A18B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3B0C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2F0860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#270552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_812_1630",
    x1: 315.953,
    y1: 24.9453,
    x2: 242.227,
    y2: 215.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_812_1630",
    x1: 164.168,
    y1: 193.635,
    x2: 334.858,
    y2: 193.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#B086CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DAC6E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EBDEF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E3D2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D5BCE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#CFB1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#BE99D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B38BCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_812_1630",
    x1: 159.933,
    y1: 188.23,
    x2: 338.85,
    y2: 188.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#26054F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2B0758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#320967"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3D0D7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#4D1294"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6517AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#6A18B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3B0C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2F0860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#270552"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_812_1630",
    x1: 315.814,
    y1: 8.94757,
    x2: 242.088,
    y2: 199.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_812_1630",
    x1: 275.776,
    y1: 112.402,
    x2: 218.668,
    y2: 259.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(249.383 206.43) scale(65.9612 66.0189)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.035 247.005) rotate(-96.2945) scale(29.8688 21.8851)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_812_1630",
    x1: 329.771,
    y1: 204.524,
    x2: 342.144,
    y2: 224.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(331.841 214.785) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_812_1630",
    x1: 317.474,
    y1: 211.626,
    x2: 329.856,
    y2: 231.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(319.553 221.896) scale(8.20058 8.20774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_812_1630",
    x1: 305.187,
    y1: 218.737,
    x2: 317.56,
    y2: 238.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(307.256 229.008) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_812_1630",
    x1: 292.899,
    y1: 225.848,
    x2: 305.272,
    y2: 245.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.969 236.11) scale(8.20059 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_812_1630",
    x1: 280.602,
    y1: 232.95,
    x2: 292.984,
    y2: 252.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.681 243.221) scale(8.20059 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_812_1630",
    x1: 268.315,
    y1: 240.061,
    x2: 280.688,
    y2: 260.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.384 250.332) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_812_1630",
    x1: 169.36,
    y1: 204.524,
    x2: 156.978,
    y2: 224.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.281 214.785) rotate(180) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_812_1630",
    x1: 181.648,
    y1: 211.626,
    x2: 169.266,
    y2: 231.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.569 221.896) rotate(180) scale(8.20058 8.20774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_812_1630",
    x1: 193.935,
    y1: 218.737,
    x2: 181.562,
    y2: 238.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.865 229.008) rotate(180) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_812_1630",
    x1: 206.232,
    y1: 225.848,
    x2: 193.85,
    y2: 245.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.153 236.11) rotate(180) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_812_1630",
    x1: 218.52,
    y1: 232.95,
    x2: 206.138,
    y2: 252.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.441 243.221) rotate(180) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_812_1630",
    x1: 230.808,
    y1: 240.061,
    x2: 218.435,
    y2: 260.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9874C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1E8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DFCBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D4BAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(228.738 250.332) rotate(180) scale(8.20058 8.20775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_812_1630",
    x1: 249.783,
    y1: 230.365,
    x2: 249.783,
    y2: 62.8594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BB0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#189CBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#11738B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0C5060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#07333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#041C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#010C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#000303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_812_1630",
    x1: 321.214,
    y1: 333.419,
    x2: 395.315,
    y2: 333.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_812_1630",
    x1: 319.64,
    y1: 331.478,
    x2: 390.923,
    y2: 331.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_812_1630",
    x1: 321.214,
    y1: 343.35,
    x2: 395.315,
    y2: 343.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_812_1630",
    x1: 320.44,
    y1: 331.478,
    x2: 390.132,
    y2: 331.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F27BD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(366.983 355.483) rotate(-22.3576) scale(12.9939 8.58128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(343.239 320.811) rotate(-18.9954) scale(9.96685 5.88449)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_812_1630",
    x1: 803.343,
    y1: 598.897,
    x2: 787.467,
    y2: 561.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_812_1630",
    x1: 349.911,
    y1: 315.08,
    x2: 368.144,
    y2: 343.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A17BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#A882C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B48FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#C5A2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#DBBAF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E6C6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6B6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#B494DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9C7CCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8E6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_812_1630",
    x1: 323.362,
    y1: 263.893,
    x2: 397.579,
    y2: 328.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_812_1630",
    x1: 386.732,
    y1: 327.509,
    x2: 350.165,
    y2: 277.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_812_1630",
    x1: 342.798,
    y1: 272.301,
    x2: 394.254,
    y2: 332.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#741BBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55148B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3B0D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#25083D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#150422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#09020F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#020003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_812_1630",
    x1: 401.393,
    y1: 335.917,
    x2: 364.893,
    y2: 277.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(390.993 300.101) scale(6.19174 6.19716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(415.211 289.501) rotate(67.6776) scale(2.90672 1.91725)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(447.528 194.836) scale(28.1681 14.3353)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_812_1630",
    x1: 422.752,
    y1: 192.669,
    x2: 467.581,
    y2: 192.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_812_1630",
    x1: 472.059,
    y1: 153.902,
    x2: 435.945,
    y2: 192.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.005 194.053) scale(16.8012 16.8159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_812_1630",
    x1: 424.3,
    y1: 184.635,
    x2: 466.05,
    y2: 184.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_812_1630",
    x1: 424.3,
    y1: 183.634,
    x2: 466.05,
    y2: 183.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_812_1630",
    x1: -47.673,
    y1: 180.196,
    x2: -46.8033,
    y2: 180.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_812_1630",
    x1: 472.059,
    y1: 141.429,
    x2: 435.945,
    y2: 180.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.005 181.58) scale(16.8012 16.8159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_812_1630",
    x1: -47.6731,
    y1: 172.163,
    x2: -46.8035,
    y2: 172.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_812_1630",
    x1: -47.6731,
    y1: 171.153,
    x2: -46.8035,
    y2: 171.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_812_1630",
    x1: -47.673,
    y1: 168.063,
    x2: -46.8033,
    y2: 168.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_812_1630",
    x1: 472.059,
    y1: 129.305,
    x2: 435.945,
    y2: 167.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.005 169.447) scale(16.8012 16.8159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_812_1630",
    x1: -47.6731,
    y1: 160.029,
    x2: -46.8035,
    y2: 160.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_812_1630",
    x1: -47.6731,
    y1: 159.028,
    x2: -46.8035,
    y2: 159.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_812_1630",
    x1: -47.673,
    y1: 155.808,
    x2: -46.8033,
    y2: 155.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_812_1630",
    x1: 472.059,
    y1: 117.041,
    x2: 435.945,
    y2: 155.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.005 157.183) scale(16.8012 16.8159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_812_1630",
    x1: -47.6731,
    y1: 147.766,
    x2: -46.8035,
    y2: 147.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_812_1630",
    x1: -47.6731,
    y1: 146.765,
    x2: -46.8035,
    y2: 146.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C1DC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E41D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4C9BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2AF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#37D2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4F92E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#625FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#703BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7825CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_812_1630",
    x1: -47.673,
    y1: 143.544,
    x2: -46.8033,
    y2: 143.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_812_1630",
    x1: 472.059,
    y1: 104.777,
    x2: 435.945,
    y2: 143.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.005 144.919) scale(16.8012 16.8159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(445.927 138.895) scale(11.5135 5.85945)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_812_1630",
    x1: 436.283,
    y1: 133.543,
    x2: 454.223,
    y2: 133.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_812_1630",
    x1: 456.015,
    y1: 117.633,
    x2: 441.566,
    y2: 133.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_812_1630",
    x1: 451.971,
    y1: 129.139,
    x2: 437.892,
    y2: 129.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#270551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#2D085D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#380B72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_812_1630",
    x1: 451.971,
    y1: 128.26,
    x2: 437.892,
    y2: 128.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(442.388 133.7) scale(6.72221 6.7281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_812_1630",
    x1: 178.108,
    y1: 93.1749,
    x2: 109.431,
    y2: 38.7733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_812_1630",
    x1: 147.828,
    y1: 41.0823,
    x2: 159.415,
    y2: 26.8265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_812_1630",
    x1: 168.16,
    y1: 70.0749,
    x2: 187.946,
    y2: 114.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_812_1630",
    x1: 130.279,
    y1: 47.8365,
    x2: 155.491,
    y2: 61.6396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_812_1630",
    x1: 157.655,
    y1: 68.6039,
    x2: 195.697,
    y2: 49.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_812_1630",
    x1: 117.391,
    y1: 39.6722,
    x2: 126.912,
    y2: 89.8296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_812_1630",
    x1: 123.304,
    y1: 90.1634,
    x2: 132.634,
    y2: 25.3915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_812_1630",
    x1: 137.123,
    y1: 67.838,
    x2: 177.509,
    y2: 44.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_812_1630",
    x1: 126.67,
    y1: 64.0431,
    x2: 153.321,
    y2: 37.5109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_812_1630",
    x1: 100.816,
    y1: 63.7384,
    x2: 124.141,
    y2: 58.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_812_1630",
    x1: 119.896,
    y1: 47.0792,
    x2: 109.875,
    y2: 59.7348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_812_1630",
    x1: 100.816,
    y1: 63.7384,
    x2: 124.141,
    y2: 58.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_812_1630",
    x1: 107.286,
    y1: 59.0122,
    x2: 131.82,
    y2: 64.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_812_1630",
    x1: 108.843,
    y1: 71.0149,
    x2: 132.168,
    y2: 65.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_812_1630",
    x1: 111.738,
    y1: 57.6283,
    x2: 122.638,
    y2: 71.4756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_812_1630",
    x1: 122.017,
    y1: 75.802,
    x2: 145.343,
    y2: 70.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_812_1630",
    x1: 140.932,
    y1: 52.023,
    x2: 129.019,
    y2: 75.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_812_1630",
    x1: 111.582,
    y1: 54.6603,
    x2: 129.298,
    y2: 50.6979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_812_1630",
    x1: 122.017,
    y1: 75.802,
    x2: 145.343,
    y2: 70.5797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_812_1630",
    x1: 113.391,
    y1: 52.8586,
    x2: 123.019,
    y2: 49.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_812_1630",
    x1: 111.582,
    y1: 54.6603,
    x2: 129.298,
    y2: 50.6979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_812_1630",
    x1: 108.843,
    y1: 71.0149,
    x2: 132.168,
    y2: 65.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_812_1630",
    x1: 143.671,
    y1: 72.8166,
    x2: 163.806,
    y2: 66.7945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_812_1630",
    x1: 145.793,
    y1: 57.2018,
    x2: 157.326,
    y2: 53.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_812_1630",
    x1: 145.793,
    y1: 57.2018,
    x2: 157.326,
    y2: 53.7519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_812_1630",
    x1: 130.166,
    y1: 79.2139,
    x2: 126.132,
    y2: 32.3355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C1DC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_812_1630",
    x1: 149.124,
    y1: 83.0523,
    x2: 150.874,
    y2: 86.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_812_1630",
    x1: 132.07,
    y1: 50.9699,
    x2: 140.528,
    y2: 88.3324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_812_1630",
    x1: 160.925,
    y1: 55.3305,
    x2: 144.84,
    y2: 85.9566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_812_1630",
    x1: 150.072,
    y1: 69.1349,
    x2: 144.503,
    y2: 72.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#3D065F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_812_1630",
    x1: 137.34,
    y1: 53.0849,
    x2: 130.344,
    y2: 47.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_812_1630",
    x1: 147.811,
    y1: 67.9424,
    x2: 147.366,
    y2: 86.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_812_1630",
    x1: 330.676,
    y1: 1.67114,
    x2: 358.009,
    y2: 48.9734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(365.982 17.695) scale(29.5064 29.5322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_812_1630",
    x1: 310.239,
    y1: 61.4841,
    x2: 369.153,
    y2: 30.0885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_812_1630",
    x1: 335.572,
    y1: 37.357,
    x2: 365.243,
    y2: 37.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25054D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_812_1630",
    x1: 335.059,
    y1: 8.05979,
    x2: 373.209,
    y2: 80.7358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9F19AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3D065F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_812_1630",
    x1: 74.614,
    y1: 189.17,
    x2: 31.2893,
    y2: 189.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_812_1630",
    x1: 62.2826,
    y1: 191.955,
    x2: 42.6384,
    y2: 181.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_812_1630",
    x1: 51.8646,
    y1: 186.811,
    x2: 48.0072,
    y2: 180.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8764 193.968) rotate(-157.642) scale(8.43644 5.57152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_812_1630",
    x1: 117.895,
    y1: 98.5365,
    x2: 11.6079,
    y2: 190.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_812_1630",
    x1: 26.3322,
    y1: 194.932,
    x2: 76.2843,
    y2: 117.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A0C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5F27BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4299A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_812_1630",
    x1: 5.98306,
    y1: 201.59,
    x2: 58.2349,
    y2: 118.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9F79B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#A07BB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A782BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B28FC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#C3A5D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CCB2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#DAC8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EEE6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#EBDFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DDC7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#D4B9E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.6362 150.359) rotate(180) scale(8.88758 8.89536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5626 148.526) rotate(112.322) scale(5.35221 3.53026)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8A266A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.562 343.176) scale(21.9499 10.8938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F5C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_812_1630",
    x1: 150.167,
    y1: 339.216,
    x2: 121.035,
    y2: 339.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_812_1630",
    x1: 152.889,
    y1: 314.984,
    x2: 129.422,
    y2: 340.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_812_1630",
    x1: 148.932,
    y1: 327.126,
    x2: 122.261,
    y2: 327.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.505 314.192) rotate(180) scale(11.0877 11.0974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_812_1630",
    x1: 151.419,
    y1: 296.741,
    x2: 129.937,
    y2: 319.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.039 335.314) rotate(-90.4896) scale(7.52763 2.03884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BC3491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8B266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#601A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_812_1630",
    x1: 109.869,
    y1: 263.022,
    x2: 106.255,
    y2: 269.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_812_1630",
    x1: 113.191,
    y1: 263.571,
    x2: 108.253,
    y2: 271.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_812_1630",
    x1: 151.576,
    y1: 326.5,
    x2: 127.233,
    y2: 265.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_812_1630",
    x1: -106.96,
    y1: 299.937,
    x2: -137.931,
    y2: 295.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_812_1630",
    x1: 135.453,
    y1: 285.591,
    x2: 137.413,
    y2: 310.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.419 263.78) rotate(180) scale(15.0445 15.0577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_812_1630",
    x1: 132.87,
    y1: 313.322,
    x2: 112.031,
    y2: 307.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_812_1630",
    x1: 152.593,
    y1: 315.846,
    x2: 125.328,
    y2: 309.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_812_1630",
    x1: 128.548,
    y1: 293.642,
    x2: 137.57,
    y2: 310.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_812_1630",
    x1: 149.298,
    y1: 288.794,
    x2: 201.396,
    y2: 273.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_812_1630",
    x1: 148.976,
    y1: 269.541,
    x2: 168.35,
    y2: 302.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.029 286.418) scale(14.3054 14.3179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_812_1630",
    x1: 178.326,
    y1: 312.687,
    x2: 170.766,
    y2: 293.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_812_1630",
    x1: -75.5356,
    y1: 310.859,
    x2: -88.1891,
    y2: 308.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.978 293.477) rotate(180) scale(4.69598 4.70009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_812_1630",
    x1: 171.769,
    y1: 322.983,
    x2: 172.664,
    y2: 322.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#703ED1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#5A77DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C9DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_812_1630",
    x1: 173.934,
    y1: 317.073,
    x2: 170.525,
    y2: 317.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_812_1630",
    x1: 175.299,
    y1: 310.815,
    x2: 169.177,
    y2: 310.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_812_1630",
    x1: 168.568,
    y1: 302.442,
    x2: 173.495,
    y2: 307.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_812_1630",
    x1: 170.16,
    y1: 306.341,
    x2: 174.447,
    y2: 306.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_812_1630",
    x1: 172.221,
    y1: 307.664,
    x2: 172.221,
    y2: 305.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_812_1630",
    x1: 167.725,
    y1: 310.067,
    x2: 172.596,
    y2: 308.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_812_1630",
    x1: 123.348,
    y1: 276.383,
    x2: 77.8251,
    y2: 262.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_812_1630",
    x1: 150.054,
    y1: 281.901,
    x2: 117.432,
    y2: 274.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_812_1630",
    x1: 105.399,
    y1: 231.062,
    x2: 125.924,
    y2: 270.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_812_1630",
    x1: 136.523,
    y1: 283.337,
    x2: 113.64,
    y2: 276.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_812_1630",
    x1: 155.75,
    y1: 286.192,
    x2: 129.45,
    y2: 280.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_812_1630",
    x1: 129.661,
    y1: 259.619,
    x2: 139.145,
    y2: 277.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_812_1630",
    x1: 142.575,
    y1: 283.059,
    x2: 140.016,
    y2: 280.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65318A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_812_1630",
    x1: 157.576,
    y1: 286.793,
    x2: 152.387,
    y2: 295.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_812_1630",
    x1: 143.567,
    y1: 293.129,
    x2: 173.571,
    y2: 287.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_812_1630",
    x1: 176.334,
    y1: 299.814,
    x2: 160.767,
    y2: 296.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_812_1630",
    x1: 167.186,
    y1: 300.597,
    x2: 170.268,
    y2: 295.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_812_1630",
    x1: 167.542,
    y1: 297.359,
    x2: 170.457,
    y2: 299.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.16 296.828) rotate(180) scale(2.97412 2.97673)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.827 284.786) rotate(-149.768) scale(9.45093 1.06903)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BC3491"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8B266B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#601A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3D112F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#22091A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0F040B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_812_1630",
    x1: 140.871,
    y1: 332.34,
    x2: 116.528,
    y2: 270.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_812_1630",
    x1: -119.088,
    y1: 305.838,
    x2: -150.055,
    y2: 301.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.792 275.312) rotate(180) scale(15.0706 15.0838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_812_1630",
    x1: 117.252,
    y1: 273.58,
    x2: 120.596,
    y2: 279.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_812_1630",
    x1: 112.469,
    y1: 277.653,
    x2: 123.34,
    y2: 275.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.878 275.573) scale(2.06971 2.07152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_812_1630",
    x1: 129.079,
    y1: 312.922,
    x2: 132.422,
    y2: 318.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_812_1630",
    x1: 124.296,
    y1: 317.004,
    x2: 135.167,
    y2: 314.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.705 314.915) scale(2.06971 2.07152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_812_1630",
    x1: 164.464,
    y1: 299.979,
    x2: 169.335,
    y2: 298.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_812_1630",
    x1: 171.473,
    y1: 316.534,
    x2: 163.913,
    y2: 297.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_812_1630",
    x1: -83.3247,
    y1: 314.739,
    x2: -95.9782,
    y2: 312.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(169.116 297.324) rotate(180) scale(4.69598 4.70009)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_812_1630",
    x1: 140.914,
    y1: 293.625,
    x2: 193.012,
    y2: 278.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_812_1630",
    x1: 140.601,
    y1: 274.372,
    x2: 159.976,
    y2: 307.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A27CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#AB87CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#BB9AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.654 291.249) scale(14.3054 14.3179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_812_1630",
    x1: 162.525,
    y1: 298.9,
    x2: 164.405,
    y2: 302.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_812_1630",
    x1: 159.829,
    y1: 301.197,
    x2: 165.951,
    y2: 299.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.438 300.022) scale(1.1653 1.16632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_812_1630",
    x1: 166.812,
    y1: 309.196,
    x2: 168.692,
    y2: 312.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_812_1630",
    x1: 164.116,
    y1: 311.494,
    x2: 170.239,
    y2: 310.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.725 310.319) scale(1.16531 1.16632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_812_1630",
    x1: 132.575,
    y1: 281.344,
    x2: 134.455,
    y2: 284.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C1A1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#C7ABD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D9C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#F6F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9F5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E9DBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B294D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9B7CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#8D6EC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#8969C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#9371C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B086CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_812_1630",
    x1: 129.879,
    y1: 283.642,
    x2: 136.001,
    y2: 282.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F79C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A47FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B491D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CDAFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1B4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#DAC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBDEF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.488 282.467) scale(1.1653 1.16632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(428.19 220.987) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_812_1630",
    x1: 427.352,
    y1: 221.853,
    x2: 380.145,
    y2: 249.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_812_1630",
    x1: 427.256,
    y1: 221.896,
    x2: 384.808,
    y2: 246.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_812_1630",
    x1: 427.152,
    y1: 221.949,
    x2: 389.463,
    y2: 243.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_812_1630",
    x1: 427.056,
    y1: 221.992,
    x2: 394.126,
    y2: 241.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.405 359.774) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_812_1630",
    x1: 319.518,
    y1: 360.532,
    x2: 272.311,
    y2: 388.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_812_1630",
    x1: 319.422,
    y1: 360.584,
    x2: 276.975,
    y2: 385.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_812_1630",
    x1: 319.318,
    y1: 360.627,
    x2: 281.629,
    y2: 382.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_812_1630",
    x1: 319.222,
    y1: 360.671,
    x2: 286.292,
    y2: 379.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330.813 95.2189) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_812_1630",
    x1: 329.954,
    y1: 96.082,
    x2: 282.747,
    y2: 123.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_812_1630",
    x1: 329.858,
    y1: 96.1255,
    x2: 287.41,
    y2: 120.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_812_1630",
    x1: 329.754,
    y1: 96.1778,
    x2: 292.065,
    y2: 118.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_812_1630",
    x1: 329.658,
    y1: 96.2213,
    x2: 296.728,
    y2: 115.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.81 95.3147) rotate(180) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_812_1630",
    x1: 195.596,
    y1: 92.4612,
    x2: 168.255,
    y2: 100.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_812_1630",
    x1: 2843.39,
    y1: -9581.65,
    x2: 2843.39,
    y2: -9581.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_812_1630",
    x1: 169.829,
    y1: 88.6228,
    x2: 205.703,
    y2: 99.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_812_1630",
    x1: 167.994,
    y1: 96.2213,
    x2: 200.924,
    y2: 115.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.351 361.08) rotate(180) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_812_1630",
    x1: 192.679,
    y1: 359.418,
    x2: 175.149,
    y2: 364.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_812_1630",
    x1: 2843.39,
    y1: -9804.16,
    x2: 2843.39,
    y2: -9804.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_812_1630",
    x1: 176.443,
    y1: 357.651,
    x2: 197.019,
    y2: 363.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_812_1630",
    x1: 175.517,
    y1: 362.055,
    x2: 193.474,
    y2: 372.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3244 214.345) rotate(180) scale(21.9668 21.986)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FEE2A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#986E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#45108A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#3C0D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2C0A58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#1E073C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#130426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#0A0214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#040108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#000001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_812_1630",
    x1: 122.322,
    y1: 211.252,
    x2: 90.1837,
    y2: 220.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#113A38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0D2E2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_812_1630",
    x1: 2843.39,
    y1: -9725.24,
    x2: 2843.39,
    y2: -9725.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_812_1630",
    x1: 91.4673,
    y1: 207.222,
    x2: 129.671,
    y2: 218.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32AEA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#2EA29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_812_1630",
    x1: 89.5106,
    y1: 215.247,
    x2: 122.441,
    y2: 234.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2FA29D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0D2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.708 245.152) rotate(-59.5819) scale(8.70192 8.69822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.335 241.404) rotate(-59.5819) scale(7.61418 7.61094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(342.592 238.026) rotate(-59.5819) scale(6.52644 6.52366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(337.921 235.279) rotate(-59.5819) scale(5.4387 5.43638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(333.88 232.902) rotate(-59.5819) scale(4.35096 4.34911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(272.497 386.654) rotate(-59.5819) scale(8.70192 8.69822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(266.116 382.901) rotate(-59.5819) scale(7.61419 7.61094)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(260.381 379.528) rotate(-59.5819) scale(6.52644 6.52366)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.702 376.776) rotate(-59.5819) scale(5.43869 5.43638)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.669 374.404) rotate(-59.5819) scale(4.35097 4.34911)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.957 309.047) rotate(-119.429) scale(8.70203 8.6981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(211.394 305.409) rotate(-119.429) scale(7.61427 7.61084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.091 302.559) rotate(-119.429) scale(6.52652 6.52357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.912 299.465) rotate(-119.429) scale(5.43877 5.43631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.994 297.159) rotate(-119.429) scale(4.35101 4.34905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.294 242.028) rotate(-119.429) scale(8.70203 8.6981)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.731 238.391) rotate(-119.429) scale(7.61427 7.61084)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.368 235.837) rotate(-119.419) scale(6.52653 6.52358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.249 232.447) rotate(-119.429) scale(5.43877 5.43631)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.331 230.14) rotate(-119.429) scale(4.35101 4.34905)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(215.814 105.644) rotate(-59.252) scale(8.70188 8.69825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(221.068 109.264) rotate(-59.242) scale(7.61414 7.61097)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(226.783 112.672) rotate(-59.242) scale(6.52641 6.52369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(231.445 115.451) rotate(-59.242) scale(5.43867 5.43641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(235.465 117.847) rotate(-59.242) scale(4.35094 4.34913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(332.107 140.296) rotate(-120.758) scale(8.70188 8.69826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.757 144.082) rotate(-120.758) scale(7.61415 7.61098)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(320.034 147.494) rotate(-120.758) scale(6.52641 6.52369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(315.379 150.269) rotate(-120.758) scale(5.43868 5.43641)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_812_1630",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.352 152.67) rotate(-120.758) scale(4.35094 4.34913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#B27BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7B1CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#61169E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4A1179"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#360C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#25083C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#170526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C0314"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#050108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_812_1630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 493,
    height: 396,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.74055e961b87877088d1b1318748805b.svg";
export { ForwardRef as ReactComponent };